var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEpic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 56,
    viewBox: "0 0 94 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.3563 8.23919L50.0783 7.59478L47.3341 2.81689L44.5898 7.59478L46.3119 8.23919L47.3341 9.27945L48.3563 8.23919Z",
    fill: "url(#paint0_radial_578_447528)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9885 7.73294L49.0843 7.31867L47.3346 4.27148L45.585 7.31867L46.6808 7.73294L47.3346 8.39574L47.9885 7.73294Z",
    fill: "url(#paint1_linear_578_447528)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5898 7.59539L45.5844 7.31921L46.6803 7.73348L46.3119 8.23981L44.5898 7.59539Z",
    fill: "url(#paint2_radial_578_447528)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6809 7.73352L47.3347 8.39632V9.2801L46.3125 8.23985L46.6809 7.73352Z",
    fill: "url(#paint3_radial_578_447528)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9883 7.73348L48.3566 8.23981L50.0787 7.59539L49.0841 7.31921L47.9883 7.73348Z",
    fill: "url(#paint4_radial_578_447528)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3341 2.81689V4.2622L45.5752 7.3186L44.5898 7.59478C44.5898 7.59478 47.3617 2.94578 47.3341 2.81689Z",
    fill: "url(#paint5_radial_578_447528)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0837 7.3186L50.0782 7.59477L47.334 2.81689V4.27142L49.0837 7.3186Z",
    fill: "url(#paint6_radial_578_447528)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8045 7.475L48.5965 7.18044L47.3349 4.98022L46.0732 7.18044L46.8652 7.475L47.3349 7.95373L47.8045 7.475Z",
    fill: "url(#paint7_radial_578_447528)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.334 3.43367L49.5257 7.40144L50.0782 7.59477L47.334 2.81689V3.43367Z",
    fill: "url(#paint8_radial_578_447528)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M45.585 7.31863L46.073 7.18054L46.865 7.47511L46.6808 7.7329L45.585 7.31863Z",
    fill: "url(#paint9_radial_578_447528)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5957 7.18054L49.0837 7.31863L47.9879 7.7329L47.8037 7.47511L48.5957 7.18054Z",
    fill: "url(#paint10_radial_578_447528)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3345 7.95395V8.39581L46.6807 7.73301L46.8648 7.47522L47.3345 7.95395Z",
    fill: "url(#paint11_radial_578_447528)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3346 4.27148V4.98036L46.073 7.18058L45.585 7.31867L47.3346 4.27148Z",
    fill: "url(#paint12_radial_578_447528)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3338 2.81677C47.3615 2.8536 47.3983 4.18845 47.3983 4.18845L48.2455 5.82709L47.3338 4.2713L46.3301 6.02964L47.3154 4.17002L47.3338 2.81677Z",
    fill: "url(#paint13_radial_578_447528)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2457 5.85461L49.1666 7.29071L50.0783 7.59453L49.1482 7.3736L47.9971 7.73262L49.0929 7.31835L48.2457 5.85461Z",
    fill: "url(#paint14_radial_578_447528)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4414 5.8363L45.5113 7.28166L44.5996 7.58544L45.5297 7.3645L46.6808 7.72353L45.585 7.30926L46.4414 5.8363Z",
    fill: "url(#paint15_radial_578_447528)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6807 7.72351L47.2977 8.4692L47.3345 9.27931L47.3713 8.48759L47.9975 7.73273L47.3345 8.39553L46.6807 7.72351Z",
    fill: "url(#paint16_radial_578_447528)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8132 7.48416L48.6143 7.18959L47.3343 4.97095L46.0635 7.18959L46.8647 7.48416L47.3343 7.9721L47.8132 7.48416Z",
    fill: "url(#paint17_radial_578_447528)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6479 7.24533L48.1544 7.05204L47.3348 5.62512L46.5244 7.05204L47.0309 7.24533L47.3348 7.55837L47.6479 7.24533Z",
    fill: "url(#paint18_radial_578_447528)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0635 7.18985L46.5239 7.05176L47.0304 7.24505L46.8647 7.48441L46.0635 7.18985Z",
    fill: "url(#paint19_radial_578_447528)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3343 4.97095V5.62458L46.5239 7.0515L46.0635 7.18959L47.3343 4.97095Z",
    fill: "url(#paint20_radial_578_447528)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6475 7.24505L47.8132 7.48441L48.6144 7.18985L48.1539 7.05176L47.6475 7.24505Z",
    fill: "url(#paint21_radial_578_447528)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M47.334 7.55803V7.9723L47.8128 7.48436L47.6471 7.245L47.334 7.55803Z",
    fill: "url(#paint22_radial_578_447528)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M47.334 4.97095V5.62458L48.1536 7.0515L48.614 7.18959L47.334 4.97095Z",
    fill: "url(#paint23_radial_578_447528)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3343 4.92505C47.3435 4.94346 47.362 5.56947 47.362 5.56947L47.7671 6.34276L47.3343 5.60628L46.8555 6.43482L47.3159 5.56025L47.3343 4.92505Z",
    fill: "#EBFFFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7672 6.36145L48.2 7.03347L48.6328 7.18077L48.1908 7.07028L47.6475 7.24519L48.1632 7.0519L47.7672 6.36145Z",
    fill: "#EBFFFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9198 6.35205L46.4777 7.03328L46.0449 7.17137L46.487 7.06088L47.0303 7.23583L46.5146 7.0425L46.9198 6.35205Z",
    fill: "#EBFFFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0303 7.23596L47.3158 7.59499L47.3342 7.97244L47.3618 7.59499L47.6473 7.24513L47.3342 7.55817L47.0303 7.23596Z",
    fill: "#EBFFFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5703 6.2783L46.865 6.43482H47.7675L48.0898 6.2507L47.3347 4.92505L46.5703 6.2783Z",
    fill: "url(#paint24_radial_578_447528)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6054 13.0632L86.5279 14.4994L81.4078 21.3026L57.7962 23.1253L55.9176 15.1714L55.6045 13.8918L87.6054 13.0632Z",
    fill: "url(#paint25_radial_578_447528)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6054 13.0632L86.5279 14.4994L81.4078 21.3026L57.7962 23.1253L55.9176 15.1714L55.6045 13.8918L87.6054 13.0632Z",
    fill: "url(#paint26_radial_578_447528)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6054 13.0632L86.5279 14.4994L55.9176 15.1714L55.6045 13.8918L87.6054 13.0632Z",
    fill: "url(#paint27_radial_578_447528)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9723 15.0697L86.5918 14.4069L86.9141 13.9927L55.917 14.6831L55.9723 15.0697Z",
    fill: "url(#paint28_radial_578_447528)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9144 13.9927C86.9144 13.9927 76.4439 14.4254 65.6787 14.453C65.6879 14.453 73.7089 14.1584 86.9144 13.9927Z",
    fill: "url(#paint29_radial_578_447528)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5922 14.4072L86.3251 14.6834L56.1016 15.4475L55.9727 15.07L86.5922 14.4072Z",
    fill: "url(#paint30_radial_578_447528)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6786 12.9615L55.6777 13.7901L55.8895 14.1951L87.0064 13.385L86.592 14.011V14.4069L86.9143 13.9926L87.3747 13.3758H87.3931L87.6786 12.9615Z",
    fill: "url(#paint31_radial_578_447528)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5924 14.4072L86.0951 14.7294L81.0947 21.3209L81.4078 21.3025L86.5924 14.4072Z",
    fill: "url(#paint32_radial_578_447528)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7179 17.8874L83.167 19.9679L76.8958 25.1141L56.1758 24.3223L56.4336 17.7309L56.4705 16.7643L85.7179 17.8874Z",
    fill: "url(#paint33_radial_578_447528)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6993 17.8874L83.1485 19.9679L76.8772 25.1141L56.1572 24.3223L56.4151 17.7309L56.4519 16.7643L85.6993 17.8874Z",
    fill: "url(#paint34_radial_578_447528)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7169 17.8875L83.9303 19.3421L56.4326 17.731L56.4694 16.7644L85.7169 17.8875Z",
    fill: "url(#paint35_radial_578_447528)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4696 16.7644L56.4512 17.0222L85.0816 18.0808L84.0318 18.9094L83.912 19.3236L85.717 17.8875L56.4696 16.7644Z",
    fill: "url(#paint36_radial_578_447528)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7596 21.1552C84.7504 21.1552 84.7228 21.1552 84.7136 21.1552C84.7044 21.1552 84.6859 21.1552 84.6767 21.1644C84.6675 21.1736 84.6491 21.1736 84.6399 21.1828C84.6307 21.192 84.6215 21.2012 84.6215 21.2196C84.6123 21.2288 84.6123 21.2472 84.6123 21.2564C84.6123 21.2656 84.6123 21.2748 84.6215 21.284C84.6307 21.3024 84.6307 21.3208 84.6491 21.3301C84.6583 21.3393 84.6583 21.3393 84.6675 21.3485C84.686 21.3577 84.7044 21.3577 84.7228 21.3577C84.732 21.3577 84.7596 21.3577 84.7688 21.3577C84.778 21.3577 84.7964 21.3577 84.8056 21.3485C84.8148 21.3393 84.8332 21.3393 84.8425 21.3301C84.8517 21.3208 84.8609 21.3117 84.8609 21.2932C84.8701 21.284 84.8701 21.2656 84.8701 21.2564C84.8701 21.2472 84.8701 21.238 84.8609 21.2288C84.8517 21.2104 84.8517 21.192 84.8332 21.1828C84.824 21.1736 84.824 21.1736 84.8148 21.1644C84.7964 21.1644 84.778 21.1552 84.7596 21.1552Z",
    fill: "url(#paint37_radial_578_447528)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4326 17.7309L83.9303 19.342L84.4184 18.9553L56.4326 17.4456V17.7309Z",
    fill: "url(#paint38_radial_578_447528)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M59.877 17.7031C59.877 17.7031 75.6057 18.679 81.5731 18.8355C81.5823 18.8447 68.9109 18.0161 59.877 17.7031Z",
    fill: "url(#paint39_radial_578_447528)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9303 19.3418L83.3502 19.8112L56.4326 18.0437V17.7307L83.9303 19.3418Z",
    fill: "url(#paint40_radial_578_447528)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9311 19.3417L82.9734 19.7375L76.5088 25.1138H76.8956L83.9311 19.3417Z",
    fill: "url(#paint41_radial_578_447528)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4941 19.8479C65.4205 20.1701 65.3008 20.5936 65.1258 21.0723C65.089 21.1643 65.0613 21.2656 65.0153 21.3761C64.7943 21.956 64.4996 22.6189 64.1036 23.3277C63.8918 23.7052 63.6616 24.0918 63.3853 24.4877C63.2104 24.7547 63.017 25.0217 62.8052 25.2794C62.4184 25.7857 61.9856 26.3012 61.4883 26.8076L71.572 28.6212L72.8889 28.8605L73.3493 28.9434L74.2794 28.299L75.8633 27.1942L80.2928 24.101L82.107 22.8398L65.4941 19.8479Z",
    fill: "#E8DDD4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1251 22.8394L80.311 24.1006L65.1348 21.0626C65.3005 20.5839 65.4202 20.1605 65.5031 19.8383L82.1251 22.8394Z",
    fill: "url(#paint42_radial_578_447528)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4937 19.8475L82.125 22.8395L81.6829 23.1525L80.2924 24.1007L80.4029 23.8245L81.3975 23.0236L65.4385 20.1237L65.4937 19.8475Z",
    fill: "url(#paint43_radial_578_447528)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4311 23.8245L65.2273 20.7773L65.126 21.072L80.293 24.1007L80.4311 23.8245Z",
    fill: "url(#paint44_radial_578_447528)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3457 21.1921C67.3457 21.1921 69.8597 21.8182 79.7224 23.733C79.7316 23.733 76.0665 22.8216 67.3457 21.1921Z",
    fill: "url(#paint45_radial_578_447528)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2934 24.1013L79.6488 24.3038L64.9883 21.3763L65.1264 21.0725L80.2934 24.1013Z",
    fill: "url(#paint46_radial_578_447528)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3681 28.9523L80.2931 24.1007L79.6485 24.3033L73.0918 28.9246L73.3681 28.9523Z",
    fill: "url(#paint47_radial_578_447528)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6488 24.3037L72.9079 28.8698L72.6593 29.0355L71.5911 28.6305L62.8242 25.2887C63.0268 25.0217 63.2202 24.7548 63.4044 24.497C63.6714 24.1012 63.9109 23.7145 64.1227 23.3371C64.5187 22.6282 64.8133 21.9654 65.0343 21.3854L79.6488 24.3037Z",
    fill: "url(#paint48_radial_578_447528)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9508 27.5809L75.0354 28.5936L69.2798 31.6407L59.5645 28.4463C60.2551 27.9123 60.8721 27.36 61.4062 26.8168C62.1706 26.0343 62.7968 25.2518 63.3033 24.4877C63.5703 24.0919 63.8097 23.7052 64.0215 23.3278L75.7905 27.1943L76.9508 27.5809Z",
    fill: "url(#paint49_radial_578_447528)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9508 27.5809L75.0354 28.5935L74.2066 28.2989L63.3125 24.4784C63.5796 24.0826 63.819 23.6959 64.0308 23.3185L75.7997 27.185L76.9508 27.5809Z",
    fill: "url(#paint50_radial_578_447528)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9199 23.5118L76.3795 27.5809L75.1548 28.2621L75.035 28.6027L76.9505 27.5809L64.0212 23.3369L63.9199 23.5118Z",
    fill: "url(#paint51_radial_578_447528)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0349 28.6028L75.1546 28.2622L63.4501 24.276L63.3027 24.497L75.0349 28.6028Z",
    fill: "url(#paint52_radial_578_447528)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4512 24.276C63.4512 24.276 68.4332 26.0344 75.1464 28.253C75.1557 28.2622 69.8421 26.2277 63.4512 24.276Z",
    fill: "url(#paint53_radial_578_447528)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0358 28.6029L74.4649 28.7134L63.1104 24.7548L63.3037 24.4971L75.0358 28.6029Z",
    fill: "url(#paint54_radial_578_447528)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0353 28.6033L74.4643 28.7138L69.2797 31.4387L69.2705 31.6505L75.0353 28.6033Z",
    fill: "url(#paint55_radial_578_447528)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06445 13.0634L8.15111 14.4995L13.2713 21.3027L36.8736 23.1255L38.7614 15.1715L39.0653 13.8919L7.06445 13.0634Z",
    fill: "url(#paint56_radial_578_447528)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06445 13.0634L8.15111 14.4995L13.2713 21.3027L36.8736 23.1255L38.7614 15.1715L39.0653 13.8919L7.06445 13.0634Z",
    fill: "url(#paint57_radial_578_447528)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06445 13.0634L8.15111 14.4995L38.7614 15.1715L39.0653 13.8919L7.06445 13.0634Z",
    fill: "url(#paint58_radial_578_447528)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6973 15.0699L8.08696 14.4071L7.76465 13.9928L38.7525 14.6832L38.6973 15.0699Z",
    fill: "url(#paint59_radial_578_447528)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76465 13.9928C7.76465 13.9928 18.2351 14.4255 29.0003 14.4531C28.9911 14.4531 20.961 14.1585 7.76465 13.9928Z",
    fill: "url(#paint60_radial_578_447528)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08691 14.4073L8.35396 14.6835L38.5775 15.4476L38.6972 15.0702L8.08691 14.4073Z",
    fill: "url(#paint61_radial_578_447528)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.9618L39.0009 13.7903L38.7798 14.1954L7.66303 13.3853L8.07743 14.0113L8.08665 14.4071L7.76434 13.9929L7.3039 13.3761H7.28548L7 12.9618Z",
    fill: "url(#paint62_radial_578_447528)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08691 14.4073L8.58418 14.7296L13.5846 21.321L13.2715 21.3026L8.08691 14.4073Z",
    fill: "url(#paint63_radial_578_447528)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96191 17.8875L11.5128 19.9681L17.784 25.1142L38.4948 24.3225L38.2462 17.731L38.2001 16.7644L8.96191 17.8875Z",
    fill: "url(#paint64_radial_578_447528)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98047 17.8876L11.5313 19.9682L17.8026 25.1143L38.5133 24.3226L38.2647 17.7312L38.2279 16.7645L8.98047 17.8876Z",
    fill: "url(#paint65_radial_578_447528)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96191 17.8875L10.7484 19.3421L38.2462 17.731L38.2001 16.7644L8.96191 17.8875Z",
    fill: "url(#paint66_radial_578_447528)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2001 16.7644L38.2277 17.0222L9.58812 18.0808L10.6471 18.9094L10.7668 19.3236L8.96191 17.8875L38.2001 16.7644Z",
    fill: "url(#paint67_radial_578_447528)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92004 21.3857C9.92924 21.3857 9.95686 21.3857 9.96607 21.3857C9.97527 21.3857 9.9937 21.3857 10.0029 21.3765C10.0121 21.3673 10.0305 21.3673 10.0397 21.3581C10.0489 21.3489 10.0581 21.3397 10.0581 21.3213C10.0673 21.3121 10.0673 21.2937 10.0673 21.2845C10.0673 21.2753 10.0673 21.2661 10.0581 21.2569C10.0489 21.2384 10.0489 21.22 10.0305 21.2108C10.0213 21.2016 10.0213 21.2016 10.0121 21.1924C9.99368 21.1832 9.97529 21.1832 9.95687 21.1832C9.94767 21.1832 9.92005 21.1832 9.91084 21.1832C9.90164 21.1832 9.88321 21.1832 9.87401 21.1924C9.8648 21.2016 9.8464 21.2016 9.83719 21.2108C9.82799 21.22 9.81879 21.2292 9.81879 21.2476C9.80958 21.2568 9.80957 21.2753 9.80957 21.2845C9.80957 21.2937 9.80958 21.3029 9.81879 21.3121C9.82799 21.3305 9.82797 21.3489 9.84639 21.3581C9.85559 21.3673 9.85561 21.3673 9.86482 21.3765C9.87402 21.3765 9.90163 21.3857 9.92004 21.3857Z",
    fill: "url(#paint68_radial_578_447528)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2465 17.7311L10.7488 19.3421L10.2607 18.9554L38.2465 17.4457V17.7311Z",
    fill: "url(#paint69_radial_578_447528)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8016 17.7032C34.8016 17.7032 19.0728 18.6791 13.1055 18.8356C13.0963 18.8448 25.7585 18.0163 34.8016 17.7032Z",
    fill: "url(#paint70_radial_578_447528)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M10.748 19.342L11.3282 19.8115L38.2458 18.0439V17.731L10.748 19.342Z",
    fill: "url(#paint71_radial_578_447528)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M10.748 19.3418L11.7058 19.7376L18.1704 25.1139H17.7836L10.748 19.3418Z",
    fill: "url(#paint72_radial_578_447528)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5527 22.8401L14.3669 24.1013L18.7963 27.1945L20.3803 28.2992L21.3104 28.9436L21.7708 28.8608L23.0877 28.6214L33.1714 26.8078C32.6741 26.3015 32.2321 25.786 31.8545 25.2797C31.652 25.0127 31.4586 24.7457 31.2744 24.4879C31.0073 24.0921 30.7679 23.7054 30.5561 23.328C30.1601 22.6191 29.8654 21.9563 29.6444 21.3763C29.6076 21.275 29.5707 21.1738 29.5339 21.0725C29.3681 20.5938 29.2484 20.1704 29.1655 19.8481L12.5527 22.8401Z",
    fill: "#E8DDD4"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5527 22.8398L14.3669 24.101L29.5431 21.063C29.3774 20.5843 29.2576 20.1608 29.1748 19.8386L12.5527 22.8398Z",
    fill: "url(#paint73_radial_578_447528)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1748 19.8481L12.5527 22.8401L12.9855 23.1531L14.3853 24.1013L14.2748 23.8251L13.271 23.0242L29.2392 20.1243L29.1748 19.8481Z",
    fill: "url(#paint74_radial_578_447528)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2471 23.8246L29.4417 20.7775L29.543 21.0721L14.3852 24.1008L14.2471 23.8246Z",
    fill: "url(#paint75_radial_578_447528)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M27.324 21.1924C27.324 21.1924 24.81 21.8184 14.9473 23.7332C14.9473 23.7332 18.6124 22.8218 27.324 21.1924Z",
    fill: "url(#paint76_radial_578_447528)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3857 24.1015L15.0304 24.3041L29.6909 21.3765L29.5436 21.0728L14.3857 24.1015Z",
    fill: "url(#paint77_radial_578_447528)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3108 28.9524L14.3857 24.1008L15.0304 24.3034L21.5871 28.9247L21.3108 28.9524Z",
    fill: "url(#paint78_radial_578_447528)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0303 24.3038L21.7712 28.87L22.0198 29.0357L23.088 28.6306L31.8549 25.2888C31.6523 25.0218 31.4589 24.7549 31.2747 24.4971C31.0077 24.1013 30.7683 23.7146 30.5565 23.3372C30.1605 22.6283 29.8658 21.9655 29.6448 21.3855L15.0303 24.3038Z",
    fill: "url(#paint79_radial_578_447528)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7285 27.5809L19.644 28.5936L25.3995 31.6407L35.1149 28.4463C34.4242 27.9123 33.8072 27.36 33.2731 26.8168C32.5088 26.0343 31.8826 25.2518 31.3761 24.4877C31.109 24.0919 30.8696 23.7052 30.6578 23.3278L18.8888 27.1943L17.7285 27.5809Z",
    fill: "url(#paint80_radial_578_447528)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7285 27.581L19.644 28.5936L20.4728 28.299L31.3669 24.4786C31.0998 24.0827 30.8604 23.696 30.6486 23.3186L18.8796 27.1851L17.7285 27.581Z",
    fill: "url(#paint81_radial_578_447528)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7591 23.5118L18.2995 27.5809L19.5242 28.2621L19.644 28.6027L17.7285 27.5809L30.6578 23.3369L30.7591 23.5118Z",
    fill: "url(#paint82_radial_578_447528)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6441 28.6029L19.5244 28.2623L31.2197 24.2761L31.367 24.4971L19.6441 28.6029Z",
    fill: "url(#paint83_radial_578_447528)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2197 24.2761C31.2197 24.2761 26.2377 26.0345 19.5244 28.2531C19.5244 28.2623 24.8287 26.2278 31.2197 24.2761Z",
    fill: "url(#paint84_radial_578_447528)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6436 28.603L20.2145 28.7135L31.5691 24.7549L31.3665 24.4972L19.6436 28.603Z",
    fill: "url(#paint85_radial_578_447528)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6436 28.6034L20.2145 28.7139L25.3991 31.4389V31.6506L19.6436 28.6034Z",
    fill: "url(#paint86_radial_578_447528)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6964 14.6102C77.6964 22.8771 61.148 26.0164 61.148 26.0164C60.6784 25.51 60.6415 24.2028 60.7981 22.7666C61.0467 20.3455 61.7834 17.5469 61.7834 17.5469C61.7834 17.5469 66.2681 17.5469 68.1191 15.6781C68.598 15.1901 68.9111 14.5734 68.9111 13.8093C68.9111 10.1269 64.8592 9.1142 64.7211 9.08658C64.7211 9.08658 64.7211 9.08658 64.7303 9.08658C65.117 9.02214 77.6964 6.48129 77.6964 14.6102Z",
    fill: "url(#paint87_radial_578_447528)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6968 14.6101C77.6968 22.8771 61.1485 26.0163 61.1485 26.0163C60.5038 25.243 60.7156 22.7758 61.0011 21.5791C69.1418 21.8276 74.8697 17.2707 75.3946 13.1188C76.1129 7.52157 65.1083 9.04054 64.7215 9.09577C65.1175 9.02212 77.6968 6.48127 77.6968 14.6101Z",
    fill: "url(#paint88_radial_578_447528)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M68.285 15.6963C68.285 15.6963 68.2205 15.6963 68.11 15.6963C68.5889 15.2084 68.902 14.5916 68.902 13.8275C68.902 10.1451 64.85 9.13248 64.7119 9.10486C64.7211 9.10486 64.7211 9.10486 64.7211 9.10486C64.7211 9.10486 74.3352 10.4858 68.285 15.6963Z",
    fill: "url(#paint89_radial_578_447528)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6968 14.6101C77.6968 22.8771 61.1485 26.0163 61.1485 26.0163C60.5038 25.243 60.7156 22.7758 61.0011 21.5791C69.1418 21.8276 74.8697 17.2707 75.3946 13.1188C76.1129 7.52157 65.1083 9.04054 64.7215 9.09577C65.1175 9.02212 77.6968 6.48127 77.6968 14.6101Z",
    fill: "url(#paint90_radial_578_447528)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3851 13.1184C75.3851 13.1184 74.7313 19.314 64.1318 21.3946C64.1318 21.4038 74.3261 20.879 75.3851 13.1184Z",
    fill: "url(#paint91_radial_578_447528)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1396 9.51904C66.1396 9.51904 73.516 11.3694 68.1104 15.687C68.1011 15.6962 74.8973 11.5628 66.1396 9.51904Z",
    fill: "url(#paint92_radial_578_447528)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0607 19.7654L71.7752 18.7159L70.9648 18.587L71.6003 19.6825L72.0607 19.7654Z",
    fill: "url(#paint93_radial_578_447528)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0607 19.7652L71.8489 18.3291L70.9648 18.5868L71.6463 18.6697L72.0607 19.7652Z",
    fill: "url(#paint94_radial_578_447528)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5047 13.9196C70.5047 13.9196 69.7588 15.4202 66.4805 17.0957C66.4805 17.0957 70.3114 16.0646 71.8124 17.8413C71.8124 17.8413 74.1515 16.5341 74.8974 13.8184C74.9066 13.8276 73.4055 14.8586 70.5047 13.9196Z",
    fill: "url(#paint95_radial_578_447528)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6602 14.6102C16.6602 22.8771 33.2085 26.0164 33.2085 26.0164C33.6782 25.51 33.715 24.2028 33.5584 22.7666C33.3098 20.3455 32.5731 17.5469 32.5731 17.5469C32.5731 17.5469 28.0884 17.5469 26.2374 15.6781C25.7585 15.1901 25.4454 14.5734 25.4454 13.8093C25.4454 10.1269 29.4973 9.1142 29.6355 9.08658C29.6355 9.08658 29.6355 9.08658 29.6263 9.08658C29.2303 9.02214 16.6602 6.48129 16.6602 14.6102Z",
    fill: "url(#paint96_radial_578_447528)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6602 14.6099C16.6602 22.8768 33.2085 26.0161 33.2085 26.0161C33.8531 25.2428 33.6321 22.7756 33.3558 21.5788C25.2152 21.8274 19.4873 17.2704 18.9624 13.1185C18.2441 7.52133 29.2487 9.04029 29.6355 9.09553C29.2303 9.02188 16.6602 6.48103 16.6602 14.6099Z",
    fill: "url(#paint97_radial_578_447528)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0623 15.6963C26.0623 15.6963 26.1268 15.6963 26.2373 15.6963C25.7584 15.2084 25.4453 14.5916 25.4453 13.8275C25.4453 10.1451 29.4972 9.13248 29.6354 9.10486C29.6262 9.10486 29.6261 9.10486 29.6261 9.10486C29.6261 9.10486 20.0121 10.4858 26.0623 15.6963Z",
    fill: "url(#paint98_radial_578_447528)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6602 14.6099C16.6602 22.8768 33.2085 26.0161 33.2085 26.0161C33.8531 25.2428 33.6321 22.7756 33.3558 21.5788C25.2152 21.8274 19.4873 17.2704 18.9624 13.1185C18.2441 7.52133 29.2487 9.04029 29.6355 9.09553C29.2303 9.02188 16.6602 6.48103 16.6602 14.6099Z",
    fill: "url(#paint99_radial_578_447528)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9531 13.1184C18.9531 13.1184 19.607 19.314 30.2064 21.3946C30.2156 21.4038 20.0214 20.879 18.9531 13.1184Z",
    fill: "url(#paint100_radial_578_447528)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2087 9.51904C28.2087 9.51904 20.8324 11.3694 26.238 15.687C26.238 15.6962 19.4511 11.5628 28.2087 9.51904Z",
    fill: "url(#paint101_radial_578_447528)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2871 19.7654L22.5634 18.7159L23.3738 18.587L22.7476 19.6825L22.2871 19.7654Z",
    fill: "url(#paint102_radial_578_447528)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2871 19.7652L22.4989 18.3291L23.3738 18.5868L22.7015 18.6697L22.2871 19.7652Z",
    fill: "url(#paint103_radial_578_447528)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M23.834 13.9196C23.834 13.9196 24.58 15.4202 27.8583 17.0957C27.8583 17.0957 24.0274 16.0646 22.5264 17.8413C22.5264 17.8413 20.1873 16.5341 19.4414 13.8184C19.4506 13.8276 20.9425 14.8586 23.834 13.9196Z",
    fill: "url(#paint104_radial_578_447528)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2852 12.9436C60.9353 13.8366 57.4728 14.4165 57.4728 14.4165C54.8943 14.2416 56.3124 12.0046 56.3124 12.0046C56.3124 12.0046 60.3275 12.695 60.5854 10.7065C60.6959 9.85956 60.3091 9.40847 56.2204 7.4384C53.4301 6.09433 53.6603 3.12081 54.0931 1.37168C54.2773 0.625996 54.4983 0.101239 54.5259 0.0183849V0.00921495C54.5259 8.99006e-06 54.5259 0 54.5259 0C54.176 2.15419 56.4782 4.11504 56.4782 4.11504C56.2111 3.48903 56.6532 2.23703 56.6532 2.23703C56.6532 3.03795 57.7214 3.94016 60.1157 6.08515C61.2668 7.11622 61.6536 8.52473 61.718 9.81356C61.8101 11.2129 61.4786 12.4741 61.2852 12.9436Z",
    fill: "url(#paint105_radial_578_447528)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2852 12.9437C60.9353 13.8367 57.4728 14.4167 57.4728 14.4167C57.1504 14.3983 56.8926 14.343 56.69 14.2694C55.2258 13.7262 56.3124 12.0047 56.3124 12.0047C56.3124 12.0047 60.3275 12.6951 60.5854 10.7067C60.6959 9.85971 60.3091 9.40862 56.2204 7.43855C53.4301 6.09447 53.6603 3.12096 54.0931 1.37183C53.8997 2.49495 54.0102 4.12443 55.631 5.53294C57.8779 7.4754 60.6682 8.34072 61.7273 9.82288C61.8101 11.213 61.4786 12.4742 61.2852 12.9437Z",
    fill: "url(#paint106_radial_578_447528)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2852 12.9437C60.9353 13.8367 57.4728 14.4167 57.4728 14.4167C57.1504 14.3983 56.8926 14.343 56.69 14.2694C55.2258 13.7262 56.3124 12.0047 56.3124 12.0047C56.3124 12.0047 60.3275 12.6951 60.5854 10.7067C60.6959 9.85971 60.3091 9.40862 56.2204 7.43855C53.4301 6.09447 53.6603 3.12096 54.0931 1.37183C53.8997 2.49495 54.0102 4.12443 55.631 5.53294C57.8779 7.4754 60.6682 8.34072 61.7273 9.82288C61.8101 11.213 61.4786 12.4742 61.2852 12.9437Z",
    fill: "url(#paint107_radial_578_447528)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2852 12.9437C60.9353 13.8367 57.4728 14.4167 57.4728 14.4167C57.1504 14.3983 56.8926 14.343 56.69 14.2694C55.2258 13.7262 56.3124 12.0047 56.3124 12.0047C56.3124 12.0047 60.3275 12.6951 60.5854 10.7067C60.6959 9.85971 60.3091 9.40862 56.2204 7.43855C53.4301 6.09447 53.6603 3.12096 54.0931 1.37183C53.8997 2.49495 54.0102 4.12443 55.631 5.53294C57.8779 7.4754 60.6682 8.34072 61.7273 9.82288C61.8101 11.213 61.4786 12.4742 61.2852 12.9437Z",
    fill: "url(#paint108_radial_578_447528)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1898 12.9254C59.3702 13.6435 57.7126 14.1682 56.7088 14.251C55.2446 13.7079 56.3313 11.9864 56.3313 11.9864C56.3313 11.9864 60.3463 12.6768 60.6042 10.6884C60.6042 10.6884 60.7055 11.8943 60.1898 12.9254Z",
    fill: "url(#paint109_radial_578_447528)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7435 5.00842C58.7435 5.00842 61.6259 6.95088 61.5983 9.2892C61.5983 9.2892 61.2392 8.92097 60.7419 8.65399C60.3183 7.84387 59.7657 7.07977 59.1672 6.62868C58.8909 6.15918 58.7343 5.40428 58.7435 5.00842Z",
    fill: "url(#paint110_radial_578_447528)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5634 1.69421C54.5634 1.69421 55.1068 3.43414 56.4052 4.31791L56.7091 6.05783C56.7275 6.06704 53.882 4.65853 54.5634 1.69421Z",
    fill: "url(#paint111_radial_578_447528)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5946 3.158C55.5946 3.158 55.5486 5.21092 56.4142 6.14072L55.9538 5.84616C55.9538 5.84616 55.5854 4.87033 55.4473 2.99231L55.5946 3.158Z",
    fill: "url(#paint112_radial_578_447528)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5443 0.00915527C54.5443 0.00915527 53.1998 2.89979 55.7415 5.44984C55.9809 5.68919 55.9441 5.84572 55.9441 5.84572C55.9441 5.84572 52.8867 3.76519 54.5443 0.00915527Z",
    fill: "url(#paint113_radial_578_447528)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2404 2.65139C54.2404 2.65139 54.1576 1.49143 54.4062 0.847011C54.4062 0.847011 54.572 2.08065 55.4376 3.00124C55.4376 3.00124 54.2681 1.32572 54.5351 0.0184753C54.5443 0.00926934 53.9365 1.49144 54.2404 2.65139Z",
    fill: "url(#paint114_radial_578_447528)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6806 2.2373C56.6806 2.2373 56.1005 3.91279 57.445 5.27527C58.7342 6.58252 60.3089 8.12914 60.5576 8.6999C60.8062 9.27067 60.6497 10.6147 60.6497 10.6147C60.6497 10.6147 60.8062 9.17861 60.2813 8.51579C59.7564 7.85296 58.1633 6.24191 57.3253 5.37655C56.2939 4.32707 56.2755 3.42487 56.6806 2.2373Z",
    fill: "url(#paint115_radial_578_447528)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1898 12.9254C59.3702 13.6435 57.7126 14.1682 56.7088 14.251C55.2446 13.7079 56.3313 11.9864 56.3313 11.9864C56.3313 11.9864 60.3463 12.6768 60.6042 10.6884C60.6042 10.6884 60.7055 11.8943 60.1898 12.9254Z",
    fill: "url(#paint116_radial_578_447528)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5947 3.15796L55.7329 3.28683C55.7329 3.28683 55.5855 4.87949 56.442 6.03024C56.6445 6.30641 59.4717 7.97269 59.6466 8.05555C59.8216 8.1384 60.282 8.52506 60.282 8.52506C60.282 8.52506 56.7366 6.51812 56.4051 6.14068C56.0736 5.76324 55.6684 4.99915 55.5947 3.15796Z",
    fill: "url(#paint117_radial_578_447528)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6992 14.26C56.6992 14.26 56.8926 14.3336 56.9571 14.3336C56.9571 14.3336 58.1819 14.4257 60.2999 13.008C60.4565 12.787 60.788 11.6915 60.788 10.4763L60.6406 10.6328C60.6406 10.6328 60.6775 12.0229 60.1802 12.9343C58.495 14.1311 56.9386 14.2047 56.6992 14.26Z",
    fill: "url(#paint118_radial_578_447528)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2021 12.3274C56.2021 12.3274 60.208 12.9166 60.604 10.9097C60.604 10.9097 60.1159 12.668 56.3311 11.996L56.2021 12.3274Z",
    fill: "url(#paint119_radial_578_447528)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3792 1.24329C54.3792 1.24329 54.499 1.84168 54.72 2.12707C54.72 2.12707 54.6003 3.49872 54.9134 4.20758C54.9226 4.20758 54.0846 2.97401 54.3792 1.24329Z",
    fill: "url(#paint120_radial_578_447528)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7651 1.8689C54.7651 1.8689 54.4612 3.61802 55.0874 4.80559L55.29 5.04495C55.29 5.04495 54.6362 3.73773 54.9033 2.17272L54.7651 1.8689Z",
    fill: "url(#paint121_radial_578_447528)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3949 4.27174L55.7227 3.51683V3.2959C55.7227 3.2959 56.1463 3.90349 56.4962 4.12444C56.4962 4.12444 56.7817 4.81491 57.0303 5.07268C57.3342 5.39488 60.1245 8.25794 60.2718 8.52491L59.8114 8.27633C59.8114 8.27633 59.6825 8.00017 59.4246 7.7424C57.6934 6.01168 56.3581 4.71363 56.3949 4.27174Z",
    fill: "url(#paint122_radial_578_447528)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6807 2.2373C56.6807 2.2373 56.3124 3.99563 57.3346 4.98988C58.366 5.99333 60.4932 8.06468 60.5945 8.68148C60.6958 9.29827 60.7879 10.4674 60.7879 10.4674L60.6406 10.6239C60.6406 10.6239 60.8247 9.47321 60.5485 8.70912C60.2722 7.93582 58.2002 6.14062 57.5832 5.45018C56.9754 4.76893 56.2755 3.78391 56.6807 2.2373Z",
    fill: "url(#paint123_radial_578_447528)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3467 8.28591C60.3467 8.28591 61.5623 9.16046 61.6083 9.46425C61.6083 9.46425 61.3965 7.57706 60.1533 6.08569C60.1533 6.08569 61.6267 7.20882 61.7557 9.81411C61.7557 9.81411 61.065 9.07763 60.5585 8.70939L60.3467 8.28591Z",
    fill: "url(#paint124_radial_578_447528)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7803 7.65967C58.7803 7.65967 60.4563 8.2765 60.6497 9.81389C60.6497 9.81389 60.6957 8.94853 60.0879 8.2857C59.5907 7.73334 58.7803 7.65967 58.7803 7.65967Z",
    fill: "url(#paint125_radial_578_447528)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0514 12.9436C33.4013 13.8366 36.8638 14.4165 36.8638 14.4165C39.4423 14.2416 38.0241 12.0046 38.0241 12.0046C38.0241 12.0046 34.0091 12.695 33.7512 10.7065C33.6407 9.85956 34.0275 9.40847 38.1162 7.4384C40.9065 6.09433 40.6763 3.12081 40.2435 1.37168C40.0593 0.625996 39.8383 0.101239 39.8107 0.0183849V0.00921495C39.8107 8.99006e-06 39.8107 0 39.8107 0C40.1606 2.15419 37.8584 4.11504 37.8584 4.11504C38.1254 3.48903 37.6834 2.23703 37.6834 2.23703C37.6834 3.03795 36.6152 3.94016 34.2209 6.08515C33.0698 7.11622 32.683 8.52473 32.6185 9.81356C32.5356 11.2129 32.8672 12.4741 33.0514 12.9436Z",
    fill: "url(#paint126_radial_578_447528)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0512 12.9437C33.4011 13.8367 36.8636 14.4167 36.8636 14.4167C37.186 14.3983 37.4438 14.343 37.6464 14.2694C39.1106 13.7262 38.024 12.0047 38.024 12.0047C38.024 12.0047 34.0089 12.6951 33.751 10.7067C33.6405 9.85971 34.0273 9.40862 38.1161 7.43855C40.9063 6.09447 40.6761 3.12096 40.2433 1.37183C40.4367 2.49495 40.3262 4.12443 38.7054 5.53294C36.4585 7.4754 33.6682 8.34072 32.6091 9.82288C32.5355 11.213 32.867 12.4742 33.0512 12.9437Z",
    fill: "url(#paint127_radial_578_447528)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0512 12.9437C33.4011 13.8367 36.8636 14.4167 36.8636 14.4167C37.186 14.3983 37.4438 14.343 37.6464 14.2694C39.1106 13.7262 38.024 12.0047 38.024 12.0047C38.024 12.0047 34.0089 12.6951 33.751 10.7067C33.6405 9.85971 34.0273 9.40862 38.1161 7.43855C40.9063 6.09447 40.6761 3.12096 40.2433 1.37183C40.4367 2.49495 40.3262 4.12443 38.7054 5.53294C36.4585 7.4754 33.6682 8.34072 32.6091 9.82288C32.5355 11.213 32.867 12.4742 33.0512 12.9437Z",
    fill: "url(#paint128_radial_578_447528)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0512 12.9437C33.4011 13.8367 36.8636 14.4167 36.8636 14.4167C37.186 14.3983 37.4438 14.343 37.6464 14.2694C39.1106 13.7262 38.024 12.0047 38.024 12.0047C38.024 12.0047 34.0089 12.6951 33.751 10.7067C33.6405 9.85971 34.0273 9.40862 38.1161 7.43855C40.9063 6.09447 40.6761 3.12096 40.2433 1.37183C40.4367 2.49495 40.3262 4.12443 38.7054 5.53294C36.4585 7.4754 33.6682 8.34072 32.6091 9.82288C32.5355 11.213 32.867 12.4742 33.0512 12.9437Z",
    fill: "url(#paint129_radial_578_447528)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1559 12.9253C34.9754 13.6433 36.633 14.1681 37.6368 14.2509C39.101 13.7078 38.0144 11.9862 38.0144 11.9862C38.0144 11.9862 33.9993 12.6767 33.7415 10.6882C33.7415 10.6882 33.6402 11.8942 34.1559 12.9253Z",
    fill: "url(#paint130_radial_578_447528)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5932 5.0083C35.5932 5.0083 32.7109 6.95076 32.7385 9.28907C32.7385 9.28907 33.0976 8.92084 33.5949 8.65387C34.0185 7.84374 34.571 7.07965 35.1696 6.62856C35.4459 6.15905 35.6024 5.40416 35.5932 5.0083Z",
    fill: "url(#paint131_radial_578_447528)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7824 1.69434C39.7824 1.69434 39.2391 3.43426 37.9406 4.31803L37.6367 6.05795C37.6275 6.06716 40.4547 4.65866 39.7824 1.69434Z",
    fill: "url(#paint132_radial_578_447528)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7512 3.158C38.7512 3.158 38.7973 5.21092 37.9316 6.14072L38.3921 5.84616C38.3921 5.84616 38.7604 4.87033 38.8986 2.99231L38.7512 3.158Z",
    fill: "url(#paint133_radial_578_447528)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8012 0.00891113C39.8012 0.00891113 41.1457 2.89955 38.604 5.4496C38.3646 5.68895 38.4015 5.84548 38.4015 5.84548C38.4015 5.84548 41.4588 3.76494 39.8012 0.00891113Z",
    fill: "url(#paint134_radial_578_447528)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0966 2.65126C40.0966 2.65126 40.1794 1.49131 39.9308 0.846889C39.9308 0.846889 39.765 2.08052 38.8994 3.00112C38.8994 3.00112 40.0689 1.3256 39.8019 0.0183532C39.8019 0.00914727 40.4097 1.49131 40.0966 2.65126Z",
    fill: "url(#paint135_radial_578_447528)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6651 2.23706C37.6651 2.23706 38.2453 3.91255 36.9008 5.27503C35.6115 6.58227 34.0368 8.12889 33.7882 8.69966C33.5395 9.27043 33.6961 10.6145 33.6961 10.6145C33.6961 10.6145 33.5395 9.17837 34.0645 8.51554C34.5894 7.85272 36.1825 6.24166 37.0205 5.3763C38.0427 4.32682 38.0703 3.42463 37.6651 2.23706Z",
    fill: "url(#paint136_radial_578_447528)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1559 12.9253C34.9754 13.6433 36.633 14.1681 37.6368 14.2509C39.101 13.7078 38.0144 11.9862 38.0144 11.9862C38.0144 11.9862 33.9993 12.6767 33.7415 10.6882C33.7415 10.6882 33.6402 11.8942 34.1559 12.9253Z",
    fill: "url(#paint137_radial_578_447528)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7518 3.15784L38.6136 3.28671C38.6136 3.28671 38.761 4.87937 37.9046 6.03012C37.702 6.30629 34.8748 7.97257 34.6999 8.05543C34.5157 8.13828 34.0645 8.52494 34.0645 8.52494C34.0645 8.52494 37.6099 6.51801 37.9414 6.14056C38.2729 5.76312 38.6781 4.99903 38.7518 3.15784Z",
    fill: "url(#paint138_radial_578_447528)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6464 14.2599C37.6464 14.2599 37.453 14.3335 37.3885 14.3335C37.3885 14.3335 36.1637 14.4256 34.0457 13.0078C33.8891 12.7869 33.5576 11.6914 33.5576 10.4762L33.705 10.6327C33.705 10.6327 33.6681 12.0228 34.1654 12.9342C35.8414 14.131 37.3977 14.2046 37.6464 14.2599Z",
    fill: "url(#paint139_radial_578_447528)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M38.144 12.3273C38.144 12.3273 34.1382 12.9164 33.7422 10.9095C33.7422 10.9095 34.2303 12.6679 38.0151 11.9958L38.144 12.3273Z",
    fill: "url(#paint140_radial_578_447528)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9677 1.24316C39.9677 1.24316 39.848 1.84156 39.627 2.12695C39.627 2.12695 39.7467 3.4986 39.4336 4.20746C39.4336 4.20746 40.2532 2.97388 39.9677 1.24316Z",
    fill: "url(#paint141_radial_578_447528)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5796 1.8689C39.5796 1.8689 39.8835 3.61802 39.2573 4.80559L39.0547 5.04495C39.0547 5.04495 39.7085 3.73773 39.4415 2.17272L39.5796 1.8689Z",
    fill: "url(#paint142_radial_578_447528)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9414 4.27162L38.6136 3.51671V3.29578C38.6136 3.29578 38.19 3.90337 37.8401 4.12431C37.8401 4.12431 37.5546 4.81479 37.306 5.07255C37.0021 5.39476 34.2118 8.25781 34.0645 8.52479L34.5249 8.27621C34.5249 8.27621 34.6538 8.00005 34.9117 7.74228C36.6521 6.01156 37.9874 4.7135 37.9414 4.27162Z",
    fill: "url(#paint143_radial_578_447528)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6648 2.23706C37.6648 2.23706 38.0331 3.99539 37.0109 4.98963C35.9796 5.99308 33.8523 8.06444 33.751 8.68123C33.6589 9.29803 33.5576 10.4672 33.5576 10.4672L33.705 10.6237C33.705 10.6237 33.5208 9.47297 33.797 8.70888C34.0733 7.93558 36.1453 6.14038 36.7623 5.44993C37.3701 4.76869 38.07 3.78366 37.6648 2.23706Z",
    fill: "url(#paint144_radial_578_447528)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9998 8.28579C33.9998 8.28579 32.7842 9.16034 32.7382 9.46413C32.7382 9.46413 32.95 7.57694 34.1932 6.08557C34.1932 6.08557 32.7197 7.2087 32.5908 9.81399C32.5908 9.81399 33.2815 9.07751 33.788 8.70927L33.9998 8.28579Z",
    fill: "url(#paint145_radial_578_447528)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5655 7.65967C35.5655 7.65967 33.8895 8.2765 33.6961 9.8139C33.6961 9.8139 33.6501 8.94853 34.2578 8.2857C34.7551 7.73334 35.5655 7.65967 35.5655 7.65967Z",
    fill: "url(#paint146_radial_578_447528)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3345 38.6379C53.8452 38.2788 59.1035 32.5251 59.1679 25.5102C59.1864 23.0154 58.6062 20.6863 57.5748 18.6886C56.3592 16.3503 53.6795 15.5309 51.589 16.875C50.3919 17.6483 48.9277 18.0902 47.3437 18.0902C45.7598 18.0902 44.2864 17.6391 43.0985 16.875C40.9988 15.5217 38.3098 16.3687 37.0943 18.7346C36.0905 20.6863 35.5195 22.9417 35.5195 25.3629C35.5103 32.7 40.8147 39.0061 47.3345 38.6379Z",
    fill: "#3D314F"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3351 8.28577C38.4577 8.28577 31.2656 14.4721 31.1643 22.2051C31.1275 24.8473 31.9286 27.3145 33.3468 29.441C35.0044 31.9174 38.6695 32.792 41.5243 31.3651C43.1543 30.5457 45.1618 30.0762 47.3351 30.0762C49.5084 30.0762 51.5159 30.555 53.1459 31.3651C56.0283 32.8012 59.7026 31.899 61.351 29.395C62.7231 27.3237 63.5059 24.9301 63.5059 22.3709C63.5059 14.5918 56.2677 8.28577 47.3351 8.28577Z",
    fill: "url(#paint147_radial_578_447528)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5062 22.3705C63.5062 24.7916 62.8063 27.0747 61.5631 29.0632C61.4987 29.1736 61.425 29.2841 61.3513 29.3854C59.749 31.8065 56.2496 32.7272 53.4225 31.4844C53.3304 31.4475 53.2291 31.3923 53.137 31.3555C52.8884 31.2266 52.6213 31.1069 52.3451 31.0056C51.9122 30.8307 51.4518 30.6742 50.9729 30.5453C49.8402 30.2415 48.6155 30.0667 47.317 30.0667C45.1437 30.0667 43.1362 30.5454 41.5062 31.3555C38.6514 32.7732 34.9771 31.9078 33.3287 29.4314C31.9106 27.3048 31.1186 24.8285 31.1462 22.1956C31.2475 14.4625 38.4396 8.27612 47.317 8.27612C56.268 8.28533 63.5062 14.5914 63.5062 22.3705Z",
    fill: "url(#paint148_radial_578_447528)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2393 10.5775C59.7663 13.3025 62.0409 17.6201 62.0409 22.4716C62.0409 25.1874 61.3226 27.7282 60.0886 29.9192C59.7478 30.5176 59.315 31.024 58.8177 31.4474C59.8491 30.9963 60.7424 30.2875 61.3594 29.3577C62.7315 27.2863 63.5143 24.8928 63.5143 22.3335C63.5051 17.4176 60.6135 13.0907 56.2393 10.5775Z",
    fill: "url(#paint149_radial_578_447528)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6367 29.6985C49.6367 29.6985 50.0235 28.7871 53.2742 28.1427C56.525 27.489 58.1365 27.4983 58.6338 26.0805C58.6338 26.0805 58.6154 27.756 56.792 28.6674C56.792 28.6674 59.3889 28.4096 60.8255 25.2888C60.8255 25.2888 59.3981 30.2324 56.2763 30.4902C56.2763 30.4902 56.7552 30.6099 58.7075 30.0851C58.7075 30.0851 57.5564 31.9816 55.3646 31.4016C52.3441 30.5823 50.8062 29.1738 49.6367 29.6985Z",
    fill: "url(#paint150_radial_578_447528)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0664 29.7722C54.0664 29.7722 56.9488 30.076 58.3025 28.4282C59.647 26.7711 59.9601 24.0093 61.498 22.8493C61.498 22.8493 59.1037 23.3373 58.3025 24.8102C58.3025 24.8102 59.0392 23.282 59.5273 22.7849C59.5273 22.7849 57.75 23.0335 56.9488 26.0346C56.1476 29.045 55.2267 29.7722 54.0664 29.7722Z",
    fill: "url(#paint151_radial_578_447528)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0303 27.8755C59.0303 27.8755 59.0303 26.3473 60.0064 24.994C60.9826 23.6499 61.664 22.2322 61.047 21.0078C61.047 21.0078 62.0232 22.0481 61.4798 24.0182C60.9273 25.979 61.047 27.8202 60.6234 28.6212C60.1906 29.4129 59.0947 27.8202 59.0303 27.8755Z",
    fill: "url(#paint152_radial_578_447528)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8977 24.3682C57.8977 24.3682 57.3268 22.8125 58.1556 21.8274C58.9844 20.8424 60.071 19.9125 59.0304 18.6145C59.0304 18.6145 60.4762 19.5995 60.0158 21.0541C59.5553 22.4994 59.6566 22.3429 60.0158 23.0242C60.0158 23.0242 59.9605 22.5547 60.2736 21.9931C60.5867 21.4223 60.9459 20.8608 60.7433 20.1795C60.7433 20.1795 61.2498 20.8147 60.7985 22.2048C60.5407 22.9781 61.4708 23.7606 60.7433 24.4327C60.0158 25.1047 58.3582 27.5259 57.8977 24.3682Z",
    fill: "url(#paint153_radial_578_447528)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4814 16.4509C59.4814 16.4509 61.6732 17.7858 61.0377 20.3635C61.0377 20.3635 61.1851 19.627 60.3839 18.9458C59.5919 18.2553 59.9787 17.2242 59.4814 16.4509Z",
    fill: "url(#paint154_radial_578_447528)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1089 14.9966C58.1089 14.9966 57.7405 16.221 58.2286 16.9574C58.7166 17.6939 59.3336 17.9977 59.3889 18.3015C59.3889 18.3015 59.5731 17.4454 59.2047 17.0127C58.8456 16.5984 58.2378 15.7423 58.1089 14.9966Z",
    fill: "url(#paint155_radial_578_447528)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4401 10.5778C34.9131 13.3027 32.6385 17.6203 32.6385 22.4719C32.6385 25.1876 33.3567 27.7285 34.5907 29.9195C34.9315 30.5179 35.3643 31.0242 35.8616 31.4477C34.8302 30.9966 33.9369 30.2877 33.3199 29.3579C31.9478 27.2866 31.165 24.893 31.165 22.3338C31.165 17.4178 34.0566 13.091 38.4401 10.5778Z",
    fill: "url(#paint156_radial_578_447528)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0423 29.6986C45.0423 29.6986 44.6555 28.7872 41.4048 28.1428C38.1541 27.4892 36.5425 27.4984 36.0452 26.0807C36.0452 26.0807 36.0637 27.7562 37.887 28.6675C37.887 28.6675 35.2901 28.4098 33.8535 25.2889C33.8535 25.2889 35.2809 30.2325 38.4027 30.4903C38.4027 30.4903 37.9238 30.61 35.9716 30.0853C35.9716 30.0853 37.1227 31.9817 39.3144 31.4017C42.3349 30.5824 43.8636 29.1739 45.0423 29.6986Z",
    fill: "url(#paint157_radial_578_447528)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6132 29.7722C40.6132 29.7722 37.7308 30.076 36.3771 28.4282C35.0326 26.7711 34.7195 24.0093 33.1816 22.8493C33.1816 22.8493 35.5759 23.3373 36.3771 24.8102C36.3771 24.8102 35.6404 23.282 35.1523 22.7849C35.1523 22.7849 36.9296 23.0335 37.7308 26.0346C38.532 29.045 39.4529 29.7722 40.6132 29.7722Z",
    fill: "url(#paint158_radial_578_447528)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6493 27.8755C35.6493 27.8755 35.6493 26.3473 34.6731 24.994C33.697 23.6499 33.0155 22.2322 33.6325 21.0078C33.6325 21.0078 32.6564 22.0481 33.1997 24.0182C33.7522 25.979 33.6325 27.8202 34.0561 28.6212C34.4798 29.4129 35.5848 27.8202 35.6493 27.8755Z",
    fill: "url(#paint159_radial_578_447528)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M36.782 24.3682C36.782 24.3682 37.353 22.8125 36.5242 21.8274C35.6954 20.8424 34.6087 19.9125 35.6493 18.6145C35.6493 18.6145 34.2035 19.5995 34.664 21.0541C35.1336 22.4994 35.0231 22.343 34.664 23.0242C34.664 23.0242 34.7192 22.5547 34.4061 21.9931C34.093 21.4223 33.7339 20.8608 33.9365 20.1795C33.9365 20.1795 33.43 20.8147 33.8812 22.2048C34.1391 22.9781 33.209 23.7607 33.9365 24.4327C34.6548 25.0955 36.3216 27.5259 36.782 24.3682Z",
    fill: "url(#paint160_radial_578_447528)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1982 16.4509C35.1982 16.4509 33.0065 17.7858 33.6419 20.3635C33.6419 20.3635 33.4946 19.627 34.2958 18.9458C35.0785 18.2553 34.701 17.2242 35.1982 16.4509Z",
    fill: "url(#paint161_radial_578_447528)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5605 14.9966C36.5605 14.9966 36.9288 16.221 36.4407 16.9574C35.9527 17.6939 35.3357 17.9977 35.2804 18.3015C35.2804 18.3015 35.0962 17.4454 35.4646 17.0127C35.833 16.5984 36.4407 15.7331 36.5605 14.9966Z",
    fill: "url(#paint162_radial_578_447528)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M56.792 11.9675C56.792 11.9675 63.0172 17.353 61.0741 25.6476L59.26 25.2609C59.2508 25.2609 61.332 18.5774 56.792 11.9675Z",
    fill: "url(#paint163_radial_578_447528)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8453 26.0992L60.816 26.5595C60.816 26.5595 60.3555 28.3731 59.757 29.3582L57.2706 28.6769C57.2613 28.6677 58.5414 27.0843 58.8453 26.0992Z",
    fill: "url(#paint164_radial_578_447528)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9792 11.9675C37.9792 11.9675 31.754 17.353 33.697 25.6476L35.5112 25.2609C35.5204 25.2609 33.4392 18.5774 37.9792 11.9675Z",
    fill: "url(#paint165_radial_578_447528)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9351 26.0992L33.9736 26.5595C33.9736 26.5595 34.4341 28.3731 35.0327 29.3582L37.5191 28.6769C37.5191 28.6677 36.2298 27.0843 35.9351 26.0992Z",
    fill: "url(#paint166_radial_578_447528)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3345 38.6379C53.8452 38.2788 59.1035 32.5251 59.1679 25.5102C59.1864 23.0154 58.6062 20.6863 57.5748 18.6886C56.3592 16.3503 53.6795 15.5309 51.589 16.875C50.3919 17.6483 48.9277 18.0902 47.3437 18.0902C45.7598 18.0902 44.2864 17.6391 43.0985 16.875C40.9988 15.5217 38.3098 16.3687 37.0943 18.7346C36.0905 20.6863 35.5195 22.9417 35.5195 25.3629C35.5103 32.7 40.8147 39.0061 47.3345 38.6379Z",
    fill: "url(#paint167_radial_578_447528)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3344 35.5351C46.2201 36.5386 45.3637 37.6433 44.8204 38.4442C42.2787 37.9011 40.041 36.3452 38.3926 34.1634C39.1109 33.7492 39.9489 33.4269 40.9342 33.2704C43.5035 32.8562 45.6952 34.0714 47.3344 35.5351Z",
    fill: "url(#paint168_radial_578_447528)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1018 34.0711C54.4442 36.0964 52.2341 37.5878 49.7201 38.2598C49.1675 37.4773 48.3571 36.4554 47.335 35.5348C48.9741 34.0619 51.1659 32.8559 53.7351 33.2701C54.6468 33.4266 55.4296 33.7028 56.1018 34.0711Z",
    fill: "url(#paint169_radial_578_447528)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5075 15.365C61.5075 15.365 60.2643 9.79538 49.9688 6.07617L50.4292 12.3454L61.5075 15.365Z",
    fill: "url(#paint170_radial_578_447528)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9971 6.39832L50.4391 12.3454L61.1859 15.2821C60.753 14.0577 58.6258 9.58358 49.9971 6.39832Z",
    fill: "url(#paint171_radial_578_447528)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0244 6.73901L50.4388 12.3455L61.0198 15.2269C60.3292 13.6435 57.8888 9.6573 50.0244 6.73901Z",
    fill: "url(#paint172_radial_578_447528)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0244 6.73901L50.4388 12.3455L61.0198 15.2269C60.3292 13.6435 57.8888 9.6573 50.0244 6.73901Z",
    fill: "url(#paint173_radial_578_447528)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1719 15.3649C33.1719 15.3649 34.4151 9.79526 44.7106 6.07605L44.2502 12.3453L33.1719 15.3649Z",
    fill: "url(#paint174_radial_578_447528)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6741 6.39819L44.2321 12.3453L33.4854 15.2819C33.9274 14.0576 36.0546 9.58346 44.6741 6.39819Z",
    fill: "url(#paint175_radial_578_447528)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6468 6.73889L44.2324 12.3454L33.6514 15.2268C34.342 13.6434 36.7916 9.65718 44.6468 6.73889Z",
    fill: "url(#paint176_radial_578_447528)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6468 6.73889L44.2324 12.3454L33.6514 15.2268C34.342 13.6434 36.7916 9.65718 44.6468 6.73889Z",
    fill: "url(#paint177_radial_578_447528)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8775 21.0996L60.8813 20.4092L60.1078 23.9259L60.0341 24.2665C60.0341 24.2665 58.7172 24.8741 57.7135 26.7797C56.7373 28.6485 51.8934 30.1583 51.6816 30.2227C56.7834 27.7095 57.2714 22.4529 57.5845 19.3781C57.6858 18.3839 57.7687 17.6198 57.9897 17.2516C58.0542 17.1503 58.1186 17.0766 58.2107 17.0306C58.2107 17.0306 58.2107 17.0306 58.2199 17.0306C59.546 16.4322 64.1597 17.4633 64.1597 17.4633C62.0785 17.8591 59.9236 21.0352 59.8775 21.0996Z",
    fill: "url(#paint178_radial_578_447528)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M64.151 17.4633C63.3038 17.4172 62.1711 17.6934 62.1711 17.6934C61.0476 17.3344 59.1598 17.2608 57.9902 17.2516C58.0547 17.1503 58.1192 17.0766 58.2112 17.0306C59.5189 16.4322 64.151 17.4633 64.151 17.4633Z",
    fill: "url(#paint179_radial_578_447528)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1514 17.4635C62.0794 17.8594 59.9245 21.0446 59.8877 21.0999C60.6244 19.2679 62.1715 17.6937 62.1715 17.6937L64.1514 17.4635Z",
    fill: "url(#paint180_radial_578_447528)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8962 21.0167C59.8962 21.0167 59.7397 21.5691 59.399 23.6404C59.399 23.6404 57.6677 24.9845 57.2809 26.0248C56.8941 27.065 55.6602 27.9488 55.6602 27.9488C55.6602 27.9488 56.931 26.6416 57.0783 25.7946C57.2349 24.9477 59.0398 23.4471 59.0398 23.4471C59.0398 23.4471 59.6476 21.4862 59.8962 21.0167Z",
    fill: "url(#paint181_radial_578_447528)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8774 21.0999C59.8774 21.0999 58.9473 22.9687 58.8828 23.3277C58.8828 23.3277 57.3726 24.7454 57.0134 25.8318C56.7372 26.6511 55.89 27.7466 55.6689 27.9583C55.6689 27.9583 56.8937 26.7431 57.0779 26.1723C57.2621 25.6016 57.8054 24.4877 59.0578 23.4566C59.0578 23.4474 59.5183 21.6522 59.8774 21.0999Z",
    fill: "url(#paint182_radial_578_447528)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8902 20.4093L59.6562 23.9536L60.0338 24.2758L60.8902 20.4093Z",
    fill: "url(#paint183_radial_578_447528)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8131 24.0916L60.0341 24.2757C60.0341 24.2757 58.7172 24.8833 57.7135 26.789C56.7373 28.6578 51.8934 30.1675 51.6816 30.232C51.875 30.1399 55.4757 28.7314 56.6821 27.6083C57.2899 27.0467 57.6674 26.3931 58.0266 25.583C58.3673 24.8281 59.6473 23.9535 59.6473 23.9535L59.8131 24.0916Z",
    fill: "url(#paint184_radial_578_447528)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1963 29.146C54.1963 29.146 56.784 28.0688 57.3734 26.9457C57.9627 25.8226 58.2482 25.0769 58.7731 24.6534C58.7731 24.6534 58.3771 24.7731 57.226 26.9457C56.7472 27.8755 54.1963 29.146 54.1963 29.146Z",
    fill: "url(#paint185_radial_578_447528)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9902 17.2607C57.9902 17.2607 61.1581 17.4448 61.8948 17.7578C61.8948 17.7578 60.1727 20.0869 59.9333 20.9063C59.9333 20.9063 61.7106 17.9972 62.2908 17.7302L64.151 17.4632L62.1527 17.6473C62.1527 17.6473 59.9609 17.1963 57.9902 17.2607Z",
    fill: "url(#paint186_radial_578_447528)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4116 21.9189L59.7578 23.9443L60.0341 24.2756L59.6749 24.0639L58.7725 24.6623L59.6565 23.9534L60.4116 21.9189Z",
    fill: "url(#paint187_radial_578_447528)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M59.877 21.0998L60.6321 20.7499L60.4111 21.9191L60.8899 20.4093L59.877 21.0998Z",
    fill: "url(#paint188_radial_578_447528)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M57.677 19.866C57.677 19.866 57.3823 22.1951 57.2441 22.7475C57.2441 22.7475 58.782 22.9132 58.9017 22.7475C59.0215 22.5818 59.5464 20.9339 60.2462 19.9028C60.2462 19.9028 58.5518 19.4701 57.677 19.866Z",
    fill: "url(#paint189_radial_578_447528)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4856 21.0076L60.062 22.8119H59.5371L59.7765 21.4035L60.4856 21.0076Z",
    fill: "url(#paint190_radial_578_447528)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2443 22.7476C57.2443 22.7476 58.4323 22.9593 58.9019 22.7476L58.6072 23.4288C58.6072 23.4288 57.3272 24.4874 56.9128 25.8407L56.0195 26.1998C56.0195 26.1998 56.9404 24.4783 57.2443 22.7476Z",
    fill: "url(#paint191_radial_578_447528)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8782 17.3898C58.3404 18.7615 58.0641 20.5658 58.0641 20.5658L57.6221 18.8812C57.7234 17.8869 57.7602 17.6291 57.972 17.2517C58.0365 17.1504 58.1009 17.0768 58.193 17.0308C58.193 17.0308 58.193 17.0308 58.2022 17.0308C58.4969 17.04 58.7087 17.0676 58.7087 17.0676L59.8782 17.3898Z",
    fill: "url(#paint192_radial_578_447528)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3788 15.8248C61.3788 15.8248 58.3675 17.9238 58.1281 19.8662C58.1281 19.8662 58.0544 19.4059 57.8518 18.6787C57.5111 17.4635 56.7928 15.475 55.4391 13.5325C54.7208 12.5199 53.8275 11.5164 52.7132 10.6511C52.5383 10.513 52.3633 10.3749 52.1699 10.246C52.1699 10.246 53.2474 10.0987 54.8129 10.5498C56.6362 11.0838 59.1503 12.437 61.3788 15.8248Z",
    fill: "url(#paint193_radial_578_447528)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1632 15.7606C60.1632 15.7606 59.2331 15.8251 57.8333 18.6789C57.7688 18.4672 57.7044 18.2278 57.6123 17.9701C57.0045 16.1289 55.7337 13.2843 53.2289 11.1024C53.0539 10.9551 52.8789 10.7986 52.6855 10.6513C52.6948 10.6421 52.6948 10.6237 52.7132 10.6145C52.7316 10.6145 57.4281 11.6824 60.1632 15.7606Z",
    fill: "url(#paint194_radial_578_447528)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1602 10.2462C52.1602 10.2462 57.3724 10.283 60.7705 15.8158H61.3782C61.3782 15.825 58.1736 9.96079 52.1602 10.2462Z",
    fill: "url(#paint195_radial_578_447528)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M61.379 15.8246L60.1726 15.7601C60.1726 15.7601 58.2664 17.049 57.8428 18.6784L58.119 19.866C58.119 19.866 58.3308 17.8591 61.379 15.8246Z",
    fill: "url(#paint196_radial_578_447528)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4205 13.5324C54.7022 12.5198 53.809 11.5163 52.6947 10.6509C52.5197 10.5128 52.3448 10.3748 52.1514 10.2459C52.1514 10.2459 53.2288 10.0986 54.7943 10.5497C55.0061 11.0836 55.4758 12.3449 55.4205 13.5324Z",
    fill: "url(#paint197_radial_578_447528)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8405 15.5857C59.8405 15.5857 58.8091 15.9908 57.6304 18.2002C57.5751 18.0069 57.5107 17.7951 57.437 17.565C56.8937 15.9079 55.7518 13.3671 53.514 11.4062C53.3575 11.2681 53.1917 11.13 53.0352 11.0012C53.0444 10.9919 53.0444 10.9827 53.0536 10.9735C53.0444 10.9735 57.3817 11.9309 59.8405 15.5857Z",
    fill: "url(#paint198_radial_578_447528)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5183 15.5302C59.5183 15.5302 58.2751 16.4784 57.6305 17.9698C57.0227 16.1286 55.7519 13.284 53.2471 11.1022C53.6707 11.2219 57.1977 12.3265 59.5183 15.5302Z",
    fill: "url(#paint199_radial_578_447528)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2471 11.1022C53.2471 11.1022 56.9767 13.0814 58.1094 15.1804L59.5275 15.5302C59.5183 15.5302 57.6765 12.5015 53.2471 11.1022Z",
    fill: "url(#paint200_radial_578_447528)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1003 15.1714C58.1003 15.1714 57.5385 16.7364 57.4648 17.4453L57.6306 17.9608C57.6306 17.9608 58.2936 16.3866 59.5184 15.5212C59.5184 15.5304 58.441 15.2911 58.1003 15.1714Z",
    fill: "url(#paint201_radial_578_447528)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3047 13.1553C56.3047 13.1553 57.7044 14.6466 58.0267 15.2542C57.9715 15.6869 57.6123 16.6443 57.4742 17.1046L58.1649 15.3463L59.5278 15.5212L58.1557 15.0977C58.1557 15.0977 56.9769 13.68 56.3047 13.1553Z",
    fill: "url(#paint202_radial_578_447528)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2471 11.1022C53.2471 11.1022 55.1809 12.1517 56.5162 13.3576C56.5162 13.3576 55.5401 12.1701 53.2471 11.1022Z",
    fill: "url(#paint203_radial_578_447528)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5807 13.3118L57.8147 13.634C57.8147 13.634 56.1939 12.1058 53.2471 11.0931C53.2471 11.1023 54.4811 11.6639 56.5807 13.3118Z",
    fill: "url(#paint204_radial_578_447528)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M57.833 13.2017C57.833 13.2017 59.7485 14.7851 60.0892 15.6965C60.0892 15.6965 59.1315 16.3869 58.2935 17.6573C58.2935 17.6573 59.4354 16.0371 60.1905 15.8346L61.3692 15.8254L60.1905 15.6228C60.1997 15.6136 59.6564 14.7667 57.833 13.2017Z",
    fill: "url(#paint205_radial_578_447528)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9512 10.8169C54.9512 10.8169 57.1245 11.6362 59.5832 14.1403C59.5832 14.1403 58.0638 11.9676 54.9512 10.8169Z",
    fill: "url(#paint206_radial_578_447528)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0375 4.43701C51.0375 4.43701 48.2841 5.72586 49.6194 8.727C49.6194 8.727 49.1405 9.32541 49.5273 9.95142L50.5863 8.73621C50.5955 8.73621 50.2271 5.32078 51.0375 4.43701Z",
    fill: "url(#paint207_radial_578_447528)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5361 9.95155C49.5361 9.95155 52.5014 9.16905 54.6747 11.5166C54.6747 11.5166 50.807 6.96883 49.5361 9.95155Z",
    fill: "url(#paint208_radial_578_447528)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6745 11.5808C54.6561 11.5624 54.6377 11.5348 54.6193 11.5164C54.61 11.498 54.5824 11.4796 54.5732 11.4612C50.6502 6.96868 49.5452 9.96059 49.5452 9.96059C49.5083 9.24252 50.3187 8.8743 50.3187 8.8743C50.1622 8.60733 49.7846 8.11943 49.7017 7.88008C49.6925 7.84325 49.6833 7.80641 49.6649 7.76959C49.6557 7.76038 49.6557 7.73276 49.6557 7.72356C49.6188 7.59467 49.6004 7.47499 49.582 7.3461C49.361 5.53253 51.0462 4.43701 51.0462 4.43701C51.0462 4.43701 50.9541 4.78687 50.9541 5.29319C50.9541 5.40366 50.9541 5.51411 50.9633 5.63379C50.9725 5.79029 50.991 5.95603 51.0186 6.13094C51.0278 6.19539 51.037 6.25062 51.0554 6.31506C51.1843 6.89504 51.4606 7.51181 52.0039 8.03655C52.1789 8.20226 52.3815 8.35877 52.6209 8.50606C52.8051 8.61654 52.9709 8.72702 53.1274 8.8467C54.4719 9.85936 54.6653 10.9457 54.6929 11.3783C54.6837 11.5072 54.6745 11.5808 54.6745 11.5808Z",
    fill: "url(#paint209_radial_578_447528)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7924 8.08247C51.1293 7.55773 50.5676 6.24129 50.761 5.00769C50.761 5.00769 48.8455 6.70161 50.6413 8.52439L51.7924 8.08247Z",
    fill: "url(#paint210_radial_578_447528)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5361 9.95155C49.5361 9.95155 52.5014 9.16905 54.6747 11.5166C54.6747 11.5166 50.807 6.96883 49.5361 9.95155Z",
    fill: "url(#paint211_radial_578_447528)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9356 5.48594C50.5396 5.7345 49.9042 6.27765 49.5911 7.55728C49.5911 7.56648 49.6372 7.75057 49.6279 7.75057C49.6279 7.75057 49.5635 7.51121 49.5635 7.38233C49.5635 7.38233 49.5635 7.37313 49.5635 7.34551C49.5819 7.15219 49.7477 6.10273 50.9264 5.2926C50.9356 5.40307 50.9356 5.36626 50.9356 5.48594Z",
    fill: "url(#paint212_radial_578_447528)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0372 6.3239C50.411 6.63691 49.8584 7.57595 49.6927 7.87975C49.6558 7.94419 49.6374 7.97181 49.6374 7.97181L49.6006 7.87975C49.619 7.84293 49.6374 7.79687 49.6651 7.76004C50.2268 6.71056 50.7149 6.28712 51.0095 6.13062C51.0095 6.20426 51.028 6.25946 51.0372 6.3239Z",
    fill: "url(#paint213_radial_578_447528)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5301 8.80984C49.9131 8.1194 48.8265 6.34265 51.009 4.43701C51.009 4.43701 48.2463 6.19537 50.2907 8.8743C50.2907 8.8743 49.3606 9.11364 49.5356 9.96059C49.5356 9.96059 49.9592 9.05844 50.788 9.03082C50.788 9.03082 53.2468 9.21492 54.582 11.5901C54.582 11.5809 53.9927 9.44505 50.5301 8.80984Z",
    fill: "url(#paint214_radial_578_447528)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M49.665 7.24439C49.665 7.24439 50.0886 5.95559 50.9359 5.48608L50.9451 5.64256C50.9451 5.64256 50.0794 6.02922 49.7019 7.44694L49.665 7.24439Z",
    fill: "url(#paint215_radial_578_447528)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8027 7.68674C49.8027 7.68674 50.4197 6.60965 51.0459 6.31506L51.0551 6.43472C51.0551 6.43472 50.1342 7.09757 49.8396 7.88007L49.8027 7.68674Z",
    fill: "url(#paint216_radial_578_447528)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6278 8.72712C49.6278 8.72712 49.6646 8.81919 50.3093 8.87442C50.3093 8.87442 48.1544 6.5545 51.046 4.43713C51.0368 4.43713 48.2649 5.80883 49.6278 8.72712Z",
    fill: "url(#paint217_radial_578_447528)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1094 8.85576C52.7319 9.01226 52.3175 9.24243 52.3175 9.24243C51.9031 8.93863 50.752 8.68086 50.752 8.68086C51.0006 8.53356 51.5808 8.24819 51.9859 8.04565C52.1609 8.21136 52.3635 8.36787 52.6029 8.51517C52.7871 8.62564 52.9621 8.73608 53.1094 8.85576Z",
    fill: "url(#paint218_radial_578_447528)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3174 9.24238L53.1093 8.85571C53.1093 8.85571 53.5974 9.2608 53.7171 9.38968C53.7171 9.38968 53.1922 9.50935 53.0817 9.61062C53.0725 9.61982 52.4924 9.2792 52.3174 9.24238Z",
    fill: "url(#paint219_radial_578_447528)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1514 35.3046V37.7809L51.4151 35.0376L51.3967 33.224L47.1514 33.8776V35.3046Z",
    fill: "url(#paint220_radial_578_447528)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4151 35.0376L47.1514 37.0997V37.781L51.4151 35.0376Z",
    fill: "url(#paint221_radial_578_447528)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3782 34.5769L47.1514 36.3076V37.0993L51.4151 35.0372L51.3782 34.5769Z",
    fill: "url(#paint222_radial_578_447528)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3782 34.5774L51.1112 34.0986L47.1514 35.3046V36.3081L51.3782 34.5774Z",
    fill: "url(#paint223_radial_578_447528)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1514 35.3045L51.1112 34.0986L51.3967 33.224L47.1514 33.8776V35.3045Z",
    fill: "url(#paint224_radial_578_447528)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1514 35.3045L51.1112 34.0985V33.9789L47.1514 35.148V35.3045Z",
    fill: "url(#paint225_radial_578_447528)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1514 36.3077L51.3782 34.577V34.4666L47.1514 36.1881V36.3077Z",
    fill: "url(#paint226_radial_578_447528)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4151 35.0376L47.1514 36.9616V37.0997L51.4151 35.0376Z",
    fill: "url(#paint227_radial_578_447528)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1514 37.781L51.4151 35.0376L47.1514 37.6521V37.781Z",
    fill: "url(#paint228_radial_578_447528)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7428 31.1523C55.7428 31.1523 56.2217 34.2087 53.9747 34.6045C52.1605 34.9267 50.4385 34.1995 50.4385 34.1995C50.4385 34.1995 52.5289 32.4319 53.5787 31.1431C54.6193 29.8726 55.7428 31.1523 55.7428 31.1523Z",
    fill: "url(#paint229_radial_578_447528)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3463 31.3732C55.3463 31.3732 55.7515 33.9693 53.8453 34.3099C52.3074 34.5861 50.834 33.9693 50.834 33.9693C50.834 33.9693 52.6113 32.4688 53.4954 31.3732C54.3794 30.2777 55.3463 31.3732 55.3463 31.3732Z",
    fill: "url(#paint230_radial_578_447528)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0537 34.3836C53.0537 34.3836 54.9876 34.6046 55.2454 32.9291C55.2454 32.9291 55.006 34.402 53.0537 34.3836Z",
    fill: "url(#paint231_radial_578_447528)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M54.251 30.9775C54.251 30.9775 55.0061 30.9038 55.3468 31.3733C55.3468 31.3733 55.4113 31.9073 55.3745 32.2479C55.3745 32.2479 55.4113 31.5666 55.1811 31.3365C54.9508 31.1063 54.4812 30.9775 54.251 30.9775Z",
    fill: "url(#paint232_radial_578_447528)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8438 33.951C50.8438 33.951 51.5068 34.3653 52.8605 34.3837C52.8605 34.393 51.8383 34.2825 50.8438 33.951Z",
    fill: "url(#paint233_radial_578_447528)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2878 33.6565C54.1313 33.7853 53.9379 33.8774 53.6708 33.9234C53.4038 33.9695 53.1459 33.9879 52.8973 33.9787C52.0408 33.9511 51.3594 33.6656 51.3594 33.6656C51.3594 33.6656 51.608 33.4539 51.9487 33.1501C52.4092 32.7359 53.017 32.1559 53.4038 31.6772C53.5327 31.5207 53.6616 31.4194 53.7813 31.3641C54.3338 31.1156 54.8127 31.6772 54.8127 31.6772C54.8127 31.6772 54.8219 31.7508 54.8311 31.8705C54.8772 32.2663 54.868 33.187 54.2878 33.6565Z",
    fill: "url(#paint234_radial_578_447528)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5555 32.0364L54.0674 33.1595L53.0176 33.4081L51.9678 33.1504C52.4282 32.7361 53.036 32.1561 53.4228 31.6774C53.5517 31.5209 53.6806 31.4196 53.8003 31.3644L54.5555 32.0364Z",
    fill: "url(#paint235_radial_578_447528)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2884 33.6564L54.0674 33.15L54.5555 32.0269L54.8593 31.8612C54.8778 32.2663 54.8686 33.1869 54.2884 33.6564Z",
    fill: "url(#paint236_radial_578_447528)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0083 33.3987L52.907 33.9787C52.0506 33.9511 51.3691 33.6656 51.3691 33.6656C51.3691 33.6656 51.6178 33.4539 51.9585 33.1501L53.0083 33.3987Z",
    fill: "url(#paint237_radial_578_447528)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7998 31.3551L54.4813 32.0455L54.1313 33.0213L54.5826 32.0731L54.868 31.8706L54.5457 31.9627L53.7998 31.3551Z",
    fill: "url(#paint238_radial_578_447528)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M51.958 33.141L52.9434 33.4816L52.9065 33.9788L53.0539 33.4632L54.0576 33.2146L54.2879 33.6566L54.1405 33.1686L54.5825 32.0731L54.0576 33.141L53.0078 33.3988L51.958 33.141Z",
    fill: "url(#paint239_radial_578_447528)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1005 33.6474L53.0176 33.9419C53.0176 33.9419 53.8188 33.9328 54.1134 33.6934L53.9937 33.4448C54.0029 33.4356 53.4412 33.6842 53.1005 33.6474Z",
    fill: "url(#paint240_radial_578_447528)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5921 32.2206C54.5921 32.2575 54.4355 32.6809 54.4355 32.6809C54.4355 32.6809 54.6749 33.086 54.6749 33.0031C54.6749 32.9663 54.8038 32.4876 54.7946 32.2574C54.7854 32.0273 54.5921 32.2206 54.5921 32.2206Z",
    fill: "url(#paint241_radial_578_447528)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1514 35.3046L51.4335 34.0066L51.4059 34.1907L47.1514 35.4611V35.3046Z",
    fill: "url(#paint242_radial_578_447528)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3782 34.5769L47.1514 36.3076V36.5101L51.4059 34.6966L51.3782 34.5769Z",
    fill: "url(#paint243_radial_578_447528)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1514 37.0997L51.4151 35.0376L47.1514 37.2838V37.0997Z",
    fill: "url(#paint244_radial_578_447528)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1514 37.6335L48.2288 34.7704L49.3523 35.0098C49.3523 35.0098 50.2548 34.347 51.1849 34.5587L51.94 33.9327L47.1514 34.3378V37.6335Z",
    fill: "url(#paint245_radial_578_447528)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0874 27.7922C62.0506 27.8843 60.8627 30.7934 58.496 31.0788C56.0925 31.3734 54.2783 30.5172 54.2783 30.5172C54.2783 30.5172 55.2268 29.8636 56.0648 29.4493C56.0648 29.4493 57.1791 29.4953 58.5052 29.302C59.776 29.1179 61.2494 28.7036 62.0874 27.7922Z",
    fill: "url(#paint246_radial_578_447528)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0874 27.8015C62.0506 27.8936 60.8627 30.8027 58.496 31.0788C56.0925 31.3734 54.2783 30.5173 54.2783 30.5173C54.2783 30.5173 55.2268 29.8636 56.0648 29.4494C56.0648 29.4494 57.1791 29.4954 58.5052 29.3021C58.1921 29.7255 57.5014 30.462 57.5014 30.462C60.6877 30.2963 62.0506 27.8752 62.0874 27.8015Z",
    fill: "url(#paint247_radial_578_447528)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0001 30.2132C52.823 31.6862 52.3902 33.5642 52.3902 33.5642L51.4877 34.1902C50.2169 34.1902 49.2315 34.6137 49.2315 34.6137L47.8963 34.5584L47.1503 35.3133C47.1503 35.3133 47.1503 35.166 47.1503 34.9359C47.1411 34.6229 47.1595 34.1626 47.1503 33.6931C47.1411 32.9014 47.1227 32.1004 47.1503 32.0176C47.1503 32.0176 48.2922 32.1281 49.5631 31.5389C51.4969 30.6459 52.5467 28.8692 52.5928 28.8139C52.1323 31.41 49.9314 33.2328 49.9314 33.2328C49.9959 33.2236 50.9352 32.9842 51.6627 32.5976C52.3349 32.2385 52.9888 30.4434 55.9264 28.6574C56.2579 28.4549 56.6263 28.2524 57.0222 28.0406C61.6819 25.6747 61.5714 21.7714 61.5714 21.7714C63.0357 28.5101 59.4626 28.6298 56.0001 30.2132Z",
    fill: "url(#paint248_radial_578_447528)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0005 30.2132C52.8234 31.6862 52.3906 33.5642 52.3906 33.5642C52.3906 33.5642 52.6208 31.6309 55.4572 29.845C57.7134 28.418 62.4191 28.0038 61.5719 21.7714C63.0361 28.5101 59.463 28.6298 56.0005 30.2132Z",
    fill: "url(#paint249_radial_578_447528)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9324 33.2238C49.9324 33.2238 48.2012 34.264 47.1514 34.6875C47.1514 34.6875 48.7813 34.1812 50.4021 33.1593L49.9324 33.2238Z",
    fill: "url(#paint250_radial_578_447528)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M52.584 28.8048C52.5472 28.9061 51.2119 32.1742 47.1415 33.6932C47.1323 32.9015 47.1139 32.1005 47.1415 32.0177C47.1415 32.0177 48.2834 32.1282 49.5543 31.539C51.4973 30.6368 52.5564 28.86 52.584 28.8048Z",
    fill: "url(#paint251_radial_578_447528)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1514 34.9266L47.9065 34.5583L47.1514 35.304V34.945V34.9266Z",
    fill: "url(#paint252_radial_578_447528)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3904 33.5741L51.4879 34.2001C50.2171 34.2001 49.2318 34.6236 49.2318 34.6236L47.8965 34.5684L49.241 34.3474C49.241 34.3474 50.2171 33.703 51.1564 33.9147L52.3904 33.5741Z",
    fill: "url(#paint253_radial_578_447528)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6043 28.8968C53.9651 29.9279 52.5562 32.6897 52.1326 32.837C51.7182 32.9751 50.0053 33.2144 49.9316 33.2236C49.9961 33.2144 50.9354 32.9751 51.6629 32.5884C52.3352 32.2294 52.989 30.4342 55.9266 28.6483C56.0832 28.5746 56.0279 28.6299 55.6043 28.8968Z",
    fill: "url(#paint254_radial_578_447528)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3154 30.6832C54.3154 30.6832 55.2732 29.4956 57.824 28.7407C57.824 28.7407 55.7336 29.5785 54.3154 30.6832Z",
    fill: "url(#paint255_radial_578_447528)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5605 28.3358C58.5605 28.3358 61.6455 27.3784 61.7008 23.5303C61.7008 23.5395 61.4982 27.0193 58.5605 28.3358Z",
    fill: "url(#paint256_radial_578_447528)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5842 28.8048C52.5842 28.8048 51.1384 31.6126 49.1309 32.6437C49.1309 32.6437 51.3042 31.8888 52.5842 28.8048Z",
    fill: "url(#paint257_radial_578_447528)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3281 33.187C50.3281 33.187 51.9765 33.0397 52.1975 32.9108C52.4278 32.7911 53.5328 30.9131 54.1959 30.2411C54.1959 30.2411 52.9434 31.7416 52.1331 32.7543C51.7647 32.9844 50.3281 33.187 50.3281 33.187Z",
    fill: "url(#paint258_radial_578_447528)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1914 34.4667C48.1914 34.4667 48.9373 34.4022 49.278 34.4022C49.4714 34.2733 49.8214 33.988 50.466 33.8683C50.466 33.8683 49.4991 34.0616 49.2412 34.3378C48.8176 34.3102 48.1914 34.4667 48.1914 34.4667Z",
    fill: "url(#paint259_radial_578_447528)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2539 33.905C50.2539 33.905 50.9169 33.8314 51.1564 33.9787L52.3904 33.5645L51.2024 33.8682C51.2116 33.8774 50.6867 33.767 50.2539 33.905Z",
    fill: "url(#paint260_radial_578_447528)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4784 34.1995L51.1561 33.9877C51.1561 33.9877 50.2536 33.6195 49.2775 34.4112L49.2314 34.623C49.2407 34.6138 50.4654 34.1443 51.4784 34.1995Z",
    fill: "url(#paint261_radial_578_447528)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2686 34.329L50.8433 33.1967L52.197 32.9205L51.2393 33.8687C51.2393 33.8687 50.3368 33.5649 49.2686 34.329Z",
    fill: "url(#paint262_radial_578_447528)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6182 28.3905C61.6182 28.3905 60.6421 29.7806 58.3398 30.3606C58.3398 30.3606 60.3105 30.3146 61.6182 28.3905Z",
    fill: "url(#paint263_radial_578_447528)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0586 8.34924C52.0586 8.34924 54.3148 9.43558 54.6739 11.5161C54.6739 11.5161 54.7752 10.0063 52.9334 8.71748C52.9334 8.71748 52.1507 8.40448 52.0586 8.34924Z",
    fill: "url(#paint264_radial_578_447528)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4706 21.0997L33.4668 20.4093L34.2404 23.926L34.314 24.2666C34.314 24.2666 35.6309 24.8742 36.6347 26.7798C37.6108 28.6486 42.4639 30.1584 42.6665 30.2229C37.5648 27.7096 37.0767 22.453 36.7636 19.3783C36.6623 18.384 36.5794 17.6199 36.3584 17.2517C36.294 17.1504 36.2295 17.0768 36.1374 17.0307C36.1374 17.0307 36.1374 17.0307 36.1282 17.0307C34.8021 16.4324 30.1885 17.4634 30.1885 17.4634C32.2697 17.8592 34.4246 21.0353 34.4706 21.0997Z",
    fill: "url(#paint265_radial_578_447528)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1982 17.4634C31.0455 17.4174 32.1782 17.6935 32.1782 17.6935C33.3016 17.3345 35.1895 17.2609 36.359 17.2517C36.2945 17.1504 36.2301 17.0768 36.138 17.0307C34.8303 16.4324 30.1982 17.4634 30.1982 17.4634Z",
    fill: "url(#paint266_radial_578_447528)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1982 17.4637C32.2702 17.8596 34.4251 21.0449 34.4619 21.1001C33.7252 19.2681 32.1782 17.6939 32.1782 17.6939L30.1982 17.4637Z",
    fill: "url(#paint267_radial_578_447528)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4521 21.0168C34.4521 21.0168 34.6087 21.5692 34.9494 23.6405C34.9494 23.6405 36.6807 24.9846 37.0675 26.0249C37.445 27.0651 38.6882 27.949 38.6882 27.949C38.6882 27.949 37.4174 26.6417 37.2701 25.7947C37.1135 24.9478 35.3086 23.4472 35.3086 23.4472C35.3086 23.4472 34.7008 21.4863 34.4521 21.0168Z",
    fill: "url(#paint268_radial_578_447528)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4707 21.1C34.4707 21.1 35.4008 22.9688 35.4653 23.3278C35.4653 23.3278 36.9755 24.7456 37.3347 25.8319C37.6109 26.6512 38.4581 27.7467 38.6792 27.9584C38.6792 27.9584 37.4544 26.7432 37.2702 26.1725C37.086 25.6017 36.5427 24.4878 35.2903 23.4567C35.2903 23.4475 34.8298 21.6523 34.4707 21.1Z",
    fill: "url(#paint269_radial_578_447528)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M33.457 20.4094L34.6818 23.9537L34.3135 24.2759L33.457 20.4094Z",
    fill: "url(#paint270_radial_578_447528)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5257 24.0917L34.3047 24.2758C34.3047 24.2758 35.6216 24.8834 36.6253 26.7891C37.6015 28.6579 42.4545 30.1676 42.6571 30.2321C42.4638 30.14 38.8631 28.7315 37.6567 27.6084C37.0489 27.0468 36.6714 26.3932 36.3122 25.5831C35.9715 24.8282 34.6915 23.9536 34.6915 23.9536L34.5257 24.0917Z",
    fill: "url(#paint271_radial_578_447528)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M40.153 29.1461C40.153 29.1461 37.5653 28.069 36.9759 26.9458C36.3865 25.8227 36.1011 25.077 35.5762 24.6536C35.5762 24.6536 35.9721 24.7732 37.1233 26.9458C37.6021 27.8756 40.153 29.1461 40.153 29.1461Z",
    fill: "url(#paint272_radial_578_447528)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M36.359 17.2608C36.359 17.2608 33.1911 17.4449 32.4544 17.7579C32.4544 17.7579 34.1765 20.0871 34.4159 20.9064C34.4159 20.9064 32.6386 17.9973 32.0584 17.7303L30.1982 17.4633L32.1966 17.6474C32.1874 17.6474 34.3883 17.1964 36.359 17.2608Z",
    fill: "url(#paint273_radial_578_447528)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9277 21.9192L34.5908 23.9445L34.3145 24.2759L34.6644 24.0642L35.5761 24.6625L34.6829 23.9537L33.9277 21.9192Z",
    fill: "url(#paint274_radial_578_447528)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M34.47 21.0999L33.7149 20.7501L33.9267 21.9192L33.457 20.4094L34.47 21.0999Z",
    fill: "url(#paint275_radial_578_447528)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6718 19.8661C36.6718 19.8661 36.9665 22.1952 37.1047 22.7476C37.1047 22.7476 35.5668 22.9133 35.4471 22.7476C35.3274 22.5819 34.8025 20.934 34.1026 19.9029C34.0934 19.9029 35.8062 19.4702 36.6718 19.8661Z",
    fill: "url(#paint276_radial_578_447528)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8633 21.0077L34.2961 22.8121H34.8118L34.5724 21.4036L33.8633 21.0077Z",
    fill: "url(#paint277_radial_578_447528)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1039 22.7477C37.1039 22.7477 35.9159 22.9594 35.4463 22.7477L35.741 23.4289C35.741 23.4289 37.021 24.4876 37.4354 25.8408L38.3287 26.1999C38.3287 26.1999 37.4078 24.4784 37.1039 22.7477Z",
    fill: "url(#paint278_radial_578_447528)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4619 17.3899C35.9998 18.7616 36.2761 20.566 36.2761 20.566L36.7181 18.8813C36.6168 17.887 36.58 17.6293 36.3682 17.2518C36.3037 17.1506 36.2392 17.0769 36.1471 17.0309C36.1471 17.0309 36.1471 17.0309 36.1379 17.0309C35.8433 17.0401 35.6314 17.0677 35.6314 17.0677L34.4619 17.3899Z",
    fill: "url(#paint279_radial_578_447528)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9697 15.8248C32.9697 15.8248 35.981 17.9238 36.2205 19.8662C36.2205 19.8662 36.2941 19.4059 36.4967 18.6787C36.8375 17.4635 37.5557 15.475 38.9095 13.5325C39.6277 12.5199 40.521 11.5164 41.6353 10.6511C41.8102 10.513 41.9852 10.3749 42.1786 10.246C42.1786 10.246 41.1012 10.0987 39.5357 10.5498C37.7123 11.0838 35.1891 12.437 32.9697 15.8248Z",
    fill: "url(#paint280_radial_578_447528)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1758 15.7606C34.1758 15.7606 35.1059 15.8251 36.5056 18.6789C36.5701 18.4672 36.6346 18.2278 36.7266 17.9701C37.3344 16.1289 38.6053 13.2843 41.1101 11.1024C41.285 10.9551 41.46 10.7986 41.6534 10.6513C41.6442 10.6421 41.6442 10.6237 41.6258 10.6145C41.6258 10.6145 36.9292 11.6824 34.1758 15.7606Z",
    fill: "url(#paint281_radial_578_447528)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1966 10.2464C42.1966 10.2464 36.9844 10.2832 33.5863 15.816H32.9785C32.9693 15.8252 36.174 9.96103 42.1966 10.2464Z",
    fill: "url(#paint282_radial_578_447528)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9697 15.8248L34.1761 15.7604C34.1761 15.7604 36.0823 17.0492 36.5059 18.6787L36.2297 19.8662C36.2205 19.8662 36.0179 17.8593 32.9697 15.8248Z",
    fill: "url(#paint283_radial_578_447528)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9192 13.5328C39.6375 12.5201 40.5307 11.5167 41.645 10.6513C41.82 10.5132 41.9949 10.3751 42.1883 10.2462C42.1883 10.2462 41.1109 10.099 39.5454 10.5501C39.3428 11.084 38.8731 12.3452 38.9192 13.5328Z",
    fill: "url(#paint284_radial_578_447528)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M34.499 15.5857C34.499 15.5857 35.5304 15.9908 36.7092 18.2002C36.7644 18.0069 36.8289 17.7951 36.9025 17.565C37.4459 15.9079 38.5878 13.3671 40.8255 11.4062C40.9821 11.2681 41.1478 11.13 41.3044 11.0012C41.2952 10.9919 41.2952 10.9827 41.286 10.9735C41.2952 10.9735 36.967 11.9309 34.499 15.5857Z",
    fill: "url(#paint285_radial_578_447528)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8203 15.5303C34.8203 15.5303 36.0635 16.4785 36.7081 17.9699C37.3159 16.1287 38.5867 13.2841 41.0916 11.1023C40.6772 11.222 37.1502 12.3267 34.8203 15.5303Z",
    fill: "url(#paint286_radial_578_447528)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1008 11.1023C41.1008 11.1023 37.3712 13.0816 36.2385 15.1805L34.8203 15.5303C34.8203 15.5303 36.6621 12.5016 41.1008 11.1023Z",
    fill: "url(#paint287_radial_578_447528)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2483 15.1715C36.2483 15.1715 36.81 16.7365 36.8837 17.4454L36.718 17.9609C36.718 17.9609 36.0549 16.3867 34.8301 15.5214C34.8209 15.5306 35.9076 15.2912 36.2483 15.1715Z",
    fill: "url(#paint288_radial_578_447528)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0434 13.1554C38.0434 13.1554 36.6437 14.6467 36.3214 15.2543C36.3766 15.687 36.7358 16.6444 36.8739 17.1047L36.1832 15.3464L34.8203 15.5213L36.1924 15.0979C36.1924 15.0979 37.3712 13.6801 38.0434 13.1554Z",
    fill: "url(#paint289_radial_578_447528)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1012 11.1023C41.1012 11.1023 39.1673 12.1518 37.832 13.3578C37.8412 13.3578 38.8082 12.1702 41.1012 11.1023Z",
    fill: "url(#paint290_radial_578_447528)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7672 13.3119L36.5332 13.6341C36.5332 13.6341 38.154 12.1059 41.1008 11.0933C41.1008 11.1025 39.876 11.664 37.7672 13.3119Z",
    fill: "url(#paint291_radial_578_447528)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5059 13.2018C36.5059 13.2018 34.5905 14.7852 34.2498 15.6966C34.2498 15.6966 35.2075 16.387 36.0455 17.6575C36.0455 17.6575 34.9036 16.0372 34.1485 15.8347L32.9697 15.8255L34.1485 15.6229C34.1485 15.6137 34.6918 14.7668 36.5059 13.2018Z",
    fill: "url(#paint292_radial_578_447528)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3977 10.817C39.3977 10.817 37.2244 11.6364 34.7656 14.1404C34.7656 14.1404 36.2851 11.9678 39.3977 10.817Z",
    fill: "url(#paint293_radial_578_447528)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3115 4.43713C43.3115 4.43713 46.065 5.72598 44.7297 8.72712C44.7297 8.72712 45.2085 9.32553 44.8218 9.95154L43.7627 8.73633C43.7627 8.73633 44.1219 5.32091 43.3115 4.43713Z",
    fill: "url(#paint294_radial_578_447528)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8124 9.95168C44.8124 9.95168 41.8471 9.16917 39.6738 11.5167C39.6738 11.5167 43.5323 6.96894 44.8124 9.95168Z",
    fill: "url(#paint295_radial_578_447528)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6737 11.5811C39.6921 11.5627 39.7105 11.5351 39.7289 11.5167C39.7382 11.4983 39.7658 11.4798 39.775 11.4614C43.698 6.96892 44.803 9.96083 44.803 9.96083C44.8399 9.24277 44.0295 8.87455 44.0295 8.87455C44.186 8.60757 44.5636 8.11968 44.6465 7.88032C44.6557 7.8435 44.6649 7.80665 44.6833 7.76983C44.6925 7.76063 44.6925 7.73301 44.6925 7.7238C44.7294 7.59492 44.7478 7.47523 44.7662 7.34635C44.9872 5.53277 43.302 4.43726 43.302 4.43726C43.302 4.43726 43.3941 4.78711 43.3941 5.29344C43.3941 5.40391 43.3941 5.51435 43.3849 5.63403C43.3757 5.79053 43.3572 5.95628 43.3296 6.13119C43.3204 6.19563 43.3112 6.25087 43.2928 6.31531C43.1639 6.89528 42.8876 7.51206 42.3443 8.03679C42.1693 8.2025 41.9667 8.35901 41.7273 8.50631C41.5431 8.61678 41.3773 8.72727 41.2208 8.84695C39.8763 9.8596 39.6737 10.9459 39.6553 11.3786C39.6645 11.5075 39.6737 11.5811 39.6737 11.5811Z",
    fill: "url(#paint296_radial_578_447528)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5654 8.08259C43.2285 7.55785 43.7902 6.24141 43.5968 5.00781C43.5968 5.00781 45.5123 6.70173 43.7165 8.5245L42.5654 8.08259Z",
    fill: "url(#paint297_radial_578_447528)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8124 9.95168C44.8124 9.95168 41.8471 9.16917 39.6738 11.5167C39.6738 11.5167 43.5323 6.96894 44.8124 9.95168Z",
    fill: "url(#paint298_radial_578_447528)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4121 5.48606C43.8081 5.73462 44.4435 6.27777 44.7566 7.5574C44.7566 7.56661 44.7106 7.75069 44.7198 7.75069C44.7198 7.75069 44.7842 7.51133 44.7842 7.38245C44.7842 7.38245 44.7842 7.37325 44.7842 7.34564C44.7658 7.15231 44.6001 6.10285 43.4213 5.29272C43.4121 5.4032 43.4213 5.36638 43.4121 5.48606Z",
    fill: "url(#paint299_radial_578_447528)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3115 6.32403C43.9377 6.63703 44.4903 7.57607 44.656 7.87987C44.6929 7.94431 44.7113 7.97193 44.7113 7.97193L44.7481 7.87987C44.7297 7.84305 44.7113 7.79699 44.6836 7.76017C44.1219 6.71069 43.6338 6.28724 43.3391 6.13074C43.3391 6.20439 43.3207 6.25958 43.3115 6.32403Z",
    fill: "url(#paint300_radial_578_447528)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8166 8.80996C44.4336 8.11952 45.5202 6.34277 43.3377 4.43713C43.3377 4.43713 46.1004 6.19549 44.056 8.87442C44.056 8.87442 44.9861 9.11376 44.8111 9.96071C44.8111 9.96071 44.3875 9.05856 43.5587 9.03094C43.5587 9.03094 41.0999 9.21504 39.7646 11.5902C39.7646 11.581 40.354 9.44517 43.8166 8.80996Z",
    fill: "url(#paint301_radial_578_447528)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6833 7.24451C44.6833 7.24451 44.2597 5.95571 43.4125 5.48621L43.4033 5.64268C43.4033 5.64268 44.269 6.02934 44.6465 7.44706L44.6833 7.24451Z",
    fill: "url(#paint302_radial_578_447528)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5454 7.68686C44.5454 7.68686 43.9284 6.60978 43.3022 6.31519L43.293 6.43484C43.293 6.43484 44.2139 7.09769 44.5085 7.8802L44.5454 7.68686Z",
    fill: "url(#paint303_radial_578_447528)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7297 8.72712C44.7297 8.72712 44.6929 8.81919 44.0482 8.87442C44.0482 8.87442 46.2031 6.5545 43.3115 4.43713C43.3115 4.43713 46.0834 5.80883 44.7297 8.72712Z",
    fill: "url(#paint304_radial_578_447528)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2393 8.85588C41.6168 9.01238 42.0312 9.24255 42.0312 9.24255C42.4456 8.93875 43.5967 8.68098 43.5967 8.68098C43.3481 8.53368 42.7679 8.24831 42.3627 8.04578C42.1878 8.21148 41.9852 8.36799 41.7457 8.51529C41.5616 8.62576 41.3866 8.73621 41.2393 8.85588Z",
    fill: "url(#paint305_radial_578_447528)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0218 9.2425L41.2299 8.85583C41.2299 8.85583 40.7418 9.26092 40.6221 9.38981C40.6221 9.38981 41.147 9.50948 41.2575 9.61074C41.2759 9.61995 41.8561 9.27933 42.0218 9.2425Z",
    fill: "url(#paint306_radial_578_447528)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1968 35.3047V37.7811L42.9238 35.0377L42.9515 33.2241L47.1968 33.8778V35.3047Z",
    fill: "url(#paint307_radial_578_447528)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9238 35.0378L47.1968 37.1V37.7812L42.9238 35.0378Z",
    fill: "url(#paint308_radial_578_447528)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9607 34.5773L47.1968 36.308V37.0997L42.9238 35.0376L42.9607 34.5773Z",
    fill: "url(#paint309_radial_578_447528)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9609 34.5775L43.2372 34.0988L47.197 35.3047V36.3082L42.9609 34.5775Z",
    fill: "url(#paint310_radial_578_447528)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1965 35.3047L43.2366 34.0987L42.9512 33.2241L47.1965 33.8778V35.3047Z",
    fill: "url(#paint311_radial_578_447528)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1961 35.3048L43.2363 34.0988V33.9791L47.1961 35.1483V35.3048Z",
    fill: "url(#paint312_radial_578_447528)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M47.197 36.308L42.9609 34.5773V34.4668L47.197 36.1883V36.308Z",
    fill: "url(#paint313_radial_578_447528)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9238 35.0378L47.1968 36.9619V37.1L42.9238 35.0378Z",
    fill: "url(#paint314_radial_578_447528)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1968 37.7812L42.9238 35.0378L47.1968 37.6523V37.7812Z",
    fill: "url(#paint315_radial_578_447528)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5955 31.1526C38.5955 31.1526 38.1166 34.209 40.3636 34.6049C42.1778 34.9271 43.8998 34.1998 43.8998 34.1998C43.8998 34.1998 41.8094 32.4323 40.7596 31.1434C39.7282 29.873 38.5955 31.1526 38.5955 31.1526Z",
    fill: "url(#paint316_radial_578_447528)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9911 31.3736C38.9911 31.3736 38.5859 33.9697 40.4922 34.3103C42.0301 34.5865 43.5035 33.9697 43.5035 33.9697C43.5035 33.9697 41.7262 32.4691 40.8421 31.3736C39.9581 30.2781 38.9911 31.3736 38.9911 31.3736Z",
    fill: "url(#paint317_radial_578_447528)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2935 34.384C41.2935 34.384 39.3597 34.6049 39.1018 32.9294C39.0926 32.9294 39.332 34.4024 41.2935 34.384Z",
    fill: "url(#paint318_radial_578_447528)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0968 30.9778C40.0968 30.9778 39.3416 30.9042 39.0009 31.3737C39.0009 31.3737 38.9364 31.9076 38.9733 32.2482C38.9733 32.2482 38.9365 31.567 39.1667 31.3369C39.3969 31.1067 39.8573 30.9778 40.0968 30.9778Z",
    fill: "url(#paint319_radial_578_447528)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5041 33.9513C43.5041 33.9513 42.841 34.3656 41.4873 34.384C41.4873 34.3932 42.5095 34.2827 43.5041 33.9513Z",
    fill: "url(#paint320_radial_578_447528)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M40.061 33.6568C40.2175 33.7857 40.4109 33.8778 40.678 33.9238C40.945 33.9698 41.2029 33.9882 41.4515 33.979C42.3079 33.9514 42.9894 33.666 42.9894 33.666C42.9894 33.666 42.7408 33.4543 42.4 33.1505C41.9396 32.7362 41.3318 32.1563 40.945 31.6775C40.8161 31.521 40.6872 31.4197 40.5675 31.3645C40.0149 31.1159 39.5361 31.6775 39.5361 31.6775C39.5361 31.6775 39.5269 31.7512 39.5176 31.8708C39.4624 32.2667 39.4808 33.1873 40.061 33.6568Z",
    fill: "url(#paint321_radial_578_447528)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M39.793 32.0367L40.281 33.1598L41.3309 33.4084L42.3899 33.1506C41.9294 32.7363 41.3216 32.1564 40.9349 31.6777C40.8059 31.5212 40.677 31.4199 40.5573 31.3646L39.793 32.0367Z",
    fill: "url(#paint322_radial_578_447528)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0606 33.6567L40.2908 33.1504L39.8028 32.0273L39.4989 31.8616C39.462 32.2666 39.4805 33.1872 40.0606 33.6567Z",
    fill: "url(#paint323_radial_578_447528)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3311 33.3989L41.4324 33.9789C42.2888 33.9513 42.9702 33.6659 42.9702 33.6659C42.9702 33.6659 42.7216 33.4542 42.3809 33.1504L41.3311 33.3989Z",
    fill: "url(#paint324_radial_578_447528)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5487 31.3553L39.858 32.0458L40.2172 33.0216L39.766 32.0734L39.4805 31.8708L39.8028 31.9629L40.5487 31.3553Z",
    fill: "url(#paint325_radial_578_447528)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3902 33.1413L41.414 33.4819L41.4416 33.979L41.2851 33.4635L40.2905 33.2149L40.0603 33.6568L40.2169 33.1689L39.7656 32.0734L40.2905 33.1413L41.3311 33.399L42.3902 33.1413Z",
    fill: "url(#paint326_radial_578_447528)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2483 33.6476L41.3312 33.9422C41.3312 33.9422 40.53 33.933 40.2354 33.6937L40.3551 33.4451C40.3459 33.4359 40.9168 33.6844 41.2483 33.6476Z",
    fill: "url(#paint327_radial_578_447528)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7469 32.2209C39.7469 32.2577 39.9035 32.6812 39.9035 32.6812C39.9035 32.6812 39.6641 33.0862 39.6641 33.0034C39.6641 32.9666 39.5352 32.4878 39.5444 32.2577C39.5628 32.0275 39.7469 32.2209 39.7469 32.2209Z",
    fill: "url(#paint328_radial_578_447528)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1968 35.3049L42.9238 34.0068L42.933 34.191L47.1968 35.4614V35.3049Z",
    fill: "url(#paint329_radial_578_447528)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9608 34.5773L47.1969 36.308V36.5105L42.9424 34.6969L42.9608 34.5773Z",
    fill: "url(#paint330_radial_578_447528)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1968 37.1L42.9238 35.0378L47.1968 37.2841V37.1Z",
    fill: "url(#paint331_radial_578_447528)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1958 37.6336L46.1184 34.7706L44.9949 35.0099C44.9949 35.0099 44.0924 34.3471 43.1623 34.5588L42.4072 33.9329L47.1958 34.3379V37.6336Z",
    fill: "url(#paint332_radial_578_447528)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2607 27.7924C32.2976 27.8844 33.4855 30.7935 35.8522 31.0789C38.2557 31.3735 40.0699 30.5173 40.0699 30.5173C40.0699 30.5173 39.1213 29.8637 38.2833 29.4494C38.2833 29.4494 37.1691 29.4955 35.843 29.3021C34.5722 29.118 33.0895 28.7037 32.2607 27.7924Z",
    fill: "url(#paint333_radial_578_447528)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2607 27.8016C32.2976 27.8937 33.4855 30.8028 35.8522 31.079C38.2557 31.3736 40.0699 30.5174 40.0699 30.5174C40.0699 30.5174 39.1213 29.8638 38.2833 29.4495C38.2833 29.4495 37.1691 29.4955 35.843 29.3022C36.1561 29.7257 36.8468 30.4621 36.8468 30.4621C33.6697 30.2964 32.2976 27.8753 32.2607 27.8016Z",
    fill: "url(#paint334_radial_578_447528)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3384 30.2133C41.5155 31.6863 41.9483 33.5643 41.9483 33.5643L42.8507 34.1903C44.1216 34.1903 45.1069 34.6138 45.1069 34.6138L46.4422 34.5586L47.1881 35.3135C47.1881 35.3135 47.1881 35.1662 47.1881 34.936C47.1973 34.623 47.1789 34.1627 47.1881 33.6932C47.1973 32.9015 47.2157 32.1006 47.1881 32.0177C47.1881 32.0177 46.0462 32.1282 44.7754 31.539C42.8415 30.646 41.7917 28.8693 41.7457 28.814C42.2061 31.4101 44.407 33.2329 44.407 33.2329C44.3426 33.2237 43.4033 32.9844 42.6758 32.5977C42.0035 32.2387 41.3497 30.4435 38.4121 28.6575C38.0805 28.455 37.7122 28.2525 37.3162 28.0408C32.6565 25.6748 32.767 21.7715 32.767 21.7715C31.312 28.5102 34.8851 28.6299 38.3384 30.2133Z",
    fill: "url(#paint335_radial_578_447528)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3384 30.2133C41.5155 31.6863 41.9483 33.5643 41.9483 33.5643C41.9483 33.5643 41.718 31.631 38.8817 29.8451C36.6255 28.4182 31.9198 28.0039 32.767 21.7715C31.312 28.5102 34.8851 28.6299 38.3384 30.2133Z",
    fill: "url(#paint336_radial_578_447528)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4169 33.2239C44.4169 33.2239 46.1482 34.2642 47.198 34.6876C47.198 34.6876 45.568 34.1813 43.9473 33.1594L44.4169 33.2239Z",
    fill: "url(#paint337_radial_578_447528)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7549 28.8049C41.7917 28.9062 43.127 32.1743 47.1973 33.6933C47.2065 32.9016 47.225 32.1007 47.1973 32.0178C47.1973 32.0178 46.0554 32.1283 44.7846 31.5391C42.8507 30.6369 41.7917 28.8602 41.7549 28.8049Z",
    fill: "url(#paint338_radial_578_447528)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1981 34.9267L46.4521 34.5585L47.1981 35.3042V34.9451V34.9267Z",
    fill: "url(#paint339_radial_578_447528)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M41.958 33.5743L42.8605 34.2004C44.1313 34.2004 45.1167 34.6239 45.1167 34.6239L46.4519 34.5686L45.1075 34.3477C45.1075 34.3477 44.1313 33.7032 43.192 33.915L41.958 33.5743Z",
    fill: "url(#paint340_radial_578_447528)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7435 28.8971C40.3827 29.9282 41.7916 32.6899 42.2152 32.8372C42.6296 32.9753 44.3425 33.2147 44.4162 33.2239C44.3517 33.2147 43.4124 32.9753 42.6849 32.5887C42.0126 32.2296 41.3588 30.4345 38.4212 28.6485C38.2554 28.5749 38.3199 28.6301 38.7435 28.8971Z",
    fill: "url(#paint341_radial_578_447528)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M40.033 30.6833C40.033 30.6833 39.0753 29.4957 36.5244 28.7408C36.5152 28.7408 38.6241 29.5786 40.033 30.6833Z",
    fill: "url(#paint342_radial_578_447528)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7789 28.336C35.7789 28.336 32.6939 27.3786 32.6387 23.5305C32.6479 23.5397 32.8505 27.0195 35.7789 28.336Z",
    fill: "url(#paint343_radial_578_447528)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7549 28.8049C41.7549 28.8049 43.2007 31.6128 45.2082 32.6438C45.2174 32.6438 43.0349 31.8889 41.7549 28.8049Z",
    fill: "url(#paint344_radial_578_447528)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0201 33.1871C44.0201 33.1871 42.3717 33.0398 42.1507 32.9109C41.9297 32.7821 40.8154 30.9132 40.1523 30.2412C40.1523 30.2412 41.4048 31.7418 42.2151 32.7544C42.5835 32.9846 44.0201 33.1871 44.0201 33.1871Z",
    fill: "url(#paint345_radial_578_447528)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1574 34.4668C46.1574 34.4668 45.4115 34.4023 45.0708 34.4023C44.8774 34.2735 44.5274 33.9881 43.8828 33.8684C43.8828 33.8684 44.8497 34.0617 45.1076 34.3379C45.522 34.3103 46.1574 34.4668 46.1574 34.4668Z",
    fill: "url(#paint346_radial_578_447528)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0847 33.9052C44.0847 33.9052 43.4217 33.8315 43.1822 33.9788L41.9482 33.5646L43.1362 33.8683C43.1362 33.8776 43.6519 33.7671 44.0847 33.9052Z",
    fill: "url(#paint347_radial_578_447528)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8604 34.1996L43.1827 33.9879C43.1827 33.9879 44.0851 33.6196 45.0613 34.4113L45.1073 34.6231C45.1165 34.6139 43.8917 34.1444 42.8604 34.1996Z",
    fill: "url(#paint348_radial_578_447528)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0798 34.3291L43.5051 33.1968L42.1514 32.9207L43.1091 33.8688C43.1091 33.8688 44.0116 33.5651 45.0798 34.3291Z",
    fill: "url(#paint349_radial_578_447528)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7305 28.3906C32.7305 28.3906 33.7066 29.7807 36.0088 30.3607C36.0088 30.3607 34.0381 30.3147 32.7305 28.3906Z",
    fill: "url(#paint350_radial_578_447528)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2804 8.34937C42.2804 8.34937 40.0242 9.4357 39.6651 11.5163C39.6651 11.5163 39.5638 10.0064 41.4055 8.7176C41.4147 8.7176 42.1975 8.4046 42.2804 8.34937Z",
    fill: "url(#paint351_radial_578_447528)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M47.078 32.1012C53.5829 32.1012 58.8561 26.8296 58.8561 20.3268C58.8561 13.8239 53.5829 8.55237 47.078 8.55237C40.5731 8.55237 35.2998 13.8239 35.2998 20.3268C35.2998 26.8296 40.5731 32.1012 47.078 32.1012Z",
    fill: "url(#paint352_radial_578_447528)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0774 32.046C53.5518 32.046 58.8003 26.7992 58.8003 20.3268C58.8003 13.8545 53.5518 8.60767 47.0774 8.60767C40.603 8.60767 35.3545 13.8545 35.3545 20.3268C35.3545 26.7992 40.603 32.046 47.0774 32.046Z",
    fill: "url(#paint353_radial_578_447528)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3254 32.1288C53.7998 32.1288 59.0483 26.8819 59.0483 20.4096C59.0483 13.9373 53.7998 8.69043 47.3254 8.69043C40.8511 8.69043 35.6025 13.9373 35.6025 20.4096C35.6025 26.8819 40.8511 32.1288 47.3254 32.1288Z",
    fill: "url(#paint354_radial_578_447528)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3144 13.7628L39.8485 14.6834L38.5869 16.8652L37.7305 16.2024C37.7305 16.2116 38.283 14.4901 39.3144 13.7628Z",
    fill: "url(#paint355_radial_578_447528)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5701 20.3268C36.5701 13.855 41.2758 8.60767 47.0774 8.60767C40.6035 8.60767 35.3545 13.855 35.3545 20.3268C35.3545 26.7986 40.6035 32.046 47.0774 32.046C41.2758 32.046 36.5701 26.7986 36.5701 20.3268Z",
    fill: "url(#paint356_radial_578_447528)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0771 8.60767C52.8787 8.60767 57.5845 13.855 57.5845 20.3268C57.5845 26.7986 52.8787 32.046 47.0771 32.046C53.551 32.046 58.8001 26.7986 58.8001 20.3268C58.8001 13.855 53.551 8.60767 47.0771 8.60767Z",
    fill: "url(#paint357_radial_578_447528)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M39.71 13.3674L40.1704 14.1591C40.1704 14.1591 44.3328 9.52852 49.895 11.25L50.291 10.1269C50.3002 10.1269 43.679 7.74257 39.71 13.3674Z",
    fill: "url(#paint358_radial_578_447528)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9178 23.6228C55.9178 23.6228 54.205 29.7724 47.0957 29.7724V30.8955C47.0957 30.8955 53.3301 32.0186 56.5072 24.8104L55.9178 23.6228Z",
    fill: "url(#paint359_radial_578_447528)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3254 17.7861C52.1877 17.7861 56.3501 20.7412 58.1275 24.9483C58.7168 23.549 59.0483 22.0117 59.0483 20.4006C59.0483 13.9288 53.7993 8.6814 47.3254 8.6814C40.8516 8.6814 35.6025 13.9288 35.6025 20.4006C35.6025 22.0117 35.9248 23.549 36.5234 24.9483C38.3007 20.7504 42.4632 17.7861 47.3254 17.7861Z",
    fill: "url(#paint360_radial_578_447528)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3226 11.2587L50.9266 16.9204L56.5901 16.7362L52.3171 20.4554L56.4519 24.3312L50.7977 23.9353L50.9819 29.6062L47.2523 25.3254L43.3753 29.4681L43.7713 23.8064L38.0986 23.9906L42.3808 20.2713L38.2368 16.3956L43.9002 16.7915L43.716 11.1206L47.4364 15.4014L51.3226 11.2587Z",
    fill: "url(#paint361_radial_578_447528)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1791 29.1462C52.0463 29.1462 55.992 25.2018 55.992 20.3361C55.992 15.4704 52.0463 11.526 47.1791 11.526C42.3119 11.526 38.3662 15.4704 38.3662 20.3361C38.3662 25.2018 42.3119 29.1462 47.1791 29.1462Z",
    fill: "url(#paint362_radial_578_447528)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1791 29.1462C52.0463 29.1462 55.992 25.2018 55.992 20.3361C55.992 15.4704 52.0463 11.526 47.1791 11.526C42.3119 11.526 38.3662 15.4704 38.3662 20.3361C38.3662 25.2018 42.3119 29.1462 47.1791 29.1462Z",
    fill: "url(#paint363_radial_578_447528)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1797 28.8979C42.3542 28.8979 38.4404 25.0222 38.376 20.2167C38.376 20.2535 38.376 20.2995 38.376 20.3363C38.376 25.1971 42.3266 29.1465 47.1889 29.1465C52.0512 29.1465 56.0018 25.1971 56.0018 20.3363C56.0018 20.2995 56.0018 20.2535 56.0018 20.2167C55.9189 25.0222 52.0051 28.8979 47.1797 28.8979Z",
    fill: "url(#paint364_radial_578_447528)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1795 11.8297C51.9958 11.8297 55.9003 15.6962 55.9832 20.4833C55.9832 20.4373 55.9832 20.382 55.9832 20.336C55.9832 15.4753 52.0326 11.5259 47.1703 11.5259C42.308 11.5259 38.3574 15.4753 38.3574 20.336C38.3574 20.382 38.3574 20.4373 38.3574 20.4833C38.4403 15.6962 42.3541 11.8297 47.1795 11.8297Z",
    fill: "url(#paint365_radial_578_447528)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8808 20.3362L53.3299 26.4949L47.1784 29.045L41.0177 26.4949L38.4668 20.3362L38.9088 19.2499L41.0177 14.1774L47.1784 11.6273L53.3299 14.1774L55.4296 19.2499L55.8808 20.3362Z",
    fill: "url(#paint366_radial_578_447528)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1787 13.2568L42.1691 15.3282L40.0879 20.3362L42.1691 25.3442L47.1787 27.4156L52.1884 25.3442L54.2511 20.3362L52.1884 15.3282L47.1787 13.2568Z",
    fill: "url(#paint367_radial_578_447528)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1787 11.6273V15.1808L50.8162 16.6906L53.3302 14.1774L47.1787 11.6273Z",
    fill: "url(#paint368_radial_578_447528)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3267 20.3364H55.8813L53.3304 26.486L50.8164 23.982L52.3267 20.3364Z",
    fill: "url(#paint369_radial_578_447528)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0177 14.1776L43.5225 16.6908L42.0214 20.3364H38.4668L41.0177 14.1776Z",
    fill: "url(#paint370_radial_578_447528)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0176 26.4859C41.0268 26.5227 43.5316 23.9727 43.5316 23.9727L47.1783 25.4824V29.0359L41.0176 26.4859Z",
    fill: "url(#paint371_radial_578_447528)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4668 20.3364H42.0214L43.5225 23.982L41.0177 26.486L38.4668 20.3364Z",
    fill: "url(#paint372_radial_578_447528)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1787 25.4917V29.0452L53.3302 26.4859L50.8162 23.9819L47.1787 25.4917Z",
    fill: "url(#paint373_radial_578_447528)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1785 15.1807L43.5225 16.6904L42.0215 20.336L43.5225 23.9816L47.1785 25.4913L50.816 23.9816L52.3262 20.336L50.816 16.6904L47.1785 15.1807Z",
    fill: "url(#paint374_radial_578_447528)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4299 19.2499H38.9092L41.018 14.1774L47.1788 11.6273L53.3303 14.1774L55.4299 19.2499Z",
    fill: "url(#paint375_radial_578_447528)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1787 11.6273V12.6032L52.7685 14.7573L54.951 20.3086L55.8811 20.3362L53.3302 14.1774L47.1787 11.6273Z",
    fill: "url(#paint376_radial_578_447528)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4061 20.3917L41.7452 25.7311L47.1231 28.0234L47.1784 29.0453L41.0177 26.486L38.4668 20.3364L39.4061 20.3917Z",
    fill: "url(#paint377_radial_578_447528)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1784 11.6273L47.0495 15.0612L43.5225 16.6906L47.206 15.3649L50.8159 16.6906L47.3257 15.0612L47.1784 11.6273Z",
    fill: "url(#paint378_radial_578_447528)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1784 28.9989L47.2981 25.5743L50.8159 23.9357L47.1508 25.2613L43.5225 23.9357L47.0218 25.5743L47.1784 28.9989Z",
    fill: "url(#paint379_radial_578_447528)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8627 20.3181L52.437 20.1893L50.7979 16.6726L52.1331 20.3458L50.7979 23.9637L52.437 20.4654L55.8627 20.3181Z",
    fill: "url(#paint380_radial_578_447528)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4941 20.3181L41.9106 20.4378L43.5498 23.9637L42.2237 20.2905L43.5498 16.6726L41.9106 20.1709L38.4941 20.3181Z",
    fill: "url(#paint381_radial_578_447528)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3117 26.4582L50.9818 23.945L52.3171 20.2994L50.6595 23.8345L47.1602 25.4548L50.7885 24.1383L53.3117 26.4582Z",
    fill: "url(#paint382_radial_578_447528)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0273 14.1776L43.3664 16.6816L42.0403 20.3364L43.6887 16.7921L47.1881 15.1811L43.5598 16.4975L41.0273 14.1776Z",
    fill: "url(#paint383_radial_578_447528)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3117 14.1776L50.8069 16.5067L47.1602 15.1811L50.6964 16.8381L52.3171 20.3364L51.0003 16.7092L53.3117 14.1776Z",
    fill: "url(#paint384_radial_578_447528)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0273 26.4582L43.5414 24.1199L47.1881 25.4548L43.6519 23.8069L42.0403 20.2994L43.348 23.9358L41.0273 26.4582Z",
    fill: "url(#paint385_radial_578_447528)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3388 38.8401C58.3388 38.8401 57.9244 40.129 57.8691 41.6663C57.8691 41.6663 47.6196 47.0426 47.1684 47.9908C46.9382 47.4937 44.019 45.7906 41.2839 44.2716C38.7975 42.8907 36.4677 41.6755 36.4677 41.6755C36.4124 40.1289 35.998 38.8493 35.998 38.8493L39.8197 35.7745C40.934 37.7722 42.1588 38.3062 42.1588 38.3062L40.4828 38.5179C44.7189 41.6755 47.1592 41.0495 47.1592 41.0495C47.1592 41.0495 49.5996 41.6847 53.8356 38.5179L52.1596 38.3062C52.1596 38.3062 53.3844 37.7814 54.4987 35.7745L58.3388 38.8401Z",
    fill: "url(#paint386_radial_578_447528)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M54.527 35.7745C53.4127 37.7722 52.188 38.3062 52.188 38.3062L53.864 38.5179C49.6279 41.6755 47.1875 41.0495 47.1875 41.0495C47.1875 41.0495 44.7472 41.6847 40.5111 38.5179L42.1871 38.3062C42.1871 38.3062 40.9623 37.7814 39.8481 35.7745L36.0264 38.8493C36.0264 38.8493 36.4408 40.1381 36.496 41.6755C36.496 41.6755 46.7455 47.0518 47.1967 48C47.648 47.0518 57.8975 41.6755 57.8975 41.6755C57.9527 40.1289 58.3671 38.8493 58.3671 38.8493L54.527 35.7745Z",
    fill: "url(#paint387_radial_578_447528)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1784 45.2103V47.9905C46.9482 47.4933 44.029 45.7902 41.2939 44.2713L41.6715 40.8098L47.1784 45.2103Z",
    fill: "url(#paint388_radial_578_447528)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8085 31.5766L54.821 32.9851C53.6883 34.9552 52.4359 35.4983 52.3807 35.5075L54.1211 35.7193C49.7009 38.8769 47.1684 38.2417 47.1684 38.2417C47.1684 38.2417 44.6268 38.8769 40.2157 35.7193L41.9562 35.5075C41.9102 35.4891 40.6578 34.946 39.5159 32.9851L35.5284 31.5766L34.7549 31.3004C34.7549 31.3004 35.2337 33.6019 35.6021 35.7101C35.8415 37.0725 36.0349 38.3522 36.0349 38.8769C36.0349 38.8769 46.708 44.2532 47.1684 45.2014C47.6289 44.2532 58.302 38.8769 58.302 38.8769C58.302 38.343 58.4954 37.0633 58.7348 35.7101C59.1032 33.6019 59.582 31.3004 59.582 31.3004L58.8085 31.5766Z",
    fill: "url(#paint389_radial_578_447528)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7404 39.5398C57.7404 39.5398 54.9317 42.1359 54.4436 43.1761L49.6826 45.6986C49.6826 45.6986 54.3791 42.5501 54.6554 41.1508L57.7404 39.5398Z",
    fill: "url(#paint390_radial_578_447528)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2632 34.4855L54.1213 35.7283L52.3809 35.5165C52.4453 35.5073 54.5081 35.0931 55.2632 34.4855Z",
    fill: "url(#paint391_radial_578_447528)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5918 44.6951C47.5918 44.6951 54.5169 40.5524 56.3771 39.8159C56.3863 39.8159 49.4612 43.8113 47.5918 44.6951Z",
    fill: "url(#paint392_radial_578_447528)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8212 32.985C54.8212 32.985 53.7806 34.8722 52.3809 35.5074C52.3809 35.5074 54.195 35.2865 55.2632 34.4764C55.2632 34.4764 53.7346 35.0655 53.2649 35.1116C53.2741 35.1208 54.9962 33.4177 54.8212 32.985Z",
    fill: "url(#paint393_radial_578_447528)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9004 41.1966C53.9004 41.1966 56.9577 39.2542 58.1365 38.8583C58.1365 38.8583 58.4772 34.7248 59.5823 31.291C59.5823 31.291 58.4404 36.5016 58.3391 38.8767C58.3391 38.8767 57.8602 40.1932 57.8694 41.6569C57.8694 41.6569 57.9983 39.8617 58.1181 39.1437C58.1181 39.1529 56.175 39.9722 53.9004 41.1966Z",
    fill: "url(#paint394_radial_578_447528)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M58.496 35.3049C58.496 35.3049 52.9522 38.3981 50.3369 39.0334L50.7421 37.3486C50.7421 37.3486 55.1716 36.5293 57.0962 32.0461C57.0962 32.0461 58.9104 31.4568 59.5458 31.0518C59.5458 31.0426 58.7354 33.786 58.496 35.3049Z",
    fill: "url(#paint395_radial_578_447528)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6152 39.5398C36.6152 39.5398 39.4239 42.1359 39.912 43.1761L44.673 45.6986C44.673 45.6986 39.9765 42.5501 39.7002 41.1508L36.6152 39.5398Z",
    fill: "url(#paint396_radial_578_447528)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M35.832 35.3507C36.0715 36.7132 36.2649 37.9928 36.2649 38.5175C36.2649 38.5175 46.4775 43.8938 46.9379 44.8421V40.5797C44.1384 39.5578 40.6943 37.91 35.832 35.3507Z",
    fill: "url(#paint397_radial_578_447528)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0742 34.4855L40.2161 35.7283L41.9566 35.5165C41.9013 35.5073 39.8386 35.0931 39.0742 34.4855Z",
    fill: "url(#paint398_radial_578_447528)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M39.525 32.985C39.525 32.985 40.5656 34.8722 41.9654 35.5074C41.9654 35.5074 40.1512 35.2865 39.083 34.4764C39.083 34.4764 40.6117 35.0655 41.0813 35.1116C41.0721 35.1208 39.3501 33.4177 39.525 32.985Z",
    fill: "url(#paint399_radial_578_447528)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4742 41.0954C40.4742 41.0954 37.3892 39.3647 36.1644 38.9964C36.1644 38.9964 35.8697 34.7524 34.7646 31.3186C34.7646 31.3186 35.9065 36.5292 36.0078 38.9044C36.0078 38.9044 36.4867 40.2208 36.4775 41.6845C36.4775 41.6845 36.3486 39.8894 36.2289 39.1713C36.2289 39.1529 38.1904 39.8618 40.4742 41.0954Z",
    fill: "url(#paint400_radial_578_447528)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M35.832 35.3049C35.832 35.3049 41.3758 38.3981 43.9911 39.0334L43.5859 37.3486C43.5859 37.3486 39.1565 36.5293 37.2318 32.0461C37.2318 32.0461 35.4176 31.4568 34.7822 31.0518C34.7822 31.0426 35.5926 33.786 35.832 35.3049Z",
    fill: "url(#paint401_radial_578_447528)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M53.652 37.6387C53.6365 37.6619 53.6365 37.6921 53.652 37.7153C53.8504 38.0112 54.0728 38.2947 54.3134 38.5601C54.3266 38.5732 54.3398 38.593 54.3596 38.6062C54.4323 38.6853 54.5115 38.7643 54.5908 38.8434C54.7757 39.0279 54.9606 39.1993 55.1653 39.3574C55.3452 39.506 55.5309 39.6429 55.7279 39.7736C55.7511 39.7891 55.7813 39.7891 55.8043 39.7733C56.1234 39.5541 56.6152 39.1355 57.0283 38.717C57.3929 38.3477 57.7655 37.8523 57.8704 37.7101C57.8879 37.6863 57.8882 37.6543 57.8713 37.6301C57.8044 37.5346 57.634 37.2932 57.5296 37.163C57.3447 36.9323 57.1465 36.7083 56.9418 36.4974C56.8295 36.3854 56.7173 36.2799 56.5984 36.1745C56.346 35.9541 56.0815 35.7518 55.805 35.5618C55.7816 35.5457 55.7508 35.5455 55.7273 35.5613C55.5231 35.6984 55.3252 35.8417 55.1389 35.9966C54.9474 36.1547 54.7691 36.3195 54.5974 36.4908C54.2388 36.855 53.9236 37.2317 53.652 37.6387Z",
    fill: "#450D63"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1741 37.6746C54.3266 37.9054 54.4988 38.1264 54.6857 38.3326C54.6955 38.3424 54.7053 38.3572 54.7201 38.367C54.7742 38.4259 54.8332 38.4849 54.8922 38.5438C55.03 38.6813 55.1677 38.809 55.3202 38.9268C55.4628 39.0447 55.6104 39.1527 55.7677 39.2558C56.0038 39.0987 56.2252 38.9268 56.4367 38.7402C56.7761 38.4357 57.0761 38.092 57.3319 37.709C57.3417 37.6942 57.3515 37.6844 57.3564 37.6697C57.2679 37.542 57.1794 37.4143 57.081 37.2916C56.9433 37.1197 56.7957 36.9527 56.6433 36.7956C56.5596 36.7121 56.476 36.6335 56.3875 36.555C56.1907 36.3831 55.9842 36.2259 55.7677 36.0786C55.6054 36.1866 55.448 36.2996 55.3005 36.4224C55.1578 36.5402 55.025 36.663 54.8972 36.7907C54.6217 37.0706 54.3807 37.3603 54.1741 37.6746Z",
    fill: "url(#paint402_radial_578_447528)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M54.174 37.6749H55.7627V36.0936C55.4479 36.2999 55.1528 36.5405 54.8872 36.8057C54.6216 37.0709 54.3806 37.3606 54.174 37.6749Z",
    fill: "url(#paint403_radial_578_447528)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7629 36.0936V37.6798H57.3516C57.145 37.3655 56.904 37.0709 56.6384 36.8057C56.3678 36.5405 56.0777 36.2999 55.7629 36.0936Z",
    fill: "url(#paint404_radial_578_447528)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7629 37.6749V39.2611C56.3924 38.8437 56.9335 38.3035 57.3516 37.6749H55.7629Z",
    fill: "url(#paint405_radial_578_447528)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M54.174 37.6749C54.3806 37.9892 54.6216 38.2839 54.8872 38.549C55.1528 38.8142 55.4479 39.0548 55.7627 39.2611V37.6749H54.174Z",
    fill: "url(#paint406_radial_578_447528)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M54.174 37.6746C54.3806 37.9889 54.6216 38.2836 54.8872 38.5487C55.1528 38.8139 55.448 39.0545 55.7627 39.2608C55.9988 39.1036 56.0824 39.0496 56.2939 38.863L55.2955 36.4371C55.1528 36.555 55.02 36.6778 54.8922 36.8054C54.6216 37.0706 54.3806 37.3603 54.174 37.6746Z",
    fill: "url(#paint407_radial_578_447528)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7154 38.3717C54.7695 38.4306 54.8285 38.4895 54.8875 38.5484C55.1531 38.8136 55.4483 39.0542 55.763 39.2605C55.9991 39.1034 56.2205 38.9315 56.432 38.7449C56.7714 38.4404 57.0714 38.0967 57.3271 37.7136C56.6631 37.9101 55.6893 38.1801 54.7154 38.3717Z",
    fill: "url(#paint408_radial_578_447528)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6857 38.3328C54.6955 38.3427 54.7054 38.3574 54.7201 38.3672C54.7742 38.4261 54.8333 38.4851 54.8923 38.544C55.03 38.6815 55.1677 38.8092 55.3202 38.927C55.694 38.2641 56.1072 37.4686 56.1416 37.1592C56.1367 37.1641 55.3104 37.8467 54.6857 38.3328Z",
    fill: "url(#paint409_radial_578_447528)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7629 37.6749L57.0762 37.2968C56.9385 37.1249 56.7909 36.9579 56.6384 36.8008C56.5548 36.7173 56.4712 36.6388 56.3827 36.5602L55.7629 37.6749Z",
    fill: "url(#paint410_radial_578_447528)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7619 38.7211C56.1751 38.4461 56.5341 38.0925 56.8096 37.6751C56.5341 37.2626 56.18 36.9041 55.7619 36.6292C55.3488 36.9041 54.9897 37.2577 54.7143 37.6751C54.9897 38.0925 55.3438 38.4461 55.7619 38.7211Z",
    fill: "url(#paint411_radial_578_447528)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0761 37.3701C56.9384 37.1983 56.7908 37.0313 56.6384 36.8741C56.5548 36.7907 56.4711 36.7121 56.3826 36.6335C56.1859 36.4616 55.9793 36.3045 55.7629 36.1572C55.6005 36.2652 55.4432 36.3782 55.2956 36.5009C55.153 36.6188 55.0202 36.7416 54.8923 36.8692C54.6365 37.1246 54.4053 37.4045 54.2037 37.7041C54.1938 37.6893 54.1889 37.6795 54.1791 37.6648C54.3857 37.3505 54.6267 37.0558 54.8923 36.7907C55.0202 36.663 55.1579 36.5402 55.2956 36.4224C55.4432 36.2996 55.6005 36.1817 55.7629 36.0786C55.9793 36.221 56.1859 36.3831 56.3826 36.555C56.4711 36.6335 56.5548 36.7121 56.6384 36.7956C56.7958 36.9527 56.9433 37.1148 57.0761 37.2916C57.1745 37.4143 57.263 37.542 57.3516 37.6697C57.3417 37.6844 57.3368 37.6942 57.327 37.709C57.2434 37.596 57.1597 37.4831 57.0761 37.3701Z",
    fill: "url(#paint412_radial_578_447528)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6857 38.2592C54.6955 38.269 54.7053 38.2837 54.7201 38.2935C54.7742 38.3525 54.8332 38.4114 54.8922 38.4703C55.03 38.6078 55.1677 38.7355 55.3202 38.8534C55.4628 38.9712 55.6104 39.0792 55.7677 39.1824C56.0038 39.0252 56.2252 38.8534 56.4367 38.6667C56.7761 38.3623 57.0761 38.0185 57.3319 37.6355C57.3417 37.6502 57.3515 37.6601 57.3564 37.6748C57.3466 37.6895 57.3368 37.6993 57.3319 37.7141C57.0761 38.0922 56.7761 38.4359 56.4367 38.7453C56.2301 38.9319 56.0038 39.1087 55.7677 39.2609C55.6153 39.1578 55.4628 39.0498 55.3202 38.9319C55.1726 38.8092 55.03 38.6815 54.8922 38.5489C54.8332 38.49 54.7791 38.431 54.7201 38.3721C54.7102 38.3623 54.7004 38.3476 54.6857 38.3377C54.4988 38.1315 54.3315 37.9105 54.1741 37.6797C54.184 37.665 54.1938 37.6551 54.1987 37.6404C54.3463 37.8565 54.5086 38.0627 54.6857 38.2592Z",
    fill: "url(#paint413_radial_578_447528)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6381 36.8741C56.7906 37.0313 56.9382 37.1983 57.0759 37.3701L57.3035 37.6775C57.054 38.0437 56.7636 38.3734 56.4367 38.6667C56.2252 38.8533 56.0038 39.0252 55.7677 39.1823C55.6104 39.0792 55.4628 38.9712 55.3202 38.8533C55.1677 38.7355 55.03 38.6078 54.8922 38.4703C54.8332 38.4114 54.7742 38.3524 54.7201 38.2935C54.71 38.2868 54.7022 38.2778 54.6952 38.2696C54.6919 38.2658 54.6888 38.2622 54.6857 38.2591C54.5182 38.0734 54.3639 37.8788 54.2228 37.6754C54.4199 37.3867 54.6444 37.1164 54.892 36.8692C55.0199 36.7416 55.1527 36.6188 55.2954 36.5009C55.4429 36.3782 55.6003 36.2652 55.7626 36.1572C55.9791 36.3045 56.1856 36.4616 56.3824 36.6335C56.4709 36.7121 56.5545 36.7907 56.6381 36.8741ZM54.1817 37.6691C54.1808 37.6677 54.1798 37.6662 54.1789 37.6648C54.3854 37.3505 54.6264 37.0558 54.892 36.7907C55.0199 36.663 55.1576 36.5402 55.2954 36.4224C55.4429 36.2996 55.6003 36.1817 55.7626 36.0786C55.9791 36.221 56.1856 36.3831 56.3824 36.555C56.4709 36.6335 56.5545 36.7121 56.6381 36.7956C56.7955 36.9527 56.9431 37.1148 57.0759 37.2916C57.1663 37.4044 57.2484 37.5213 57.3298 37.6386C57.3305 37.6376 57.3312 37.6365 57.3319 37.6355C57.3348 37.6399 57.3377 37.6438 57.3405 37.6476C57.3471 37.6565 57.353 37.6644 57.3564 37.6748C57.3535 37.6792 57.3506 37.6831 57.3478 37.6869C57.3412 37.6958 57.3353 37.7037 57.3319 37.714C57.0761 38.0922 56.7761 38.4359 56.4367 38.7453C56.2301 38.9319 56.0038 39.1087 55.7677 39.2609C55.6153 39.1578 55.4628 39.0498 55.3202 38.9319C55.1726 38.8091 55.03 38.6815 54.8922 38.5489C54.8627 38.5194 54.8344 38.4899 54.8062 38.4605C54.7779 38.431 54.7496 38.4015 54.7201 38.3721C54.717 38.369 54.7139 38.3654 54.7106 38.3616C54.7035 38.3534 54.6957 38.3444 54.6857 38.3377C54.4988 38.1315 54.3315 37.9105 54.1741 37.6797C54.1767 37.6759 54.1792 37.6724 54.1817 37.6691Z",
    fill: "url(#paint414_radial_578_447528)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7627 36.6331C55.7627 36.6331 55.143 37.021 54.715 37.679C54.715 37.6741 55.02 36.9964 55.7627 36.6331Z",
    fill: "url(#paint415_radial_578_447528)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8057 37.6752C56.8057 37.6752 56.4368 38.3234 55.8121 38.7113L55.7629 39.1828L55.7285 38.7015C55.7285 38.7015 55.2612 38.5051 54.7153 37.6752C54.7153 37.6752 55.4039 38.5984 55.7728 38.6475C55.7728 38.6524 56.2007 38.4854 56.8057 37.6752Z",
    fill: "url(#paint416_radial_578_447528)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7578 38.7162C55.7578 38.7162 55.1086 38.3479 54.72 37.7242L54.2478 37.6751L54.7298 37.6408C54.7298 37.6408 54.9266 37.1742 55.7578 36.6292C55.7578 36.6292 54.8331 37.3166 54.7839 37.685C54.779 37.685 54.9462 38.1122 55.7578 38.7162Z",
    fill: "url(#paint417_radial_578_447528)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M55.782 36.6292C55.782 36.6292 56.4312 36.9975 56.8198 37.6211L57.292 37.6702L56.81 37.7046C56.81 37.7046 56.6132 38.1711 55.782 38.7162C55.782 38.7162 56.7067 38.0287 56.7559 37.6604C56.7608 37.6604 56.5936 37.2332 55.782 36.6292Z",
    fill: "url(#paint418_radial_578_447528)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7153 37.6696C54.7153 37.6696 55.0842 37.0214 55.7088 36.6334L55.758 36.162L55.7924 36.6432C55.7924 36.6432 56.2597 36.8397 56.8057 37.6696C56.8057 37.6696 56.1171 36.7464 55.7482 36.6973C55.7482 36.6923 55.3203 36.8593 54.7153 37.6696Z",
    fill: "url(#paint419_radial_578_447528)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3248 40.0326C49.3093 40.0558 49.3094 40.086 49.3249 40.1092C49.5232 40.4051 49.7456 40.6886 49.9862 40.954C49.9994 40.9672 50.0127 40.9869 50.0325 41.0001C50.1051 41.0792 50.1844 41.1583 50.2636 41.2373C50.4485 41.4219 50.6334 41.5932 50.8382 41.7514C51.018 41.8999 51.2037 42.0368 51.4007 42.1675C51.424 42.183 51.4541 42.183 51.4771 42.1672C51.7962 41.948 52.288 41.5295 52.7012 41.1109C53.0657 40.7416 53.4383 40.2462 53.5432 40.104C53.5608 40.0802 53.5611 40.0482 53.5441 40.024C53.4773 39.9286 53.3068 39.6871 53.2024 39.5569C53.0175 39.3263 52.8194 39.1022 52.6147 38.8913C52.5024 38.7793 52.3901 38.6739 52.2713 38.5684C52.0189 38.348 51.7544 38.1457 51.4779 37.9557C51.4545 37.9396 51.4237 37.9395 51.4001 37.9553C51.196 38.0923 50.998 38.2356 50.8118 38.3905C50.6202 38.5487 50.4419 38.7134 50.2702 38.8847C49.9116 39.249 49.5965 39.6256 49.3248 40.0326Z",
    fill: "#450D63"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M49.847 40.0685C49.9995 40.2993 50.1716 40.5203 50.3585 40.7265C50.3683 40.7364 50.3782 40.7511 50.3929 40.7609C50.447 40.8198 50.5061 40.8788 50.5651 40.9377C50.7028 41.0752 50.8405 41.2029 50.993 41.3207C51.1356 41.4386 51.2832 41.5466 51.4406 41.6498C51.6767 41.4926 51.898 41.3207 52.1095 41.1341C52.4489 40.8297 52.7489 40.4859 53.0047 40.1029C53.0145 40.0882 53.0244 40.0783 53.0293 40.0636C52.9408 39.9359 52.8522 39.8082 52.7539 39.6855C52.6161 39.5136 52.4686 39.3466 52.3161 39.1895C52.2325 39.106 52.1489 39.0274 52.0603 38.9489C51.8636 38.777 51.657 38.6199 51.4406 38.4725C51.2783 38.5806 51.1209 38.6935 50.9733 38.8163C50.8307 38.9341 50.6979 39.0569 50.57 39.1846C50.2946 39.4645 50.0536 39.7542 49.847 40.0685Z",
    fill: "url(#paint420_radial_578_447528)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8468 40.0688H51.4355V38.4875C51.1208 38.6938 50.8256 38.9344 50.56 39.1996C50.2944 39.4648 50.0534 39.7545 49.8468 40.0688Z",
    fill: "url(#paint421_radial_578_447528)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4357 38.4875V40.0737H53.0244C52.8178 39.7594 52.5768 39.4648 52.3112 39.1996C52.0407 38.9344 51.7505 38.6938 51.4357 38.4875Z",
    fill: "url(#paint422_radial_578_447528)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4357 40.0688V41.655C52.0653 41.2376 52.6063 40.6974 53.0244 40.0688H51.4357Z",
    fill: "url(#paint423_radial_578_447528)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8468 40.0688C50.0534 40.3831 50.2944 40.6778 50.56 40.943C50.8256 41.2081 51.1208 41.4488 51.4355 41.655V40.0688H49.8468Z",
    fill: "url(#paint424_radial_578_447528)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8469 40.0686C50.0535 40.3828 50.2945 40.6775 50.5601 40.9427C50.8257 41.2078 51.1208 41.4485 51.4356 41.6547C51.6717 41.4976 51.7553 41.4435 51.9668 41.2569L50.9683 38.8311C50.8257 38.9489 50.6929 39.0717 50.565 39.1994C50.2945 39.4645 50.0535 39.7543 49.8469 40.0686Z",
    fill: "url(#paint425_radial_578_447528)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3882 40.7656C50.4423 40.8245 50.5014 40.8834 50.5604 40.9424C50.826 41.2075 51.1211 41.4482 51.4359 41.6544C51.672 41.4973 51.8933 41.3254 52.1048 41.1388C52.4442 40.8343 52.7442 40.4906 53 40.1075C52.336 40.304 51.3621 40.5741 50.3882 40.7656Z",
    fill: "url(#paint426_radial_578_447528)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3586 40.7268C50.3684 40.7366 50.3782 40.7513 50.393 40.7611C50.4471 40.8201 50.5061 40.879 50.5651 40.9379C50.7029 41.0754 50.8406 41.2031 50.9931 41.321C51.3669 40.658 51.78 39.8625 51.8145 39.5531C51.8095 39.558 50.9832 40.2406 50.3586 40.7268Z",
    fill: "url(#paint427_radial_578_447528)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4358 40.0688L52.749 39.6907C52.6113 39.5188 52.4637 39.3519 52.3113 39.1947C52.2277 39.1112 52.144 39.0327 52.0555 38.9541L51.4358 40.0688Z",
    fill: "url(#paint428_radial_578_447528)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4348 41.115C51.8479 40.84 52.207 40.4865 52.4824 40.0691C52.207 39.6566 51.8528 39.2981 51.4348 39.0231C51.0216 39.2981 50.6625 39.6516 50.3871 40.0691C50.6625 40.4865 51.0167 40.84 51.4348 41.115Z",
    fill: "url(#paint429_radial_578_447528)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M52.749 39.764C52.6113 39.5922 52.4637 39.4252 52.3112 39.2681C52.2276 39.1846 52.144 39.106 52.0555 39.0274C51.8587 38.8556 51.6521 38.6984 51.4357 38.5511C51.2734 38.6591 51.116 38.7721 50.9684 38.8949C50.8258 39.0127 50.693 39.1355 50.5651 39.2632C50.3094 39.5185 50.0782 39.7984 49.8765 40.098C49.8667 40.0832 49.8618 40.0734 49.8519 40.0587C50.0585 39.7444 50.2995 39.4498 50.5651 39.1846C50.693 39.0569 50.8307 38.9341 50.9684 38.8163C51.116 38.6935 51.2734 38.5757 51.4357 38.4725C51.6521 38.6149 51.8587 38.777 52.0555 38.9489C52.144 39.0274 52.2276 39.106 52.3112 39.1895C52.4686 39.3466 52.6162 39.5087 52.749 39.6855C52.8473 39.8082 52.9359 39.9359 53.0244 40.0636C53.0146 40.0783 53.0097 40.0882 52.9998 40.1029C52.9162 39.9899 52.8326 39.877 52.749 39.764Z",
    fill: "url(#paint430_radial_578_447528)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3585 40.6531C50.3683 40.6629 50.3782 40.6776 50.3929 40.6875C50.447 40.7464 50.5061 40.8053 50.5651 40.8642C50.7028 41.0017 50.8405 41.1294 50.993 41.2473C51.1356 41.3651 51.2832 41.4732 51.4406 41.5763C51.6767 41.4191 51.898 41.2473 52.1095 41.0607C52.4489 40.7562 52.7489 40.4125 53.0047 40.0294C53.0145 40.0442 53.0244 40.054 53.0293 40.0687C53.0195 40.0834 53.0096 40.0933 53.0047 40.108C52.7489 40.4861 52.4489 40.8299 52.1095 41.1392C51.9029 41.3258 51.6767 41.5026 51.4406 41.6549C51.2881 41.5517 51.1356 41.4437 50.993 41.3258C50.8454 41.2031 50.7028 41.0754 50.5651 40.9428C50.5061 40.8839 50.452 40.825 50.3929 40.766C50.3831 40.7562 50.3733 40.7415 50.3585 40.7316C50.1716 40.5254 50.0044 40.3044 49.847 40.0736C49.8568 40.0589 49.8667 40.0491 49.8716 40.0343C50.0191 40.2504 50.1814 40.4567 50.3585 40.6531Z",
    fill: "url(#paint431_radial_578_447528)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.311 39.2681C52.4635 39.4252 52.611 39.5922 52.7487 39.764L52.9763 40.0715C52.7268 40.4376 52.4364 40.7674 52.1095 41.0606C51.898 41.2472 51.6767 41.4191 51.4406 41.5763C51.2832 41.4731 51.1356 41.3651 50.993 41.2472C50.8405 41.1294 50.7028 41.0017 50.5651 40.8642C50.5061 40.8053 50.447 40.7464 50.3929 40.6874C50.3829 40.6807 50.3751 40.6717 50.368 40.6635C50.3647 40.6598 50.3616 40.6562 50.3585 40.6531C50.191 40.4673 50.0368 40.2727 49.8957 40.0694C50.0927 39.7806 50.3173 39.5104 50.5649 39.2632C50.6928 39.1355 50.8256 39.0127 50.9682 38.8949C51.1158 38.7721 51.2732 38.6591 51.4355 38.5511C51.6519 38.6984 51.8585 38.8556 52.0552 39.0274C52.1438 39.106 52.2274 39.1846 52.311 39.2681ZM49.8545 40.063C49.8536 40.0616 49.8527 40.0602 49.8517 40.0587C50.0583 39.7444 50.2993 39.4498 50.5649 39.1846C50.6928 39.0569 50.8305 38.9341 50.9682 38.8163C51.1158 38.6935 51.2732 38.5757 51.4355 38.4725C51.6519 38.6149 51.8585 38.777 52.0552 38.9489C52.1438 39.0274 52.2274 39.106 52.311 39.1895C52.4684 39.3466 52.6159 39.5087 52.7487 39.6855C52.8391 39.7983 52.9212 39.9152 53.0026 40.0325C53.0033 40.0315 53.004 40.0304 53.0047 40.0294C53.0076 40.0338 53.0106 40.0378 53.0134 40.0415C53.02 40.0504 53.0258 40.0583 53.0293 40.0687C53.0264 40.0731 53.0234 40.077 53.0206 40.0808C53.014 40.0897 53.0082 40.0976 53.0047 40.108C52.7489 40.4861 52.4489 40.8298 52.1095 41.1392C51.9029 41.3258 51.6767 41.5026 51.4406 41.6548C51.2881 41.5517 51.1356 41.4437 50.993 41.3258C50.8454 41.2031 50.7028 41.0754 50.5651 40.9428C50.5356 40.9133 50.5073 40.8839 50.479 40.8544C50.4507 40.8249 50.4225 40.7955 50.3929 40.766C50.3898 40.7629 50.3867 40.7593 50.3834 40.7555C50.3764 40.7473 50.3686 40.7383 50.3585 40.7316C50.1716 40.5254 50.0044 40.3044 49.847 40.0736C49.8495 40.0698 49.8521 40.0663 49.8545 40.063Z",
    fill: "url(#paint432_radial_578_447528)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4355 39.027C51.4355 39.027 50.8158 39.4149 50.3879 40.073C50.3879 40.068 50.6928 39.3904 51.4355 39.027Z",
    fill: "url(#paint433_radial_578_447528)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4785 40.0691C52.4785 40.0691 52.1096 40.7173 51.485 41.1052L51.4358 41.5767L51.4013 41.0954C51.4013 41.0954 50.9341 40.899 50.3881 40.0691C50.3881 40.0691 51.0767 40.9923 51.4456 41.0414C51.4456 41.0463 51.8735 40.8794 52.4785 40.0691Z",
    fill: "url(#paint434_radial_578_447528)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4307 41.1101C51.4307 41.1101 50.7814 40.7418 50.3928 40.1182L49.9207 40.0691L50.4027 40.0347C50.4027 40.0347 50.5994 39.5682 51.4307 39.0231C51.4307 39.0231 50.506 39.7106 50.4568 40.0789C50.4519 40.0789 50.6191 40.5061 51.4307 41.1101Z",
    fill: "url(#paint435_radial_578_447528)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4548 39.0231C51.4548 39.0231 52.1041 39.3914 52.4927 40.015L52.9648 40.0641L52.4828 40.0985C52.4828 40.0985 52.2861 40.565 51.4548 41.1101C51.4548 41.1101 52.3795 40.4226 52.4287 40.0543C52.4336 40.0543 52.2664 39.6271 51.4548 39.0231Z",
    fill: "url(#paint436_radial_578_447528)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3881 40.0635C50.3881 40.0635 50.757 39.4153 51.3817 39.0273L51.4309 38.5559L51.4653 39.0372C51.4653 39.0372 51.9326 39.2336 52.4785 40.0635C52.4785 40.0635 51.7899 39.1403 51.421 39.0912C51.421 39.0863 50.9931 39.2532 50.3881 40.0635Z",
    fill: "url(#paint437_radial_578_447528)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9986 41.837C44.9832 41.8602 44.9832 41.8905 44.9987 41.9136C45.1971 42.2095 45.4195 42.4931 45.6601 42.7584C45.6733 42.7716 45.6865 42.7914 45.7063 42.8045C45.7789 42.8836 45.8582 42.9627 45.9374 43.0418C46.1224 43.2263 46.3073 43.3976 46.512 43.5558C46.6919 43.7043 46.8776 43.8412 47.0745 43.972C47.0978 43.9874 47.128 43.9874 47.151 43.9716C47.47 43.7525 47.9619 43.3339 48.375 42.9154C48.7395 42.5461 49.1121 42.0506 49.2171 41.9084C49.2346 41.8846 49.2349 41.8527 49.2179 41.8284C49.1511 41.733 48.9807 41.4916 48.8763 41.3614C48.6913 41.1307 48.4932 40.9066 48.2885 40.6958C48.1762 40.5837 48.064 40.4783 47.9451 40.3729C47.6927 40.1525 47.4282 39.9502 47.1517 39.7601C47.1283 39.7441 47.0975 39.7439 47.074 39.7597C46.8698 39.8968 46.6719 40.04 46.4856 40.1949C46.2941 40.3531 46.1157 40.5178 45.944 40.6892C45.5854 41.0534 45.2703 41.43 44.9986 41.837Z",
    fill: "#450D63"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5208 41.873C45.6733 42.1038 45.8454 42.3247 46.0323 42.531C46.0422 42.5408 46.052 42.5555 46.0668 42.5654C46.1209 42.6243 46.1799 42.6832 46.2389 42.7421C46.3766 42.8796 46.5144 43.0073 46.6668 43.1252C46.8095 43.243 46.957 43.3511 47.1144 43.4542C47.3505 43.2971 47.5719 43.1252 47.7834 42.9386C48.1227 42.6341 48.4228 42.2904 48.6785 41.9073C48.6884 41.8926 48.6982 41.8828 48.7031 41.868C48.6146 41.7404 48.5261 41.6127 48.4277 41.4899C48.29 41.318 48.1424 41.1511 47.9899 40.9939C47.9063 40.9105 47.8227 40.8319 47.7342 40.7533C47.5374 40.5814 47.3308 40.4243 47.1144 40.277C46.9521 40.385 46.7947 40.498 46.6472 40.6207C46.5045 40.7386 46.3717 40.8614 46.2438 40.989C45.9684 41.2689 45.7274 41.5587 45.5208 41.873Z",
    fill: "url(#paint438_radial_578_447528)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5207 41.8732H47.1094V40.292C46.7946 40.4982 46.4995 40.7389 46.2339 41.004C45.9683 41.2692 45.7273 41.559 45.5207 41.8732Z",
    fill: "url(#paint439_radial_578_447528)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1095 40.292V41.8781H48.6982C48.4917 41.5639 48.2507 41.2692 47.985 41.004C47.7145 40.7389 47.4243 40.4982 47.1095 40.292Z",
    fill: "url(#paint440_radial_578_447528)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1095 41.8733V43.4594C47.7391 43.042 48.2802 42.5019 48.6982 41.8733H47.1095Z",
    fill: "url(#paint441_radial_578_447528)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5207 41.8733C45.7273 42.1876 45.9683 42.4822 46.2339 42.7474C46.4995 43.0126 46.7946 43.2532 47.1094 43.4594V41.8733H45.5207Z",
    fill: "url(#paint442_radial_578_447528)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5207 41.873C45.7273 42.1873 45.9683 42.4819 46.2339 42.7471C46.4995 43.0123 46.7946 43.2529 47.1094 43.4592C47.3455 43.302 47.4291 43.248 47.6406 43.0614L46.6422 40.6355C46.4995 40.7534 46.3667 40.8761 46.2388 41.0038C45.9683 41.269 45.7273 41.5587 45.5207 41.873Z",
    fill: "url(#paint443_radial_578_447528)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0621 42.57C46.1162 42.6289 46.1752 42.6879 46.2342 42.7468C46.4998 43.012 46.7949 43.2526 47.1097 43.4589C47.3458 43.3017 47.5671 43.1298 47.7786 42.9432C48.118 42.6388 48.4181 42.295 48.6738 41.912C48.0098 42.1084 47.0359 42.3785 46.0621 42.57Z",
    fill: "url(#paint444_radial_578_447528)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0324 42.5312C46.0422 42.541 46.0521 42.5558 46.0668 42.5656C46.1209 42.6245 46.1799 42.6834 46.239 42.7424C46.3767 42.8799 46.5144 43.0075 46.6669 43.1254C47.0407 42.4625 47.4539 41.6669 47.4883 41.3575C47.4834 41.3625 46.657 42.045 46.0324 42.5312Z",
    fill: "url(#paint445_radial_578_447528)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1096 41.8733L48.4229 41.4951C48.2851 41.3233 48.1376 41.1563 47.9851 40.9992C47.9015 40.9157 47.8179 40.8371 47.7293 40.7585L47.1096 41.8733Z",
    fill: "url(#paint446_radial_578_447528)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1086 42.9195C47.5218 42.6445 47.8808 42.2909 48.1562 41.8735C47.8808 41.461 47.5267 41.1025 47.1086 40.8275C46.6954 41.1025 46.3364 41.4561 46.0609 41.8735C46.3364 42.2909 46.6905 42.6445 47.1086 42.9195Z",
    fill: "url(#paint447_radial_578_447528)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4228 41.5685C48.2851 41.3966 48.1375 41.2297 47.985 41.0725C47.9014 40.989 47.8178 40.9105 47.7293 40.8319C47.5325 40.66 47.326 40.5029 47.1095 40.3555C46.9472 40.4636 46.7898 40.5765 46.6423 40.6993C46.4996 40.8172 46.3668 40.9399 46.239 41.0676C45.9832 41.323 45.752 41.6029 45.5504 41.9024C45.5405 41.8877 45.5356 41.8779 45.5258 41.8631C45.7323 41.5488 45.9734 41.2542 46.239 40.989C46.3668 40.8614 46.5046 40.7386 46.6423 40.6207C46.7898 40.498 46.9472 40.3801 47.1095 40.277C47.326 40.4194 47.5325 40.5814 47.7293 40.7533C47.8178 40.8319 47.9014 40.9105 47.985 40.9939C48.1424 41.1511 48.29 41.3131 48.4228 41.4899C48.5212 41.6127 48.6097 41.7404 48.6982 41.868C48.6884 41.8828 48.6835 41.8926 48.6736 41.9073C48.59 41.7944 48.5064 41.6814 48.4228 41.5685Z",
    fill: "url(#paint448_radial_578_447528)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0323 42.4575C46.0422 42.4673 46.052 42.4821 46.0668 42.4919C46.1209 42.5508 46.1799 42.6098 46.2389 42.6687C46.3766 42.8062 46.5144 42.9339 46.6668 43.0517C46.8095 43.1696 46.957 43.2776 47.1144 43.3807C47.3505 43.2236 47.5719 43.0517 47.7834 42.8651C48.1227 42.5606 48.4228 42.2169 48.6785 41.8339C48.6884 41.8486 48.6982 41.8584 48.7031 41.8731C48.6933 41.8879 48.6835 41.8977 48.6785 41.9124C48.4228 42.2906 48.1227 42.6343 47.7834 42.9437C47.5768 43.1303 47.3505 43.3071 47.1144 43.4593C46.9619 43.3562 46.8095 43.2481 46.6668 43.1303C46.5193 43.0075 46.3766 42.8798 46.2389 42.7473C46.1799 42.6883 46.1258 42.6294 46.0668 42.5705C46.0569 42.5606 46.0471 42.5459 46.0323 42.5361C45.8454 42.3298 45.6782 42.1089 45.5208 41.8781C45.5306 41.8633 45.5405 41.8535 45.5454 41.8388C45.693 42.0548 45.8553 42.2611 46.0323 42.4575Z",
    fill: "url(#paint449_radial_578_447528)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9848 41.0725C48.1373 41.2297 48.2849 41.3966 48.4226 41.5685L48.6502 41.8759C48.4007 42.2421 48.1103 42.5718 47.7834 42.8651C47.5719 43.0517 47.3505 43.2236 47.1144 43.3807C46.957 43.2776 46.8095 43.1695 46.6668 43.0517C46.5144 42.9338 46.3766 42.8062 46.2389 42.6687C46.1799 42.6097 46.1209 42.5508 46.0668 42.4919C46.0567 42.4852 46.0489 42.4762 46.0418 42.468C46.0386 42.4642 46.0355 42.4606 46.0323 42.4575C45.8649 42.2717 45.7106 42.0771 45.5695 41.8738C45.7666 41.585 45.9911 41.3148 46.2387 41.0676C46.3666 40.9399 46.4994 40.8172 46.642 40.6993C46.7896 40.5765 46.947 40.4636 47.1093 40.3555C47.3257 40.5029 47.5323 40.66 47.7291 40.8319C47.8176 40.9105 47.9012 40.989 47.9848 41.0725ZM45.5283 41.8674C45.5275 41.866 45.5265 41.8646 45.5255 41.8631C45.7321 41.5488 45.9731 41.2542 46.2387 40.989C46.3666 40.8614 46.5043 40.7386 46.642 40.6207C46.7896 40.498 46.947 40.3801 47.1093 40.277C47.3257 40.4194 47.5323 40.5814 47.7291 40.7533C47.8176 40.8319 47.9012 40.9105 47.9848 40.9939C48.1422 41.1511 48.2898 41.3131 48.4226 41.4899C48.513 41.6027 48.595 41.7197 48.6764 41.837C48.6771 41.8359 48.6778 41.8349 48.6785 41.8338C48.6815 41.8382 48.6844 41.8422 48.6872 41.846C48.6938 41.8549 48.6997 41.8628 48.7031 41.8731C48.7002 41.8775 48.6973 41.8815 48.6944 41.8853C48.6879 41.8942 48.682 41.9021 48.6785 41.9124C48.4228 42.2905 48.1227 42.6343 47.7834 42.9437C47.5768 43.1303 47.3505 43.307 47.1144 43.4593C46.9619 43.3562 46.8095 43.2481 46.6668 43.1303C46.5193 43.0075 46.3766 42.8798 46.2389 42.7472C46.2094 42.7178 46.1811 42.6883 46.1528 42.6588C46.1246 42.6294 46.0963 42.5999 46.0668 42.5704C46.0637 42.5673 46.0605 42.5637 46.0573 42.5599C46.0502 42.5518 46.0424 42.5428 46.0323 42.5361C45.8454 42.3298 45.6782 42.1088 45.5208 41.878C45.5233 41.8742 45.5259 41.8707 45.5283 41.8674Z",
    fill: "url(#paint450_radial_578_447528)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1094 40.8314C47.1094 40.8314 46.4896 41.2194 46.0617 41.8774C46.0617 41.8725 46.3667 41.1948 47.1094 40.8314Z",
    fill: "url(#paint451_radial_578_447528)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1523 41.8735C48.1523 41.8735 47.7834 42.5217 47.1588 42.9097L47.1096 43.3811L47.0752 42.8999C47.0752 42.8999 46.6079 42.7034 46.0619 41.8735C46.0619 41.8735 46.7505 42.7967 47.1194 42.8459C47.1194 42.8508 47.5474 42.6838 48.1523 41.8735Z",
    fill: "url(#paint452_radial_578_447528)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1045 42.9146C47.1045 42.9146 46.4552 42.5463 46.0667 41.9226L45.5945 41.8735L46.0765 41.8391C46.0765 41.8391 46.2733 41.3726 47.1045 40.8275C47.1045 40.8275 46.1798 41.515 46.1306 41.8833C46.1257 41.8833 46.2929 42.3105 47.1045 42.9146Z",
    fill: "url(#paint453_radial_578_447528)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1287 40.8275C47.1287 40.8275 47.7779 41.1958 48.1665 41.8195L48.6387 41.8686L48.1567 41.903C48.1567 41.903 47.9599 42.3695 47.1287 42.9146C47.1287 42.9146 48.0534 42.2271 48.1025 41.8588C48.1075 41.8588 47.9402 41.4315 47.1287 40.8275Z",
    fill: "url(#paint454_radial_578_447528)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0619 41.8679C46.0619 41.8679 46.4308 41.2197 47.0555 40.8318L47.1047 40.3604L47.1391 40.8416C47.1391 40.8416 47.6064 41.038 48.1523 41.8679C48.1523 41.8679 47.4637 40.9447 47.0948 40.8956C47.0948 40.8907 46.6669 41.0577 46.0619 41.8679Z",
    fill: "url(#paint455_radial_578_447528)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6715 40.0647C40.656 40.0879 40.656 40.1181 40.6716 40.1413C40.8699 40.4372 41.0923 40.7207 41.3329 40.9861C41.3461 40.9993 41.3593 41.019 41.3791 41.0322C41.4518 41.1113 41.531 41.1904 41.6103 41.2694C41.7952 41.454 41.9801 41.6253 42.1848 41.7835C42.3647 41.932 42.5504 42.0689 42.7474 42.1997C42.7707 42.2151 42.8008 42.2151 42.8238 42.1993C43.1429 41.9801 43.6347 41.5616 44.0479 41.143C44.4124 40.7737 44.785 40.2783 44.8899 40.1361C44.9075 40.1123 44.9078 40.0803 44.8908 40.0561C44.824 39.9607 44.6535 39.7193 44.5491 39.589C44.3642 39.3584 44.1661 39.1343 43.9614 38.9234C43.8491 38.8114 43.7368 38.706 43.6179 38.6005C43.3655 38.3801 43.1011 38.1778 42.8245 37.9878C42.8012 37.9717 42.7704 37.9716 42.7468 37.9874C42.5427 38.1244 42.3447 38.2677 42.1584 38.4226C41.9669 38.5808 41.7886 38.7455 41.6169 38.9168C41.2583 39.2811 40.9432 39.6577 40.6715 40.0647Z",
    fill: "#450D63"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1937 40.1006C41.3461 40.3314 41.5183 40.5524 41.7052 40.7587C41.715 40.7685 41.7249 40.7832 41.7396 40.793C41.7937 40.852 41.8527 40.9109 41.9118 40.9698C42.0495 41.1073 42.1872 41.235 42.3397 41.3528C42.4823 41.4707 42.6299 41.5787 42.7873 41.6819C43.0234 41.5247 43.2447 41.3528 43.4562 41.1662C43.7956 40.8618 44.0956 40.518 44.3514 40.135C44.3612 40.1203 44.3711 40.1104 44.376 40.0957C44.2874 39.968 44.1989 39.8403 44.1005 39.7176C43.9628 39.5457 43.8153 39.3787 43.6628 39.2216C43.5792 39.1381 43.4956 39.0595 43.407 38.981C43.2103 38.8091 43.0037 38.652 42.7873 38.5046C42.625 38.6127 42.4676 38.7256 42.32 38.8484C42.1774 38.9662 42.0446 39.089 41.9167 39.2167C41.6412 39.4966 41.4002 39.7863 41.1937 40.1006Z",
    fill: "url(#paint456_radial_578_447528)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1935 40.1009H42.7822V38.5197C42.4674 38.7259 42.1723 38.9665 41.9067 39.2317C41.6411 39.4969 41.4001 39.7866 41.1935 40.1009Z",
    fill: "url(#paint457_radial_578_447528)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7824 38.5197V40.1058H44.3711C44.1645 39.7915 43.9235 39.4969 43.6579 39.2317C43.3874 38.9665 43.0972 38.7259 42.7824 38.5197Z",
    fill: "url(#paint458_radial_578_447528)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7824 40.101V41.6871C43.412 41.2697 43.953 40.7295 44.3711 40.101H42.7824Z",
    fill: "url(#paint459_radial_578_447528)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1935 40.101C41.4001 40.4152 41.6411 40.7099 41.9067 40.9751C42.1723 41.2402 42.4674 41.4809 42.7822 41.6871V40.101H41.1935Z",
    fill: "url(#paint460_radial_578_447528)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1936 40.1007C41.4002 40.4149 41.6412 40.7096 41.9068 40.9748C42.1724 41.2399 42.4675 41.4806 42.7823 41.6868C43.0184 41.5297 43.102 41.4757 43.3135 41.289L42.315 38.8632C42.1724 38.981 42.0396 39.1038 41.9117 39.2315C41.6412 39.4966 41.4002 39.7864 41.1936 40.1007Z",
    fill: "url(#paint461_radial_578_447528)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7349 40.7977C41.789 40.8566 41.848 40.9155 41.9071 40.9745C42.1727 41.2396 42.4678 41.4803 42.7826 41.6865C43.0187 41.5294 43.24 41.3575 43.4515 41.1709C43.7909 40.8664 44.0909 40.5227 44.3467 40.1396C43.6827 40.3361 42.7088 40.6062 41.7349 40.7977Z",
    fill: "url(#paint462_radial_578_447528)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7052 40.7589C41.7151 40.7687 41.7249 40.7834 41.7397 40.7932C41.7938 40.8522 41.8528 40.9111 41.9118 40.97C42.0495 41.1075 42.1873 41.2352 42.3397 41.3531C42.7135 40.6901 43.1267 39.8946 43.1611 39.5852C43.1562 39.5901 42.3299 40.2727 41.7052 40.7589Z",
    fill: "url(#paint463_radial_578_447528)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7824 40.1009L44.0957 39.7228C43.958 39.5509 43.8104 39.384 43.6579 39.2268C43.5743 39.1433 43.4907 39.0648 43.4022 38.9862L42.7824 40.1009Z",
    fill: "url(#paint464_radial_578_447528)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7814 41.1471C43.1946 40.8721 43.5537 40.5186 43.8291 40.1012C43.5537 39.6887 43.1995 39.3302 42.7814 39.0552C42.3683 39.3302 42.0092 39.6837 41.7338 40.1012C42.0092 40.5186 42.3634 40.8721 42.7814 41.1471Z",
    fill: "url(#paint465_radial_578_447528)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0957 39.7962C43.9579 39.6243 43.8104 39.4573 43.6579 39.3002C43.5743 39.2167 43.4907 39.1381 43.4021 39.0595C43.2054 38.8877 42.9988 38.7305 42.7824 38.5832C42.6201 38.6912 42.4627 38.8042 42.3151 38.927C42.1725 39.0448 42.0397 39.1676 41.9118 39.2953C41.656 39.5506 41.4249 39.8305 41.2232 40.1301C41.2134 40.1153 41.2084 40.1055 41.1986 40.0908C41.4052 39.7765 41.6462 39.4819 41.9118 39.2167C42.0397 39.089 42.1774 38.9662 42.3151 38.8484C42.4627 38.7256 42.6201 38.6078 42.7824 38.5046C42.9988 38.647 43.2054 38.8091 43.4021 38.981C43.4907 39.0595 43.5743 39.1381 43.6579 39.2216C43.8153 39.3787 43.9629 39.5408 44.0957 39.7176C44.194 39.8403 44.2826 39.968 44.3711 40.0957C44.3613 40.1104 44.3563 40.1203 44.3465 40.135C44.2629 40.022 44.1793 39.9091 44.0957 39.7962Z",
    fill: "url(#paint466_radial_578_447528)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7052 40.6852C41.715 40.695 41.7249 40.7097 41.7396 40.7196C41.7937 40.7785 41.8527 40.8374 41.9118 40.8963C42.0495 41.0338 42.1872 41.1615 42.3397 41.2794C42.4823 41.3972 42.6299 41.5053 42.7873 41.6084C43.0234 41.4513 43.2447 41.2794 43.4562 41.0928C43.7956 40.7883 44.0956 40.4446 44.3514 40.0615C44.3612 40.0763 44.3711 40.0861 44.376 40.1008C44.3661 40.1155 44.3563 40.1254 44.3514 40.1401C44.0956 40.5182 43.7956 40.862 43.4562 41.1713C43.2496 41.3579 43.0234 41.5347 42.7873 41.687C42.6348 41.5838 42.4823 41.4758 42.3397 41.3579C42.1921 41.2352 42.0495 41.1075 41.9118 40.9749C41.8527 40.916 41.7986 40.8571 41.7396 40.7981C41.7298 40.7883 41.7199 40.7736 41.7052 40.7638C41.5183 40.5575 41.3511 40.3365 41.1937 40.1057C41.2035 40.091 41.2133 40.0812 41.2183 40.0664C41.3658 40.2825 41.5281 40.4888 41.7052 40.6852Z",
    fill: "url(#paint467_radial_578_447528)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6577 39.3002C43.8101 39.4573 43.9577 39.6243 44.0954 39.7962L44.323 40.1036C44.0735 40.4697 43.7831 40.7995 43.4562 41.0927C43.2447 41.2794 43.0234 41.4512 42.7873 41.6084C42.6299 41.5052 42.4823 41.3972 42.3397 41.2794C42.1872 41.1615 42.0495 41.0338 41.9118 40.8963C41.8527 40.8374 41.7937 40.7785 41.7396 40.7195C41.7295 40.7128 41.7217 40.7038 41.7147 40.6957C41.7114 40.6919 41.7083 40.6883 41.7052 40.6852C41.5377 40.4994 41.3834 40.3048 41.2424 40.1015C41.4394 39.8127 41.664 39.5425 41.9116 39.2953C42.0395 39.1676 42.1723 39.0448 42.3149 38.927C42.4625 38.8042 42.6199 38.6912 42.7822 38.5832C42.9986 38.7305 43.2052 38.8877 43.4019 39.0595C43.4904 39.1381 43.5741 39.2167 43.6577 39.3002ZM41.2012 40.0951C41.2003 40.0937 41.1994 40.0923 41.1984 40.0908C41.405 39.7765 41.646 39.4819 41.9116 39.2167C42.0395 39.089 42.1772 38.9662 42.3149 38.8484C42.4625 38.7256 42.6199 38.6078 42.7822 38.5046C42.9986 38.647 43.2052 38.8091 43.4019 38.981C43.4904 39.0595 43.5741 39.1381 43.6577 39.2216C43.8151 39.3787 43.9626 39.5408 44.0954 39.7176C44.1858 39.8304 44.2679 39.9473 44.3493 40.0646C44.35 40.0636 44.3507 40.0625 44.3514 40.0615C44.3543 40.0659 44.3573 40.0699 44.3601 40.0736C44.3667 40.0825 44.3725 40.0905 44.376 40.1008C44.373 40.1052 44.3701 40.1091 44.3673 40.1129C44.3607 40.1218 44.3548 40.1297 44.3514 40.1401C44.0956 40.5182 43.7956 40.8619 43.4562 41.1713C43.2496 41.3579 43.0234 41.5347 42.7873 41.6869C42.6348 41.5838 42.4823 41.4758 42.3397 41.3579C42.1921 41.2352 42.0495 41.1075 41.9118 40.9749C41.8823 40.9454 41.854 40.916 41.8257 40.8865C41.7974 40.857 41.7691 40.8276 41.7396 40.7981C41.7365 40.795 41.7334 40.7914 41.7301 40.7876C41.7231 40.7794 41.7153 40.7704 41.7052 40.7637C41.5183 40.5575 41.3511 40.3365 41.1937 40.1057C41.1962 40.1019 41.1987 40.0984 41.2012 40.0951Z",
    fill: "url(#paint468_radial_578_447528)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7822 39.0591C42.7822 39.0591 42.1625 39.447 41.7346 40.1051C41.7346 40.1001 42.0395 39.4225 42.7822 39.0591Z",
    fill: "url(#paint469_radial_578_447528)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8252 40.1012C43.8252 40.1012 43.4563 40.7494 42.8316 41.1374L42.7825 41.6088L42.748 41.1275C42.748 41.1275 42.2808 40.9311 41.7348 40.1012C41.7348 40.1012 42.4234 41.0244 42.7923 41.0735C42.7923 41.0784 43.2202 40.9115 43.8252 40.1012Z",
    fill: "url(#paint470_radial_578_447528)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7773 41.1422C42.7773 41.1422 42.1281 40.7739 41.7395 40.1503L41.2673 40.1012L41.7494 40.0668C41.7494 40.0668 41.9461 39.6003 42.7773 39.0552C42.7773 39.0552 41.8527 39.7427 41.8035 40.111C41.7985 40.111 41.9658 40.5382 42.7773 41.1422Z",
    fill: "url(#paint471_radial_578_447528)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8015 39.0552C42.8015 39.0552 43.4508 39.4235 43.8393 40.0471L44.3115 40.0962L43.8295 40.1306C43.8295 40.1306 43.6328 40.5971 42.8015 41.1422C42.8015 41.1422 43.7262 40.4547 43.7754 40.0864C43.7803 40.0864 43.6131 39.6592 42.8015 39.0552Z",
    fill: "url(#paint472_radial_578_447528)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7348 40.0956C41.7348 40.0956 42.1037 39.4474 42.7284 39.0594L42.7775 38.588L42.812 39.0693C42.812 39.0693 43.2792 39.2657 43.8252 40.0956C43.8252 40.0956 43.1366 39.1724 42.7677 39.1233C42.7677 39.1184 42.3398 39.2853 41.7348 40.0956Z",
    fill: "url(#paint473_radial_578_447528)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3063 37.6387C36.2908 37.6619 36.2908 37.6921 36.3063 37.7153C36.5047 38.0112 36.7271 38.2947 36.9677 38.5601C36.9809 38.5732 36.9941 38.593 37.0139 38.6062C37.0866 38.6853 37.1658 38.7643 37.2451 38.8434C37.43 39.0279 37.6149 39.1993 37.8196 39.3574C37.9995 39.506 38.1852 39.6429 38.3822 39.7736C38.4054 39.7891 38.4356 39.7891 38.4586 39.7733C38.7777 39.5541 39.2695 39.1355 39.6826 38.717C40.0472 38.3477 40.4198 37.8523 40.5247 37.7101C40.5422 37.6863 40.5425 37.6543 40.5256 37.6301C40.4587 37.5346 40.2883 37.2932 40.1839 37.163C39.999 36.9323 39.8008 36.7083 39.5961 36.4974C39.4838 36.3854 39.3716 36.2799 39.2527 36.1745C39.0003 35.9541 38.7358 35.7518 38.4593 35.5618C38.4359 35.5457 38.4051 35.5455 38.3816 35.5613C38.1774 35.6984 37.9795 35.8417 37.7932 35.9966C37.6017 36.1547 37.4234 36.3195 37.2517 36.4908C36.8931 36.855 36.5779 37.2317 36.3063 37.6387Z",
    fill: "#450D63"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8284 37.6746C36.9809 37.9054 37.153 38.1264 37.34 38.3326C37.3498 38.3424 37.3596 38.3572 37.3744 38.367C37.4285 38.4259 37.4875 38.4849 37.5465 38.5438C37.6843 38.6813 37.822 38.809 37.9745 38.9268C38.1171 39.0447 38.2646 39.1527 38.422 39.2558C38.6581 39.0987 38.8795 38.9268 39.091 38.7402C39.4304 38.4357 39.7304 38.092 39.9861 37.709C39.996 37.6942 40.0058 37.6844 40.0107 37.6697C39.9222 37.542 39.8337 37.4143 39.7353 37.2916C39.5976 37.1197 39.45 36.9527 39.2975 36.7956C39.2139 36.7121 39.1303 36.6335 39.0418 36.555C38.845 36.3831 38.6385 36.2259 38.422 36.0786C38.2597 36.1866 38.1023 36.2996 37.9548 36.4224C37.8121 36.5402 37.6793 36.663 37.5515 36.7907C37.276 37.0706 37.035 37.3603 36.8284 37.6746Z",
    fill: "url(#paint474_radial_578_447528)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8283 37.6749H38.417V36.0936C38.1022 36.2999 37.8071 36.5405 37.5415 36.8057C37.2759 37.0709 37.0349 37.3606 36.8283 37.6749Z",
    fill: "url(#paint475_radial_578_447528)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4172 36.0936V37.6798H40.0059C39.7993 37.3655 39.5583 37.0709 39.2927 36.8057C39.0221 36.5405 38.7319 36.2999 38.4172 36.0936Z",
    fill: "url(#paint476_radial_578_447528)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4172 37.6749V39.2611C39.0467 38.8437 39.5878 38.3035 40.0059 37.6749H38.4172Z",
    fill: "url(#paint477_radial_578_447528)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8283 37.6749C37.0349 37.9892 37.2759 38.2839 37.5415 38.549C37.8071 38.8142 38.1022 39.0548 38.417 39.2611V37.6749H36.8283Z",
    fill: "url(#paint478_radial_578_447528)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8283 37.6746C37.0349 37.9889 37.2759 38.2836 37.5415 38.5487C37.8071 38.8139 38.1022 39.0545 38.417 39.2608C38.6531 39.1036 38.7367 39.0496 38.9482 38.863L37.9498 36.4371C37.8071 36.555 37.6743 36.6778 37.5464 36.8054C37.2759 37.0706 37.0349 37.3603 36.8283 37.6746Z",
    fill: "url(#paint479_radial_578_447528)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3697 38.3717C37.4238 38.4306 37.4828 38.4895 37.5418 38.5484C37.8074 38.8136 38.1025 39.0542 38.4173 39.2605C38.6534 39.1034 38.8748 38.9315 39.0863 38.7449C39.4256 38.4404 39.7257 38.0967 39.9814 37.7136C39.3174 37.9101 38.3436 38.1801 37.3697 38.3717Z",
    fill: "url(#paint480_radial_578_447528)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M37.34 38.3328C37.3498 38.3427 37.3597 38.3574 37.3744 38.3672C37.4285 38.4261 37.4876 38.4851 37.5466 38.544C37.6843 38.6815 37.822 38.8092 37.9745 38.927C38.3483 38.2641 38.7615 37.4686 38.7959 37.1592C38.791 37.1641 37.9647 37.8467 37.34 38.3328Z",
    fill: "url(#paint481_radial_578_447528)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4172 37.6749L39.7305 37.2968C39.5927 37.1249 39.4452 36.9579 39.2927 36.8008C39.2091 36.7173 39.1255 36.6388 39.0369 36.5602L38.4172 37.6749Z",
    fill: "url(#paint482_radial_578_447528)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4162 38.7211C38.8294 38.4461 39.1884 38.0925 39.4639 37.6751C39.1884 37.2626 38.8343 36.9041 38.4162 36.6292C38.0031 36.9041 37.644 37.2577 37.3686 37.6751C37.644 38.0925 37.9981 38.4461 38.4162 38.7211Z",
    fill: "url(#paint483_radial_578_447528)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7304 37.3701C39.5927 37.1983 39.4451 37.0313 39.2927 36.8741C39.209 36.7907 39.1254 36.7121 39.0369 36.6335C38.8402 36.4616 38.6336 36.3045 38.4172 36.1572C38.2548 36.2652 38.0975 36.3782 37.9499 36.5009C37.8073 36.6188 37.6745 36.7416 37.5466 36.8692C37.2908 37.1246 37.0596 37.4045 36.858 37.7041C36.8481 37.6893 36.8432 37.6795 36.8334 37.6648C37.04 37.3505 37.281 37.0558 37.5466 36.7907C37.6745 36.663 37.8122 36.5402 37.9499 36.4224C38.0975 36.2996 38.2548 36.1817 38.4172 36.0786C38.6336 36.221 38.8402 36.3831 39.0369 36.555C39.1254 36.6335 39.209 36.7121 39.2927 36.7956C39.4501 36.9527 39.5976 37.1148 39.7304 37.2916C39.8288 37.4143 39.9173 37.542 40.0059 37.6697C39.996 37.6844 39.9911 37.6942 39.9813 37.709C39.8977 37.596 39.814 37.4831 39.7304 37.3701Z",
    fill: "url(#paint484_radial_578_447528)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M37.34 38.2592C37.3498 38.269 37.3596 38.2837 37.3744 38.2935C37.4285 38.3525 37.4875 38.4114 37.5465 38.4703C37.6843 38.6078 37.822 38.7355 37.9745 38.8534C38.1171 38.9712 38.2646 39.0792 38.422 39.1824C38.6581 39.0252 38.8795 38.8534 39.091 38.6667C39.4304 38.3623 39.7304 38.0185 39.9861 37.6355C39.996 37.6502 40.0058 37.6601 40.0107 37.6748C40.0009 37.6895 39.9911 37.6993 39.9861 37.7141C39.7304 38.0922 39.4304 38.4359 39.091 38.7453C38.8844 38.9319 38.6581 39.1087 38.422 39.2609C38.2696 39.1578 38.1171 39.0498 37.9745 38.9319C37.8269 38.8092 37.6843 38.6815 37.5465 38.5489C37.4875 38.49 37.4334 38.431 37.3744 38.3721C37.3645 38.3623 37.3547 38.3476 37.34 38.3377C37.153 38.1315 36.9858 37.9105 36.8284 37.6797C36.8383 37.665 36.8481 37.6551 36.853 37.6404C37.0006 37.8565 37.1629 38.0627 37.34 38.2592Z",
    fill: "url(#paint485_radial_578_447528)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2924 36.8741C39.4449 37.0313 39.5925 37.1983 39.7302 37.3701L39.9578 37.6775C39.7083 38.0437 39.4179 38.3734 39.091 38.6667C38.8795 38.8533 38.6581 39.0252 38.422 39.1823C38.2646 39.0792 38.1171 38.9712 37.9745 38.8533C37.822 38.7355 37.6843 38.6078 37.5465 38.4703C37.4875 38.4114 37.4285 38.3524 37.3744 38.2935C37.3643 38.2868 37.3565 38.2778 37.3495 38.2696C37.3462 38.2658 37.3431 38.2622 37.34 38.2591C37.1725 38.0734 37.0182 37.8788 36.8771 37.6754C37.0742 37.3867 37.2987 37.1164 37.5463 36.8692C37.6742 36.7416 37.807 36.6188 37.9497 36.5009C38.0972 36.3782 38.2546 36.2652 38.4169 36.1572C38.6333 36.3045 38.8399 36.4616 39.0367 36.6335C39.1252 36.7121 39.2088 36.7907 39.2924 36.8741ZM36.836 37.6691C36.8351 37.6677 36.8341 37.6662 36.8331 37.6648C37.0397 37.3505 37.2807 37.0558 37.5463 36.7907C37.6742 36.663 37.8119 36.5402 37.9497 36.4224C38.0972 36.2996 38.2546 36.1817 38.4169 36.0786C38.6333 36.221 38.8399 36.3831 39.0367 36.555C39.1252 36.6335 39.2088 36.7121 39.2924 36.7956C39.4498 36.9527 39.5974 37.1148 39.7302 37.2916C39.8206 37.4044 39.9027 37.5213 39.9841 37.6386C39.9848 37.6376 39.9855 37.6365 39.9861 37.6355C39.9891 37.6399 39.992 37.6438 39.9948 37.6476C40.0014 37.6565 40.0073 37.6644 40.0107 37.6748C40.0078 37.6792 40.0049 37.6831 40.0021 37.6869C39.9955 37.6958 39.9896 37.7037 39.9861 37.714C39.7304 38.0922 39.4304 38.4359 39.091 38.7453C38.8844 38.9319 38.6581 39.1087 38.422 39.2609C38.2696 39.1578 38.1171 39.0498 37.9745 38.9319C37.8269 38.8091 37.6843 38.6815 37.5465 38.5489C37.517 38.5194 37.4887 38.4899 37.4605 38.4605C37.4322 38.431 37.4039 38.4015 37.3744 38.3721C37.3713 38.369 37.3682 38.3654 37.3649 38.3616C37.3578 38.3534 37.35 38.3444 37.34 38.3377C37.153 38.1315 36.9858 37.9105 36.8284 37.6797C36.831 37.6759 36.8335 37.6724 36.836 37.6691Z",
    fill: "url(#paint486_radial_578_447528)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M38.417 36.6331C38.417 36.6331 37.7973 37.021 37.3693 37.679C37.3693 37.6741 37.6743 36.9964 38.417 36.6331Z",
    fill: "url(#paint487_radial_578_447528)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M39.46 37.6752C39.46 37.6752 39.0911 38.3234 38.4664 38.7113L38.4172 39.1828L38.3828 38.7015C38.3828 38.7015 37.9155 38.5051 37.3696 37.6752C37.3696 37.6752 38.0582 38.5984 38.4271 38.6475C38.4271 38.6524 38.855 38.4854 39.46 37.6752Z",
    fill: "url(#paint488_radial_578_447528)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4121 38.7162C38.4121 38.7162 37.7629 38.3479 37.3743 37.7242L36.9021 37.6751L37.3841 37.6408C37.3841 37.6408 37.5809 37.1742 38.4121 36.6292C38.4121 36.6292 37.4874 37.3166 37.4382 37.685C37.4333 37.685 37.6005 38.1122 38.4121 38.7162Z",
    fill: "url(#paint489_radial_578_447528)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4363 36.6292C38.4363 36.6292 39.0855 36.9975 39.4741 37.6211L39.9463 37.6702L39.4643 37.7046C39.4643 37.7046 39.2675 38.1711 38.4363 38.7162C38.4363 38.7162 39.361 38.0287 39.4102 37.6604C39.4151 37.6604 39.2479 37.2332 38.4363 36.6292Z",
    fill: "url(#paint490_radial_578_447528)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3696 37.6696C37.3696 37.6696 37.7385 37.0214 38.3631 36.6334L38.4123 36.162L38.4467 36.6432C38.4467 36.6432 38.914 36.8397 39.46 37.6696C39.46 37.6696 38.7714 36.7464 38.4025 36.6973C38.4025 36.6923 37.9746 36.8593 37.3696 37.6696Z",
    fill: "url(#paint491_radial_578_447528)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4756 42.817C43.4756 42.817 46.846 44.6121 47.0486 45.1921C47.2512 45.7721 47.1683 47.9907 47.1683 47.9907C47.1683 47.9907 47.1591 45.8089 47.2973 45.1921C47.4354 44.5753 51.1834 42.6973 51.1834 42.6973C51.1834 42.6973 47.6472 44.4924 47.1499 44.9895C47.1591 44.9803 45.2989 43.6731 43.4756 42.817Z",
    fill: "url(#paint492_radial_578_447528)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0273 35.3511L47.1785 38.2785L48.3019 35.3603L47.1785 38.0668L46.0273 35.3511Z",
    fill: "url(#paint493_radial_578_447528)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3296 35.0931L47.1785 36.9988L46.0273 35.0931L46.0458 35.3601L47.1785 38.1495L48.3019 35.3601L48.3296 35.0931Z",
    fill: "url(#paint494_radial_578_447528)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3296 35.0931L47.1785 37.9194L46.0273 35.0931L46.055 35.397L47.1785 38.168L48.2835 35.397L48.3296 35.0931Z",
    fill: "url(#paint495_radial_578_447528)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1785 37.9194V38.168L46.0458 35.3601L46.0273 35.0931L47.1785 37.9194Z",
    fill: "url(#paint496_radial_578_447528)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7451 36.8699L47.1503 37.9286L47.1779 38.1679L47.1871 37.9193L47.5923 36.8699L47.1779 37.8733L46.7451 36.8699Z",
    fill: "url(#paint497_radial_578_447528)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1781 35.8572L48.9462 34.3014L47.1781 33.1782L45.3916 34.3014L47.1781 35.8572Z",
    fill: "url(#paint498_radial_578_447528)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1781 35.8759L48.9462 34.3018L47.1781 35.4985L45.3916 34.3018L47.1781 35.8759Z",
    fill: "url(#paint499_radial_578_447528)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9462 34.3018L47.1781 35.8759L45.3916 34.3018L46.2204 35.1671L47.1781 36.1337L48.1266 35.1671L48.9462 34.3018Z",
    fill: "url(#paint500_radial_578_447528)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1781 35.4985V35.8759L45.3916 34.3018L47.1781 35.4985Z",
    fill: "url(#paint501_radial_578_447528)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7051 34.5039L47.1509 35.5258L47.1785 35.8756L47.1877 35.5258L48.6059 34.4763L47.1785 35.4798L45.7051 34.5039Z",
    fill: "url(#paint502_radial_578_447528)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6538 3.55334L47.3905 6.19543L50.0887 5.73513L47.4457 6.46239L47.9062 9.15976L47.1787 6.51764L44.4805 6.98715L47.1234 6.25067L46.6538 3.55334Z",
    fill: "url(#paint503_radial_578_447528)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1972 29.1277L53.8824 32.6536L57.6028 31.4476L54.085 33.1415L55.2822 36.8515L53.5969 33.3256L49.8857 34.5316L53.4035 32.8469L52.1972 29.1277Z",
    fill: "url(#paint504_radial_578_447528)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2313 29.1277L40.9166 32.6536L44.637 31.4476L41.1192 33.1415L42.3163 36.8515L40.6311 33.3256L36.9199 34.5316L40.4377 32.8469L39.2313 29.1277Z",
    fill: "url(#paint505_radial_578_447528)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9258 17.7188C45.1557 17.7277 45.4829 17.7453 45.6421 17.7542C45.8013 17.763 45.934 17.763 46.0313 17.763C46.1462 17.763 46.385 17.7542 46.7388 17.7277C46.8714 17.7188 46.9687 17.7188 47.0394 17.7188V18.1521C46.8449 18.161 46.7122 18.1876 46.6503 18.2229C46.5884 18.2583 46.5619 18.3202 46.5619 18.4086C46.5619 18.4528 46.5707 18.5059 46.5796 18.559C46.5884 18.6209 46.6149 18.6828 46.6415 18.7624L47.7558 22.1496L48.7994 18.7712C48.8347 18.6916 48.8524 18.6297 48.8613 18.5855C48.8701 18.5413 48.8701 18.4971 48.8701 18.444C48.8701 18.3379 48.8347 18.2671 48.7551 18.2141C48.6755 18.1699 48.5429 18.1433 48.366 18.1433V17.71C48.5429 17.7188 48.6756 17.7277 48.7905 17.7365C48.9055 17.7454 48.9939 17.7453 49.0735 17.7453C49.1354 17.7453 49.215 17.7454 49.3123 17.7365C49.4096 17.7277 49.6041 17.7276 49.781 17.71V18.1433C49.613 18.161 49.498 18.1875 49.4361 18.2317C49.3742 18.276 49.3211 18.3556 49.2946 18.4705L48.1007 21.9903C48.03 22.2026 47.9857 22.3707 47.8973 22.5917C47.8177 22.8217 47.7558 22.9455 47.6762 23.1843L47.1367 23.14L45.5006 18.6209L45.4918 18.5943C45.3857 18.2848 45.1999 18.1345 44.9346 18.1345L44.9258 17.7188Z",
    fill: "url(#paint506_radial_578_447528)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6778 17.8602C44.9166 17.8691 45.12 17.8868 45.288 17.8956C45.456 17.9044 45.5887 17.9044 45.686 17.9044C45.8098 17.9044 46.0486 17.8956 46.42 17.8779C46.5615 17.869 46.6588 17.8691 46.7295 17.8691V18.1609C46.5261 18.1698 46.3935 18.1963 46.3316 18.2316C46.2697 18.267 46.2431 18.3289 46.2431 18.4174C46.2431 18.4616 46.252 18.5058 46.2608 18.5677C46.2697 18.6296 46.2962 18.6915 46.3227 18.7711L47.4813 22.1052L48.5691 18.78C48.6044 18.7004 48.6221 18.6385 48.631 18.5942C48.6398 18.55 48.6398 18.5058 48.6398 18.4527C48.6398 18.3466 48.6044 18.2759 48.516 18.2316C48.4276 18.1874 48.2949 18.1609 48.1003 18.1609V17.8691C48.286 17.8779 48.4275 17.8868 48.5425 17.8956C48.6575 17.9044 48.7548 17.9044 48.8344 17.9044C48.8963 17.9044 48.9759 17.9044 49.082 17.8956C49.1881 17.8868 49.4623 17.8868 49.648 17.8691V18.1609C49.4711 18.1786 49.3561 18.2051 49.2854 18.2493C49.2235 18.2936 49.1704 18.3732 49.1351 18.4881L47.95 21.9549C47.8792 22.1583 47.7996 22.3706 47.72 22.5917C47.6316 22.8127 47.552 23.0427 47.4547 23.2814L46.9595 23.2372L45.2526 18.6296L45.2438 18.6031C45.1377 18.3024 44.9431 18.1432 44.6689 18.1432L44.6778 17.8602Z",
    fill: "url(#paint507_radial_578_447528)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8369 17.8427C45.0757 17.8515 45.2791 17.8692 45.4471 17.878C45.6152 17.8869 45.7478 17.8869 45.8451 17.8869C45.9689 17.8869 46.2077 17.878 46.5791 17.8604C46.7206 17.8515 46.8179 17.8515 46.8887 17.8515V18.1433C46.6853 18.1522 46.5526 18.1787 46.4907 18.2053C46.4288 18.2406 46.4023 18.3025 46.4023 18.391C46.4023 18.4352 46.4111 18.4794 46.42 18.5325C46.4288 18.5856 46.4553 18.6474 46.4819 18.727L47.6404 21.9904L48.7282 18.7359C48.7636 18.6563 48.7812 18.5944 48.7901 18.5502C48.7989 18.5059 48.7989 18.4617 48.7989 18.4175C48.7989 18.3202 48.7636 18.2495 48.6751 18.2053C48.5867 18.161 48.454 18.1433 48.2595 18.1433V17.8515C48.4452 17.8603 48.5867 17.8692 48.7017 17.878C48.8166 17.8869 48.9139 17.8869 48.9935 17.8869C49.0554 17.8869 49.135 17.8869 49.2411 17.878C49.3472 17.8692 49.4887 17.8692 49.6745 17.8515V18.1433C49.4976 18.161 49.3826 18.1876 49.3119 18.2318C49.25 18.276 49.1969 18.3467 49.1615 18.4617L47.9765 21.8577C47.9057 22.0611 47.8261 22.2734 47.7465 22.4856C47.6581 22.6979 47.5785 22.9278 47.4812 23.1666L47.1186 23.1224L45.4295 18.6209L45.4206 18.5944C45.3145 18.3025 45.1199 18.1522 44.8458 18.1522L44.8369 17.8427Z",
    fill: "url(#paint508_radial_578_447528)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5434 21.7784L46.4645 18.7272C46.4379 18.6477 46.4203 18.5858 46.4026 18.5327C46.3849 18.4796 46.3849 18.4266 46.3849 18.3912C46.3849 18.3381 46.3937 18.2939 46.4203 18.2585C46.3672 18.2674 46.3318 18.2851 46.2964 18.2939C46.2345 18.3293 46.208 18.3912 46.208 18.4796C46.208 18.5239 46.2169 18.5681 46.2257 18.6211C46.2345 18.6742 46.2611 18.7361 46.2876 18.8157L47.4461 22.079L47.5434 21.7784Z",
    fill: "url(#paint509_radial_578_447528)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2615 17.9665C45.4295 17.9753 45.5622 17.9753 45.6594 17.9753C45.7833 17.9753 46.022 17.9665 46.3935 17.9488C46.535 17.94 46.6323 17.9399 46.703 17.9399V18.1522C46.7561 18.1433 46.818 18.1433 46.8799 18.1433V17.8515C46.8091 17.8515 46.703 17.8604 46.5704 17.8604C46.2078 17.878 45.9601 17.8869 45.8363 17.8869C45.739 17.8869 45.6064 17.878 45.4383 17.878C45.2703 17.8692 45.0669 17.8603 44.8281 17.8427V17.9399C44.9962 17.9576 45.1377 17.9665 45.2615 17.9665Z",
    fill: "url(#paint510_radial_578_447528)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2239 17.8695C49.1177 17.8784 49.0381 17.8783 48.9762 17.8783C48.8966 17.8783 48.7993 17.8784 48.6844 17.8695C48.5694 17.8607 48.4191 17.8606 48.2422 17.843V17.9402C48.3483 17.9491 48.4279 17.9491 48.5075 17.9491C48.6225 17.9579 48.7198 17.958 48.7994 17.958C48.8613 17.958 48.9409 17.9579 49.047 17.9491C49.1531 17.9403 49.2946 17.9402 49.4803 17.9225V18.1525C49.5334 18.1436 49.5953 18.1348 49.6572 18.126V17.8341C49.4715 17.8606 49.3211 17.8695 49.2239 17.8695Z",
    fill: "url(#paint511_radial_578_447528)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1174 18.3116C49.0555 18.3558 49.0025 18.4265 48.9671 18.5415L47.782 21.9375C47.7113 22.1409 47.6317 22.3531 47.5521 22.5654C47.4813 22.7511 47.4106 22.9457 47.3398 23.1402L47.4813 23.1491C47.5698 22.9103 47.6582 22.6892 47.7467 22.4681C47.8351 22.2559 47.9058 22.0436 47.9766 21.8402L49.1617 18.4442C49.1882 18.3558 49.2236 18.2939 49.2766 18.2496C49.197 18.2762 49.1528 18.2939 49.1174 18.3116Z",
    fill: "url(#paint512_radial_578_447528)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3357 5.46732) scale(6.78308 6.78089)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_578_447528",
    x1: 47.3328,
    y1: 9.08271,
    x2: 47.3328,
    y2: 4.45825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1426,
    stopColor: "#EACAB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3661,
    stopColor: "#CC9C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5717,
    stopColor: "#B57847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7523,
    stopColor: "#A45F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9013,
    stopColor: "#9A4F11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#964909"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.5856 7.45834) scale(4.76614 4.7646)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1214,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2943,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7233,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9095,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.5861 10.9094) scale(6.25109 6.24905)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.2968 8.5557) scale(2.04625 2.04559)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.6212 3.1784) scale(5.16733 5.16568)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1214,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2943,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7233,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9095,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0365 8.45854) scale(4.52249 4.52104)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1214,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2943,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7233,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9095,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.588 9.0916) scale(4.21267 4.21133)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E59310"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2381,
    stopColor: "#B1730F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4835,
    stopColor: "#82560E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7014,
    stopColor: "#60410E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8809,
    stopColor: "#4C340D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#442F0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.2682 5.59497) scale(2.17698 2.17628)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#FDF1AD",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#FDEC9B",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#FEE37C",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#FFD752",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.1473 6.69053) scale(2.33629 2.33556)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E2D08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1755,
    stopColor: "#66340E",
    stopOpacity: 0.8245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4401,
    stopColor: "#7A461F",
    stopOpacity: 0.5599
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7591,
    stopColor: "#9C633A",
    stopOpacity: 0.2409
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA7E52",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.3188 6.37942) scale(3.17032 3.16933)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E2D08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1755,
    stopColor: "#66340E",
    stopOpacity: 0.8245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4401,
    stopColor: "#7A461F",
    stopOpacity: 0.5599
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7591,
    stopColor: "#9C633A",
    stopOpacity: 0.2409
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA7E52",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.8826 8.93824) scale(1.54169 1.54121)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E2D08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1755,
    stopColor: "#66340E",
    stopOpacity: 0.8245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4401,
    stopColor: "#7A461F",
    stopOpacity: 0.5599
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7591,
    stopColor: "#9C633A",
    stopOpacity: 0.2409
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA7E52",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.743 3.77031) scale(3.83675 3.83554)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E2D08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1755,
    stopColor: "#66340E",
    stopOpacity: 0.8245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4401,
    stopColor: "#7A461F",
    stopOpacity: 0.5599
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7591,
    stopColor: "#9C633A",
    stopOpacity: 0.2409
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA7E52",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3546 4.01127) scale(2.31162 2.31087)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.1266 7.27464) scale(1.23538 1.23498)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#FDF1AD",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#FDEC9B",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#FEE37C",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#FFD752",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.5338 7.26317) rotate(180) scale(1.23537 1.23498)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#FDF1AD",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#FDEC9B",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#FEE37C",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#FFD752",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3213 8.24523) scale(1.11458 1.11422)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#FDF1AD",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#FDEC9B",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#FEE37C",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#FFD752",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.2714 5.89235) scale(1.87139 1.8708)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.4215 3.80918) scale(10.0419 10.0387)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.6117 5.53326) scale(5.70249 5.70029)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.8692 5.39314) scale(3.05103 3.05007)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9806 6.74378) scale(1.14119 1.14075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.0829 7.35405) scale(0.989296 0.989043)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.6005 5.10302) scale(2.70422 2.70337)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3712 6.65428) scale(1.67416 1.67362)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.8347 6.88583) scale(23.849 23.8414)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EEE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    stopColor: "#F1E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6827,
    stopColor: "#DFD6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC3BA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.3032 19.7392) rotate(0.350465) scale(23.5039 5.31856)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E857E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2256,
    stopColor: "#958C84",
    stopOpacity: 0.7744
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5468,
    stopColor: "#A79E96",
    stopOpacity: 0.4532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9236,
    stopColor: "#C6BCB3",
    stopOpacity: 0.0763797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC3BA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.1193 12.4022) scale(18.3714 18.3655)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8ECAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0912484,
    stopColor: "#F4E4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#E5C57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7893,
    stopColor: "#DBB26A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#D8AB63"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.8605 -6.79227) scale(32.6011 32.5899)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.2721 13.9249) scale(13.2875 13.2833)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#FDF0DF",
    stopOpacity: 0.845
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#F9E6CD",
    stopOpacity: 0.6244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6355,
    stopColor: "#F2D7AE",
    stopOpacity: 0.3645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9233,
    stopColor: "#E8C284",
    stopOpacity: 0.0766657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.3792 -7.30281) scale(55.3379 55.3197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.3494 12.0528) scale(27.8051 27.7966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#FDF0DF",
    stopOpacity: 0.845
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#F9E6CD",
    stopOpacity: 0.6244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6355,
    stopColor: "#F2D7AE",
    stopOpacity: 0.3645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9233,
    stopColor: "#E8C284",
    stopOpacity: 0.0766657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.0726 15.9475) scale(8.97979 8.97696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2561,
    stopColor: "#F9EFE7",
    stopOpacity: 0.7437
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6207,
    stopColor: "#E7DDD5",
    stopOpacity: 0.379
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    stopColor: "#CDC3BA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.0547 18.0031) scale(29.942 29.9324)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EEE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    stopColor: "#F1E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6827,
    stopColor: "#DFD6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC3BA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.2113 22.8819) rotate(9.07456) scale(11.7989 3.57357)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E857E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2256,
    stopColor: "#958C84",
    stopOpacity: 0.7744
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5468,
    stopColor: "#A79E96",
    stopOpacity: 0.4532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9236,
    stopColor: "#C6BCB3",
    stopOpacity: 0.0763797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC3BA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.0062 16.6049) scale(8.1336 8.13104)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8ECAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0912484,
    stopColor: "#F4E4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#E5C57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7893,
    stopColor: "#DBB26A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#D8AB63"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.2378 3.15016) scale(59.5354 59.5162)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#FDF0DF",
    stopOpacity: 0.845
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#F9E6CD",
    stopOpacity: 0.6244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6355,
    stopColor: "#F2D7AE",
    stopOpacity: 0.3645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9233,
    stopColor: "#E8C284",
    stopOpacity: 0.0766657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.7317 21.2749) scale(0.0318357 0.0318393)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#FDF0DF",
    stopOpacity: 0.845
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#F9E6CD",
    stopOpacity: 0.6244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6355,
    stopColor: "#F2D7AE",
    stopOpacity: 0.3645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9233,
    stopColor: "#E8C284",
    stopOpacity: 0.0766657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.6168 2.25224) scale(25.9967 25.9885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.9307 16.8908) scale(10.473 10.4699)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#FDF0DF",
    stopOpacity: 0.845
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#F9E6CD",
    stopOpacity: 0.6244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6355,
    stopColor: "#F2D7AE",
    stopOpacity: 0.3645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9233,
    stopColor: "#E8C284",
    stopOpacity: 0.0766657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.4854 8.24182) scale(24.0548 24.0468)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.6528 21.0934) scale(12.897 12.8929)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2561,
    stopColor: "#F9EFE7",
    stopOpacity: 0.7437
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6207,
    stopColor: "#E7DDD5",
    stopOpacity: 0.379
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    stopColor: "#CDC3BA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.4301 20.2413) scale(8.07178 8.06919)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8ECAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0912484,
    stopColor: "#F4E4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#E5C57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7893,
    stopColor: "#DBB26A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#D8AB63"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.43 20.2381) scale(19.1945 19.1883)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#FDF0DF",
    stopOpacity: 0.845
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#F9E6CD",
    stopOpacity: 0.6244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6355,
    stopColor: "#F2D7AE",
    stopOpacity: 0.3645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9233,
    stopColor: "#E8C284",
    stopOpacity: 0.0766657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.1061 7.3663) scale(23.8285 23.821)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.5806 19.6519) scale(12.5672 12.5632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#FDF0DF",
    stopOpacity: 0.845
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#F9E6CD",
    stopOpacity: 0.6244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6355,
    stopColor: "#F2D7AE",
    stopOpacity: 0.3645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9233,
    stopColor: "#E8C284",
    stopOpacity: 0.0766657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.9059 12.2949) scale(20.9225 20.9159)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.006 23.1513) scale(8.90924 8.90644)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2561,
    stopColor: "#F9EFE7",
    stopOpacity: 0.7437
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6207,
    stopColor: "#E7DDD5",
    stopOpacity: 0.379
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    stopColor: "#CDC3BA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.6302 26.7973) rotate(16.9392) scale(11.8989 2.31182)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E857E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2256,
    stopColor: "#958C84",
    stopOpacity: 0.7744
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5468,
    stopColor: "#A79E96",
    stopOpacity: 0.4532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9236,
    stopColor: "#C6BCB3",
    stopOpacity: 0.0763797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC3BA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.9464 28.496) scale(13.9508 13.9464)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EEE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    stopColor: "#F1E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6827,
    stopColor: "#DFD6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC3BA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.0172 24.7691) scale(6.92977 6.92761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8ECAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0912484,
    stopColor: "#F4E4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#E5C57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7893,
    stopColor: "#DBB26A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#D8AB63"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.6238 24.6849) scale(10.7627 10.7592)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#FDF0DF",
    stopOpacity: 0.845
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#F9E6CD",
    stopOpacity: 0.6244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6355,
    stopColor: "#F2D7AE",
    stopOpacity: 0.3645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9233,
    stopColor: "#E8C284",
    stopOpacity: 0.0766657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.3271 13.5876) scale(24.6101 24.6023)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.8957 23.6599) scale(7.90817 7.9057)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#FDF0DF",
    stopOpacity: 0.845
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#F9E6CD",
    stopOpacity: 0.6244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6355,
    stopColor: "#F2D7AE",
    stopOpacity: 0.3645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9233,
    stopColor: "#E8C284",
    stopOpacity: 0.0766657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.2457 17.5639) scale(25.7235 25.7153)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.0981 30.1197) scale(10.4281 10.4248)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2561,
    stopColor: "#F9EFE7",
    stopOpacity: 0.7437
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6207,
    stopColor: "#E7DDD5",
    stopOpacity: 0.379
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    stopColor: "#CDC3BA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.8231 6.88595) rotate(180) scale(23.849 23.8414)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EEE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    stopColor: "#F1E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6827,
    stopColor: "#DFD6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC3BA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.3567 19.7381) rotate(179.65) scale(23.5039 5.31856)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E857E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2256,
    stopColor: "#958C84",
    stopOpacity: 0.7744
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5468,
    stopColor: "#A79E96",
    stopOpacity: 0.4532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9236,
    stopColor: "#C6BCB3",
    stopOpacity: 0.0763797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC3BA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5384 12.4023) rotate(180) scale(18.3714 18.3655)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8ECAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0912484,
    stopColor: "#F4E4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#E5C57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7893,
    stopColor: "#DBB26A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#D8AB63"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.7969 -6.79215) rotate(180) scale(32.6011 32.5899)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.3856 13.925) rotate(180) scale(13.2875 13.2833)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#FDF0DF",
    stopOpacity: 0.845
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#F9E6CD",
    stopOpacity: 0.6244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6355,
    stopColor: "#F2D7AE",
    stopOpacity: 0.3645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9233,
    stopColor: "#E8C284",
    stopOpacity: 0.0766657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.2787 -7.30268) rotate(180) scale(55.3379 55.3197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.3079 12.0531) rotate(180) scale(27.8051 27.7966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#FDF0DF",
    stopOpacity: 0.845
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#F9E6CD",
    stopOpacity: 0.6244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6355,
    stopColor: "#F2D7AE",
    stopOpacity: 0.3645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9233,
    stopColor: "#E8C284",
    stopOpacity: 0.0766657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.5854 15.9476) rotate(180) scale(8.97978 8.97696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2561,
    stopColor: "#F9EFE7",
    stopOpacity: 0.7437
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6207,
    stopColor: "#E7DDD5",
    stopOpacity: 0.379
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    stopColor: "#CDC3BA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6037 18.0032) rotate(180) scale(29.942 29.9324)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EEE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    stopColor: "#F1E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6827,
    stopColor: "#DFD6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC3BA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.4992 22.8811) rotate(170.925) scale(11.7989 3.57357)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E857E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2256,
    stopColor: "#958C84",
    stopOpacity: 0.7744
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5468,
    stopColor: "#A79E96",
    stopOpacity: 0.4532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9236,
    stopColor: "#C6BCB3",
    stopOpacity: 0.0763797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC3BA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.6513 16.6049) rotate(180) scale(8.1336 8.13101)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8ECAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0912484,
    stopColor: "#F4E4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#E5C57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7893,
    stopColor: "#DBB26A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#D8AB63"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.41978 3.15021) rotate(180) scale(59.5353 59.5159)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#FDF0DF",
    stopOpacity: 0.845
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#F9E6CD",
    stopOpacity: 0.6244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6355,
    stopColor: "#F2D7AE",
    stopOpacity: 0.3645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9233,
    stopColor: "#E8C284",
    stopOpacity: 0.0766657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.94198 21.2754) scale(0.0318371 0.0318323)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#FDF0DF",
    stopOpacity: 0.845
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#F9E6CD",
    stopOpacity: 0.6244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6355,
    stopColor: "#F2D7AE",
    stopOpacity: 0.3645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9233,
    stopColor: "#E8C284",
    stopOpacity: 0.0766657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.041 2.25236) rotate(180) scale(25.9967 25.9885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.7266 16.8909) rotate(180) scale(10.473 10.4699)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#FDF0DF",
    stopOpacity: 0.845
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#F9E6CD",
    stopOpacity: 0.6244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6355,
    stopColor: "#F2D7AE",
    stopOpacity: 0.3645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9233,
    stopColor: "#E8C284",
    stopOpacity: 0.0766657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.1717 8.24211) rotate(180) scale(24.0548 24.0466)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0051 21.0936) rotate(180) scale(12.897 12.8929)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2561,
    stopColor: "#F9EFE7",
    stopOpacity: 0.7437
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6207,
    stopColor: "#E7DDD5",
    stopOpacity: 0.379
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    stopColor: "#CDC3BA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.2264 20.2416) rotate(180) scale(8.07178 8.06919)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8ECAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0912484,
    stopColor: "#F4E4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#E5C57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7893,
    stopColor: "#DBB26A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#D8AB63"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2264 20.2388) rotate(180) scale(19.1945 19.1883)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#FDF0DF",
    stopOpacity: 0.845
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#F9E6CD",
    stopOpacity: 0.6244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6355,
    stopColor: "#F2D7AE",
    stopOpacity: 0.3645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9233,
    stopColor: "#E8C284",
    stopOpacity: 0.0766657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5508 7.36642) rotate(180) scale(23.8285 23.821)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.077 19.6522) rotate(180) scale(12.5672 12.5633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#FDF0DF",
    stopOpacity: 0.845
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#F9E6CD",
    stopOpacity: 0.6244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6355,
    stopColor: "#F2D7AE",
    stopOpacity: 0.3645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9233,
    stopColor: "#E8C284",
    stopOpacity: 0.0766657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.752 12.2952) rotate(180) scale(20.9225 20.9159)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.6516 23.1514) rotate(180) scale(8.90925 8.90645)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2561,
    stopColor: "#F9EFE7",
    stopOpacity: 0.7437
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6207,
    stopColor: "#E7DDD5",
    stopOpacity: 0.379
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    stopColor: "#CDC3BA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0448 26.809) rotate(163.061) scale(11.8989 2.31182)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E857E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2256,
    stopColor: "#958C84",
    stopOpacity: 0.7744
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5468,
    stopColor: "#A79E96",
    stopOpacity: 0.4532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9236,
    stopColor: "#C6BCB3",
    stopOpacity: 0.0763797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC3BA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.7115 28.496) rotate(180) scale(13.9509 13.9464)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EEE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    stopColor: "#F1E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6827,
    stopColor: "#DFD6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC3BA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.6409 24.7692) rotate(180) scale(6.92977 6.92761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8ECAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0912484,
    stopColor: "#F4E4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#E5C57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7893,
    stopColor: "#DBB26A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#D8AB63"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.0338 24.6849) rotate(180) scale(10.7627 10.7592)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#FDF0DF",
    stopOpacity: 0.845
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#F9E6CD",
    stopOpacity: 0.6244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6355,
    stopColor: "#F2D7AE",
    stopOpacity: 0.3645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9233,
    stopColor: "#E8C284",
    stopOpacity: 0.0766657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.3306 13.5877) rotate(180) scale(24.6101 24.6023)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.763 23.66) rotate(180) scale(7.90817 7.9057)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#FDF0DF",
    stopOpacity: 0.845
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#F9E6CD",
    stopOpacity: 0.6244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6355,
    stopColor: "#F2D7AE",
    stopOpacity: 0.3645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9233,
    stopColor: "#E8C284",
    stopOpacity: 0.0766657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.4125 17.564) rotate(180) scale(25.7235 25.7153)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5594 30.1199) rotate(180) scale(10.4286 10.4253)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2561,
    stopColor: "#F9EFE7",
    stopOpacity: 0.7437
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6207,
    stopColor: "#E7DDD5",
    stopOpacity: 0.379
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    stopColor: "#CDC3BA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.1041 15.2423) scale(10.8427 10.8393)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8ECAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0912484,
    stopColor: "#F4E4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#E5C57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7893,
    stopColor: "#DBB26A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#D8AB63"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.1023 18.9811) scale(18.2287 18.223)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.9738 19.2124) scale(9.41996 9.41698)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.4681 23.867) rotate(-40.3435) scale(10.8012 5.347)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8944A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4017,
    stopColor: "#E1B168",
    stopOpacity: 0.5983
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7531,
    stopColor: "#E6C37A",
    stopOpacity: 0.2469
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8C981",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.5561 17.8419) scale(9.29104 9.28809)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0288684,
    stopColor: "#FDF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    stopColor: "#FAEDAD",
    stopOpacity: 0.7695
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5714,
    stopColor: "#F3DC9B",
    stopOpacity: 0.4414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9453,
    stopColor: "#E7C17C",
    stopOpacity: 0.0563537
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.1286 13.0707) scale(3.88991 3.88868)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1683,
    stopColor: "#FDF5D2",
    stopOpacity: 0.8317
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4079,
    stopColor: "#F8E9C0",
    stopOpacity: 0.5921
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6902,
    stopColor: "#F0D6A1",
    stopOpacity: 0.3098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.1715 18.7758) rotate(107.178) scale(5.27953 5.28098)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.8289 18.3539) scale(3.8159 3.81457)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0288684,
    stopColor: "#FDF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    stopColor: "#FAEDAD",
    stopOpacity: 0.7695
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5714,
    stopColor: "#F3DC9B",
    stopOpacity: 0.4414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9453,
    stopColor: "#E7C17C",
    stopOpacity: 0.0563537
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.7221 13.1015) scale(6.34773 6.34568)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0288684,
    stopColor: "#FDF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    stopColor: "#FAEDAD",
    stopOpacity: 0.7695
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5714,
    stopColor: "#F3DC9B",
    stopOpacity: 0.4414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9453,
    stopColor: "#E7C17C",
    stopOpacity: 0.0563537
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2221 15.2423) rotate(180) scale(10.8427 10.8393)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8ECAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0912484,
    stopColor: "#F4E4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#E5C57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7893,
    stopColor: "#DBB26A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9991,
    stopColor: "#D8AB63"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.2244 18.9808) rotate(180) scale(18.2287 18.223)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.3524 19.2124) rotate(180) scale(9.41997 9.41698)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.8157 23.894) rotate(-139.656) scale(10.8012 5.347)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8944A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4017,
    stopColor: "#E1B168",
    stopOpacity: 0.5983
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7531,
    stopColor: "#E6C37A",
    stopOpacity: 0.2469
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8C981",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.7703 17.8419) rotate(180) scale(9.29104 9.28809)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0288684,
    stopColor: "#FDF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    stopColor: "#FAEDAD",
    stopOpacity: 0.7695
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5714,
    stopColor: "#F3DC9B",
    stopOpacity: 0.4414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9453,
    stopColor: "#E7C17C",
    stopOpacity: 0.0563537
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1987 13.0707) rotate(180) scale(3.88991 3.88868)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1683,
    stopColor: "#FDF5D2",
    stopOpacity: 0.8317
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4079,
    stopColor: "#F8E9C0",
    stopOpacity: 0.5921
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6902,
    stopColor: "#F0D6A1",
    stopOpacity: 0.3098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.179 18.8006) rotate(72.8223) scale(5.27953 5.28098)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.4979 18.3539) rotate(180) scale(3.8159 3.81457)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0288684,
    stopColor: "#FDF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    stopColor: "#FAEDAD",
    stopOpacity: 0.7695
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5714,
    stopColor: "#F3DC9B",
    stopOpacity: 0.4414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9453,
    stopColor: "#E7C17C",
    stopOpacity: 0.0563537
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6048 13.1015) rotate(180) scale(6.34773 6.34568)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0288684,
    stopColor: "#FDF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    stopColor: "#FAEDAD",
    stopOpacity: 0.7695
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5714,
    stopColor: "#F3DC9B",
    stopOpacity: 0.4414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9453,
    stopColor: "#E7C17C",
    stopOpacity: 0.0563537
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.1043 3.47745) scale(12.5734 12.5694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.2161 13.323) scale(23.4621 23.4547)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.8384 13.6705) scale(4.58981 4.58836)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E3900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1141,
    stopColor: "#924004",
    stopOpacity: 0.8859
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2767,
    stopColor: "#9E520F",
    stopOpacity: 0.7233
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4684,
    stopColor: "#B27121",
    stopOpacity: 0.5316
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6822,
    stopColor: "#CD9C39",
    stopOpacity: 0.3178
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9117,
    stopColor: "#EFD259",
    stopOpacity: 0.0883256
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.7756 7.45579) scale(6.62253 6.62044)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E3900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1141,
    stopColor: "#924004",
    stopOpacity: 0.8859
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2767,
    stopColor: "#9E520F",
    stopOpacity: 0.7233
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4684,
    stopColor: "#B27121",
    stopOpacity: 0.5316
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6822,
    stopColor: "#CD9C39",
    stopOpacity: 0.3178
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9117,
    stopColor: "#EFD259",
    stopOpacity: 0.0883256
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.5841 9.08327) scale(10.3664 10.3631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.8142 5.56307) scale(6.47026 6.46821)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.1435 5.10802) scale(8.2377 8.23505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.9392 6.66811) scale(5.4366 5.43482)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00147628,
    stopColor: "#B2450F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2058,
    stopColor: "#B44C14",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4966,
    stopColor: "#B85E24",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8377,
    stopColor: "#BF7D3C",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.1154 1.22326) scale(6.92369 6.92149)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.6968 -0.593518) scale(6.15038 6.14849)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.3976 7.97973) scale(7.72355 7.72111)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00147628,
    stopColor: "#B2450F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2058,
    stopColor: "#B44C14",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4966,
    stopColor: "#B85E24",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8377,
    stopColor: "#BF7D3C",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.1958 14.3341) scale(6.82175 6.81954)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#890D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2818,
    stopColor: "#AD0800",
    stopOpacity: 0.7182
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5747,
    stopColor: "#CC0400",
    stopOpacity: 0.4253
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8245,
    stopColor: "#DE0200",
    stopOpacity: 0.1755
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E50100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.5351 4.58582) scale(4.91982 4.91828)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.8668 16.3242) scale(7.07095 7.06869)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.5867 10.8509) scale(3.85577 3.85455)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.5433 -0.0139889) scale(8.29168 8.28891)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E3900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1141,
    stopColor: "#924004",
    stopOpacity: 0.8859
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2767,
    stopColor: "#9E520F",
    stopOpacity: 0.7233
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4684,
    stopColor: "#B27121",
    stopOpacity: 0.5316
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6822,
    stopColor: "#CD9C39",
    stopOpacity: 0.3178
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9117,
    stopColor: "#EFD259",
    stopOpacity: 0.0883256
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.9131 1.27445) scale(3.20154 3.20048)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.9001 5.46736) scale(6.02059 6.01871)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.4231 5.74616) scale(4.42504 4.42364)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.8678 7.4046) scale(8.22903 8.22641)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.3595 9.24923) scale(5.19569 5.19414)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.2197 3.47745) rotate(180) scale(12.5734 12.5694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.1078 13.323) rotate(180) scale(23.4621 23.4547)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.4855 13.6705) rotate(180) scale(4.58981 4.58836)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E3900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1141,
    stopColor: "#924004",
    stopOpacity: 0.8859
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2767,
    stopColor: "#9E520F",
    stopOpacity: 0.7233
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4684,
    stopColor: "#B27121",
    stopOpacity: 0.5316
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6822,
    stopColor: "#CD9C39",
    stopOpacity: 0.3178
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9117,
    stopColor: "#EFD259",
    stopOpacity: 0.0883256
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.5483 7.45579) rotate(180) scale(6.62253 6.62044)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E3900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1141,
    stopColor: "#924004",
    stopOpacity: 0.8859
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2767,
    stopColor: "#9E520F",
    stopOpacity: 0.7233
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4684,
    stopColor: "#B27121",
    stopOpacity: 0.5316
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6822,
    stopColor: "#CD9C39",
    stopOpacity: 0.3178
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9117,
    stopColor: "#EFD259",
    stopOpacity: 0.0883256
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.7398 9.08315) rotate(180) scale(10.3664 10.3631)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.5101 5.56295) rotate(180) scale(6.47025 6.4682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.1806 5.10814) rotate(180) scale(8.23769 8.23505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.3849 6.66811) rotate(180) scale(5.43659 5.43482)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00147628,
    stopColor: "#B2450F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2058,
    stopColor: "#B44C14",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4966,
    stopColor: "#B85E24",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8377,
    stopColor: "#BF7D3C",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.2084 1.22302) rotate(180) scale(6.92368 6.92149)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.6276 -0.59364) rotate(180) scale(6.15036 6.14849)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.9264 7.97949) rotate(180) scale(7.72355 7.72111)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00147628,
    stopColor: "#B2450F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2058,
    stopColor: "#B44C14",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4966,
    stopColor: "#B85E24",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8377,
    stopColor: "#BF7D3C",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.128 14.334) rotate(180) scale(6.82175 6.81953)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#890D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2818,
    stopColor: "#AD0800",
    stopOpacity: 0.7182
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5747,
    stopColor: "#CC0400",
    stopOpacity: 0.4253
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8245,
    stopColor: "#DE0200",
    stopOpacity: 0.1755
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E50100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.7896 4.5857) rotate(180) scale(4.91982 4.91829)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.457 16.3241) rotate(180) scale(7.07095 7.06869)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7377 10.8508) rotate(180) scale(3.85577 3.85453)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.7819 -0.014111) rotate(180) scale(8.29169 8.28891)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E3900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1141,
    stopColor: "#924004",
    stopOpacity: 0.8859
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2767,
    stopColor: "#9E520F",
    stopOpacity: 0.7233
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4684,
    stopColor: "#B27121",
    stopOpacity: 0.5316
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6822,
    stopColor: "#CD9C39",
    stopOpacity: 0.3178
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9117,
    stopColor: "#EFD259",
    stopOpacity: 0.0883256
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.4099 1.27445) rotate(180) scale(3.20154 3.20048)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.4236 5.46723) rotate(180) scale(6.02059 6.0187)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.9007 5.74592) rotate(180) scale(4.42503 4.42364)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.4569 7.40448) rotate(180) scale(8.22903 8.22642)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.9645 9.24923) rotate(180) scale(5.19569 5.19415)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1425 12.5783) scale(20.7627 20.7561)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E50100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#680500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.026 30.1382) scale(26.4348 10.5191)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E50100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C0A00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.1119 7.52887) scale(27.3128 27.3042)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    stopColor: "#FA632C",
    stopOpacity: 0.8769
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3964,
    stopColor: "#F13919",
    stopOpacity: 0.6036
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6433,
    stopColor: "#EB1A0B",
    stopOpacity: 0.3567
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8528,
    stopColor: "#E60803",
    stopOpacity: 0.1472
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E50100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.2444 34.3202) scale(12.4987 12.4948)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1018,
    stopColor: "#FCE7DC",
    stopOpacity: 0.8982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#F3D5CA",
    stopOpacity: 0.7531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#E5B6AB",
    stopOpacity: 0.582
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6089,
    stopColor: "#D18B80",
    stopOpacity: 0.3911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8135,
    stopColor: "#B7564A",
    stopOpacity: 0.1865
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D1E12",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.5522 21.994) scale(7.47319 7.47081)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1018,
    stopColor: "#FCE7DC",
    stopOpacity: 0.8982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#F3D5CA",
    stopOpacity: 0.7531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#E5B6AB",
    stopOpacity: 0.582
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6089,
    stopColor: "#D18B80",
    stopOpacity: 0.3911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8135,
    stopColor: "#B7564A",
    stopOpacity: 0.1865
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D1E12",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.5214 18.6208) scale(7.12254 7.1203)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1018,
    stopColor: "#FCE7DC",
    stopOpacity: 0.8982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#F3D5CA",
    stopOpacity: 0.7531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#E5B6AB",
    stopOpacity: 0.582
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6089,
    stopColor: "#D18B80",
    stopOpacity: 0.3911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8135,
    stopColor: "#B7564A",
    stopOpacity: 0.1865
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D1E12",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.951 16.4133) scale(7.54635 7.54395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1018,
    stopColor: "#FCE7DC",
    stopOpacity: 0.8982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#F3D5CA",
    stopOpacity: 0.7531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#E5B6AB",
    stopOpacity: 0.582
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6089,
    stopColor: "#D18B80",
    stopOpacity: 0.3911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8135,
    stopColor: "#B7564A",
    stopOpacity: 0.1865
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D1E12",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.5038 15.4766) rotate(9.85311) scale(4.26451 4.26323)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1018,
    stopColor: "#FCE7DC",
    stopOpacity: 0.8982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#F3D5CA",
    stopOpacity: 0.7531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#E5B6AB",
    stopOpacity: 0.582
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6089,
    stopColor: "#D18B80",
    stopOpacity: 0.3911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8135,
    stopColor: "#B7564A",
    stopOpacity: 0.1865
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D1E12",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.8645 14.083) scale(3.21399 3.21296)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1018,
    stopColor: "#FCE7DC",
    stopOpacity: 0.8982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#F3D5CA",
    stopOpacity: 0.7531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#E5B6AB",
    stopOpacity: 0.582
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6089,
    stopColor: "#D18B80",
    stopOpacity: 0.3911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8135,
    stopColor: "#B7564A",
    stopOpacity: 0.1865
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D1E12",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.5458 7.52883) rotate(180) scale(27.3128 27.3042)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    stopColor: "#FA632C",
    stopOpacity: 0.8769
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3964,
    stopColor: "#F13919",
    stopOpacity: 0.6036
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6433,
    stopColor: "#EB1A0B",
    stopOpacity: 0.3567
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8528,
    stopColor: "#E60803",
    stopOpacity: 0.1472
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E50100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.413 34.3201) rotate(180) scale(12.4987 12.4948)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1018,
    stopColor: "#FCE7DC",
    stopOpacity: 0.8982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#F3D5CA",
    stopOpacity: 0.7531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#E5B6AB",
    stopOpacity: 0.582
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6089,
    stopColor: "#D18B80",
    stopOpacity: 0.3911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8135,
    stopColor: "#B7564A",
    stopOpacity: 0.1865
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D1E12",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.1058 21.9937) rotate(180) scale(7.47318 7.47081)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1018,
    stopColor: "#FCE7DC",
    stopOpacity: 0.8982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#F3D5CA",
    stopOpacity: 0.7531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#E5B6AB",
    stopOpacity: 0.582
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6089,
    stopColor: "#D18B80",
    stopOpacity: 0.3911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8135,
    stopColor: "#B7564A",
    stopOpacity: 0.1865
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D1E12",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.1366 18.6205) rotate(180) scale(7.12254 7.1203)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1018,
    stopColor: "#FCE7DC",
    stopOpacity: 0.8982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#F3D5CA",
    stopOpacity: 0.7531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#E5B6AB",
    stopOpacity: 0.582
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6089,
    stopColor: "#D18B80",
    stopOpacity: 0.3911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8135,
    stopColor: "#B7564A",
    stopOpacity: 0.1865
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D1E12",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7072 16.413) rotate(180) scale(7.54634 7.54396)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1018,
    stopColor: "#FCE7DC",
    stopOpacity: 0.8982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#F3D5CA",
    stopOpacity: 0.7531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#E5B6AB",
    stopOpacity: 0.582
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6089,
    stopColor: "#D18B80",
    stopOpacity: 0.3911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8135,
    stopColor: "#B7564A",
    stopOpacity: 0.1865
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D1E12",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint161_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.2036 15.4523) rotate(170.147) scale(4.26449 4.26323)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1018,
    stopColor: "#FCE7DC",
    stopOpacity: 0.8982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#F3D5CA",
    stopOpacity: 0.7531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#E5B6AB",
    stopOpacity: 0.582
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6089,
    stopColor: "#D18B80",
    stopOpacity: 0.3911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8135,
    stopColor: "#B7564A",
    stopOpacity: 0.1865
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D1E12",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.7924 14.0827) rotate(180) scale(3.21399 3.21296)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1018,
    stopColor: "#FCE7DC",
    stopOpacity: 0.8982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#F3D5CA",
    stopOpacity: 0.7531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#E5B6AB",
    stopOpacity: 0.582
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6089,
    stopColor: "#D18B80",
    stopOpacity: 0.3911
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8135,
    stopColor: "#B7564A",
    stopOpacity: 0.1865
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D1E12",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.9208 23.496) scale(19.3607 19.3545)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE9E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0347985,
    stopColor: "#FEDDD5",
    stopOpacity: 0.9652
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2383,
    stopColor: "#F69B95",
    stopOpacity: 0.7617
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4317,
    stopColor: "#F06460",
    stopOpacity: 0.5683
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6099,
    stopColor: "#EB3937",
    stopOpacity: 0.3901
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7696,
    stopColor: "#E81A19",
    stopOpacity: 0.2304
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#E60806",
    stopOpacity: 0.0950359
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E50100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.9205 23.4966) scale(19.3607 19.3545)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1568,
    stopColor: "#F99A87",
    stopOpacity: 0.8432
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3689,
    stopColor: "#F26457",
    stopOpacity: 0.6311
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5667,
    stopColor: "#EC3931",
    stopOpacity: 0.4333
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#E81A16",
    stopOpacity: 0.256
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8944,
    stopColor: "#E60806",
    stopOpacity: 0.1056
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E50100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint165_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.835 23.496) rotate(180) scale(19.3607 19.3545)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE9E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0347985,
    stopColor: "#FEDDD5",
    stopOpacity: 0.9652
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2383,
    stopColor: "#F69B95",
    stopOpacity: 0.7617
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4317,
    stopColor: "#F06460",
    stopOpacity: 0.5683
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6099,
    stopColor: "#EB3937",
    stopOpacity: 0.3901
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7696,
    stopColor: "#E81A19",
    stopOpacity: 0.2304
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#E60806",
    stopOpacity: 0.0950359
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E50100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8353 23.4966) rotate(180) scale(19.3607 19.3545)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1568,
    stopColor: "#F99A87",
    stopOpacity: 0.8432
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3689,
    stopColor: "#F26457",
    stopOpacity: 0.6311
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5667,
    stopColor: "#EC3931",
    stopOpacity: 0.4333
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#E81A16",
    stopOpacity: 0.256
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8944,
    stopColor: "#E60806",
    stopOpacity: 0.1056
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E50100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint167_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0201 32.2126) scale(17.748 17.7424)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#554175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3156,
    stopColor: "#513E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7637,
    stopColor: "#45365C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D314F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.3537 45.413) scale(15.7019 15.697)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.9549 51.0131) scale(18.7421 18.7363)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.8627 9.54502) scale(8.19547 8.19286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint171_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.7927 8.88379) scale(8.68885 8.6861)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1028,
    stopColor: "#FFF8EE",
    stopOpacity: 0.8972
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2493,
    stopColor: "#FFF0DC",
    stopOpacity: 0.7507
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#FFE3BD",
    stopOpacity: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#FFD092",
    stopOpacity: 0.3852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8213,
    stopColor: "#FFB95C",
    stopOpacity: 0.1787
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA227",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint172_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.0999 8.3782) scale(19.6629 19.6567)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.9609 13.8074) scale(16.1536 16.1485)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331A0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#3A1F0E",
    stopOpacity: 0.8696
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3161,
    stopColor: "#4C2E16",
    stopOpacity: 0.6839
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#6B4724",
    stopOpacity: 0.465
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#956936",
    stopOpacity: 0.223
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint174_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.7944 9.5449) rotate(180) scale(8.19558 8.19298)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint175_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.8655 8.88366) rotate(180) scale(8.68885 8.6861)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1028,
    stopColor: "#FFF8EE",
    stopOpacity: 0.8972
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2493,
    stopColor: "#FFF0DC",
    stopOpacity: 0.7507
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#FFE3BD",
    stopOpacity: 0.578
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6148,
    stopColor: "#FFD092",
    stopOpacity: 0.3852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8213,
    stopColor: "#FFB95C",
    stopOpacity: 0.1787
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA227",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint176_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.5582 8.37808) rotate(180) scale(19.6629 19.6567)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint177_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.6973 13.8073) rotate(180) scale(16.1536 16.1485)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331A0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#3A1F0E",
    stopOpacity: 0.8696
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3161,
    stopColor: "#4C2E16",
    stopOpacity: 0.6839
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#6B4724",
    stopOpacity: 0.465
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#956936",
    stopOpacity: 0.223
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint178_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.3504 19.5407) scale(24.1396 24.1319)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E59310"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#D98C0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4883,
    stopColor: "#B7780D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7959,
    stopColor: "#A26B0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B670B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint179_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.8989 17.8205) scale(11.632 11.628)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint180_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.0899 16.8963) scale(5.57858 5.57683)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2333,
    stopColor: "#AF6C02",
    stopOpacity: 0.7667
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#C47B07",
    stopOpacity: 0.415
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59310",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint181_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.3505 23.5377) scale(9.36706 9.36411)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2333,
    stopColor: "#AF6C02",
    stopOpacity: 0.7667
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#C47B07",
    stopOpacity: 0.415
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59310",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint182_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.1576 25.6832) scale(5.06279 5.06119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint183_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.3838 24.7303) scale(6.05788 6.05598)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2333,
    stopColor: "#AF6C02",
    stopOpacity: 0.7667
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#C47B07",
    stopOpacity: 0.415
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59310",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint184_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.3977 29.8259) scale(11.7581 11.7544)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2333,
    stopColor: "#AF6C02",
    stopOpacity: 0.7667
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#C47B07",
    stopOpacity: 0.415
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59310",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint185_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.0146 24.9644) scale(4.42136 4.42)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint186_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.1048 17.6774) scale(4.22795 4.22661)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint187_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.6279 23.7279) scale(1.74953 1.74896)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint188_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.9329 20.1647) scale(4.51288 4.51157)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint189_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.417 25.7548) scale(6.32463 6.32269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint190_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.8101 23.9809) scale(2.54142 2.54061)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint191_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.1444 21.5168) scale(4.94122 4.93966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1159,
    stopColor: "#6E3B07",
    stopOpacity: 0.8841
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#7E4D19",
    stopOpacity: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4756,
    stopColor: "#996C38",
    stopOpacity: 0.5244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6926,
    stopColor: "#BF9762",
    stopOpacity: 0.3074
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9256,
    stopColor: "#EECD98",
    stopOpacity: 0.0743866
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0AB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint192_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.4876 18.2702) scale(4.02728 4.026)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1196,
    stopColor: "#AD4C04",
    stopOpacity: 0.8804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#B75E10",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4907,
    stopColor: "#C77D23",
    stopOpacity: 0.5093
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7147,
    stopColor: "#DDA83E",
    stopOpacity: 0.2853
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9552,
    stopColor: "#F8DE5F",
    stopOpacity: 0.0448036
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint193_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.5039 9.51028) scale(9.74016 9.73706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint194_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.5277 11.3664) scale(7.6636 7.66117)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint195_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.5118 8.14383) scale(8.12666 8.12409)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint196_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.124 16.6541) scale(9.13896 9.13607)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint197_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.6012 10.3017) scale(4.17135 4.17004)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1196,
    stopColor: "#AD4C04",
    stopOpacity: 0.8804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#B75E10",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4907,
    stopColor: "#C77D23",
    stopOpacity: 0.5093
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7147,
    stopColor: "#DDA83E",
    stopOpacity: 0.2853
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9552,
    stopColor: "#F8DE5F",
    stopOpacity: 0.0448036
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint198_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.0459 15.0851) scale(15.2927 15.2878)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1196,
    stopColor: "#AD4C04",
    stopOpacity: 0.8804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#B75E10",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4907,
    stopColor: "#C77D23",
    stopOpacity: 0.5093
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7147,
    stopColor: "#DDA83E",
    stopOpacity: 0.2853
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9552,
    stopColor: "#F8DE5F",
    stopOpacity: 0.0448036
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint199_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.8978 14.0766) scale(5.13512 5.13346)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#596087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0665902,
    stopColor: "#545B81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4474,
    stopColor: "#3C4562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#2D3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283249"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint200_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.6977 15.178) scale(9.26241 9.25938)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7781AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2052,
    stopColor: "#646E93",
    stopOpacity: 0.7948
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5293,
    stopColor: "#4C5674",
    stopOpacity: 0.4707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8058,
    stopColor: "#3C4662",
    stopOpacity: 0.1942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37415B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint201_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.9217 14.9544) scale(4.73952 4.73805)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1496,
    stopColor: "#242B3C",
    stopOpacity: 0.8504
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3627,
    stopColor: "#323A4E",
    stopOpacity: 0.6373
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6138,
    stopColor: "#49526D",
    stopOpacity: 0.3862
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8917,
    stopColor: "#697397",
    stopOpacity: 0.1083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7781AA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint202_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.0738 15.1879) scale(2.60106 2.60023)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98B0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2357,
    stopColor: "#94ABDE",
    stopOpacity: 0.7643
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5711,
    stopColor: "#8A9CCC",
    stopOpacity: 0.4289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9647,
    stopColor: "#7983AD",
    stopOpacity: 0.035313
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7781AA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint203_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.0429 12.2602) scale(1.98379 1.98316)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98B0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2357,
    stopColor: "#94ABDE",
    stopOpacity: 0.7643
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5711,
    stopColor: "#8A9CCC",
    stopOpacity: 0.4289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9647,
    stopColor: "#7983AD",
    stopOpacity: 0.035313
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7781AA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint204_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.6 15.691) scale(6.22487 6.22291)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98B0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2357,
    stopColor: "#94ABDE",
    stopOpacity: 0.7643
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5711,
    stopColor: "#8A9CCC",
    stopOpacity: 0.4289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9647,
    stopColor: "#7983AD",
    stopOpacity: 0.035313
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7781AA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint205_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.2596 15.6669) scale(2.12488 2.1242)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000888724,
    stopColor: "#FFD4A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1657,
    stopColor: "#FFD4A2",
    stopOpacity: 0.835
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4004,
    stopColor: "#FFD490",
    stopOpacity: 0.6001
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6769,
    stopColor: "#FFD371",
    stopOpacity: 0.3234
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9831,
    stopColor: "#FFD347",
    stopOpacity: 0.0168727
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint206_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.1865 11.723) scale(3.25488 3.25386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000888724,
    stopColor: "#FFEEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1255,
    stopColor: "#FFEDD7",
    stopOpacity: 0.8753
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFEAC5",
    stopOpacity: 0.6976
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5121,
    stopColor: "#FFE4A6",
    stopOpacity: 0.4883
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#FFDD7B",
    stopOpacity: 0.2547
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    stopColor: "#FFD345",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint207_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.2744 6.21357) scale(8.22856 8.22602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint208_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.9958 9.77046) scale(15.7771 15.7721)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint209_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.2542 6.01507) scale(9.73934 9.73626)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint210_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.6631 5.14161) scale(3.83336 3.83216)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint211_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.6298 6.24515) scale(4.70064 4.69915)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint212_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.6388 5.99681) scale(4.60262 4.60112)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint213_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.6391 5.99709) scale(4.60262 4.60117)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint214_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.5761 8.87476) scale(8.01944 8.15596)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#FDF1AD",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#FDEC9B",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#FEE37C",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#FFD752",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint215_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.9252 6.7024) scale(2.09407 2.09341)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#FDF1AD",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#FDEC9B",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#FEE37C",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#FFD752",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint216_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0557 7.29443) scale(1.92983 1.92922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#FDF1AD",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#FDEC9B",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#FEE37C",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#FFD752",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint217_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.0304 11.5442) scale(5.79222 5.7904)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint218_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.7868 9.63867) scale(4.16015 4.15883)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#FDF1AD",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#FDEC9B",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#FEE37C",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#FFD752",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint219_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.4149 8.54713) scale(1.72034 1.71982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint220_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.407 36.9528) scale(4.02069 4.01941)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E59310"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#D98C0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4883,
    stopColor: "#B7780D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7959,
    stopColor: "#A26B0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B670B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint221_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.6904 34.2128) scale(3.58996 3.5888)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint222_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.2981 32.6617) scale(4.1224 4.12106)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint223_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.5537 32.7688) scale(3.53365 3.53254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint224_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.257 36.3189) scale(2.91815 2.91723)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint225_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.1154 35.9541) scale(2.58691 2.58607)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint226_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.2508 37.1919) scale(2.85036 2.84945)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint227_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.268 38.1062) scale(2.92713 2.92619)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint228_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.268 39.1078) scale(3.11879 3.11777)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint229_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.312 34.9137) scale(6.40738 6.40536)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E59310"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#D98C0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4883,
    stopColor: "#B7780D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7959,
    stopColor: "#A26B0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B670B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint230_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.1509 36.6414) scale(5.71331 5.71149)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint231_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.4813 33.634) scale(2.77355 2.77269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint232_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.3107 31.0672) scale(1.14847 1.14808)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint233_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.1514 34.1647) scale(1.89918 1.89865)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint234_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9708 31.7639) scale(2.08335 2.08272)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint235_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.5306 31.599) scale(6.46475 6.46276)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint236_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.2981 31.2134) scale(4.96619 4.96463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint237_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.1849 33.0029) scale(2.20007 2.19939)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint238_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.5666 31.9808) scale(1.80766 1.80703)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint239_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.0038 33.1444) scale(1.38095 1.38052)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint240_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.5423 32.7739) scale(1.37264 1.3722)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint241_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.6091 31.0006) scale(2.1258 2.1258)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint242_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.4557 33.9185) scale(3.26989 3.26883)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3271,
    stopColor: "#9D5D0E",
    stopOpacity: 0.6729
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7917,
    stopColor: "#AF6F1B",
    stopOpacity: 0.2083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B97A22",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint243_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.2049 35.2456) scale(2.79856 2.79767)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3271,
    stopColor: "#9D5D0E",
    stopOpacity: 0.6729
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7917,
    stopColor: "#AF6F1B",
    stopOpacity: 0.2083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B97A22",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint244_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.4989 36.1959) scale(3.85177 3.85053)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3271,
    stopColor: "#9D5D0E",
    stopOpacity: 0.6729
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7917,
    stopColor: "#AF6F1B",
    stopOpacity: 0.2083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B97A22",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint245_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.0234 32.9823) scale(4.91145 4.90985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#633604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1835,
    stopColor: "#6A3B06",
    stopOpacity: 0.8165
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    stopColor: "#7C4A0D",
    stopOpacity: 0.5552
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7511,
    stopColor: "#9B6217",
    stopOpacity: 0.2489
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B97A22",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint246_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.6091 27.9511) scale(9.29648 9.29358)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint247_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.0291 29.1461) scale(11.1414 11.1379)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint248_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.3857 24.2189) scale(18.7844 18.7784)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint249_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.7874 24.5527) scale(12.951 12.9469)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint250_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.1077 34.0164) scale(2.65661 2.65577)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint251_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.3021 29.072) scale(4.88265 4.88112)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#FDF1AD",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#FDEC9B",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#FEE37C",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#FFD752",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint252_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.604 34.979) scale(0.816551 0.816308)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint253_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.2141 32.0639) scale(7.74625 7.74407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint254_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.5352 32.326) scale(5.98453 5.98264)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint255_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.9822 29.7045) scale(2.79136 2.7905)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint256_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.7866 25.8622) scale(2.73291 2.73203)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1258,
    stopColor: "#FFECD5",
    stopOpacity: 0.8742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#FFE9C3",
    stopOpacity: 0.695
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5161,
    stopColor: "#FFE3A4",
    stopOpacity: 0.4839
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7517,
    stopColor: "#FFDC79",
    stopOpacity: 0.2483
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint257_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.8591 31.0475) scale(3.53491 3.53381)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1258,
    stopColor: "#FFECD5",
    stopOpacity: 0.8742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#FFE9C3",
    stopOpacity: 0.695
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5161,
    stopColor: "#FFE3A4",
    stopOpacity: 0.4839
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7517,
    stopColor: "#FFDC79",
    stopOpacity: 0.2483
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint258_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.5173 33.0477) scale(2.44892 2.44814)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint259_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.2328 33.9249) scale(1.41146 1.41101)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint260_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.2346 33.6068) scale(1.27081 1.27041)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint261_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.8746 33.3207) scale(3.28832 3.28744)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1196,
    stopColor: "#AD4C04",
    stopOpacity: 0.8804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#B75E10",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4907,
    stopColor: "#C77D23",
    stopOpacity: 0.5093
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7147,
    stopColor: "#DDA83E",
    stopOpacity: 0.2853
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9552,
    stopColor: "#F8DE5F",
    stopOpacity: 0.0448036
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint262_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.9934 33.4727) scale(2.57789 2.57705)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3001,
    stopColor: "#DF6506",
    stopOpacity: 0.6999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7261,
    stopColor: "#EB7717",
    stopOpacity: 0.2739
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58726",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint263_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.9128 29.5523) scale(3.00036 2.99941)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint264_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.5119 9.13664) scale(3.07934 3.07841)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#FDF1AD",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#FDEC9B",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#FEE37C",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#FFD752",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint265_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9758 19.5408) rotate(180) scale(24.1396 24.1319)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E59310"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#D98C0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4883,
    stopColor: "#B7780D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7959,
    stopColor: "#A26B0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B670B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint266_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.4283 17.8206) rotate(180) scale(11.632 11.6279)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint267_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.2378 16.8965) rotate(180) scale(5.57858 5.57682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2333,
    stopColor: "#AF6C02",
    stopOpacity: 0.7667
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#C47B07",
    stopOpacity: 0.415
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59310",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint268_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.9759 23.5378) rotate(180) scale(9.36705 9.36411)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2333,
    stopColor: "#AF6C02",
    stopOpacity: 0.7667
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#C47B07",
    stopOpacity: 0.415
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59310",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint269_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.1686 25.6833) rotate(180) scale(5.06279 5.06119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint270_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.9415 24.7305) rotate(180) scale(6.05788 6.05598)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2333,
    stopColor: "#AF6C02",
    stopOpacity: 0.7667
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#C47B07",
    stopOpacity: 0.415
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59310",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint271_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.9283 29.8261) rotate(180) scale(11.7581 11.7544)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2333,
    stopColor: "#AF6C02",
    stopOpacity: 0.7667
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#C47B07",
    stopOpacity: 0.415
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59310",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint272_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3127 24.9646) rotate(180) scale(4.42136 4.41999)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint273_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.2224 17.6775) rotate(180) scale(4.22794 4.22661)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint274_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6987 23.7281) rotate(180) scale(1.74952 1.74896)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint275_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3921 20.1648) rotate(180) scale(4.51288 4.51154)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint276_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.9098 25.7549) rotate(180) scale(6.32463 6.32269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint277_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5169 23.981) rotate(180) scale(2.54141 2.54061)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint278_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.1818 21.5169) rotate(180) scale(4.94122 4.93966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1159,
    stopColor: "#6E3B07",
    stopOpacity: 0.8841
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#7E4D19",
    stopOpacity: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4756,
    stopColor: "#996C38",
    stopOpacity: 0.5244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6926,
    stopColor: "#BF9762",
    stopOpacity: 0.3074
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9256,
    stopColor: "#EECD98",
    stopOpacity: 0.0743866
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0AB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint279_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8398 18.2703) rotate(180) scale(4.02729 4.026)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1196,
    stopColor: "#AD4C04",
    stopOpacity: 0.8804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#B75E10",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4907,
    stopColor: "#C77D23",
    stopOpacity: 0.5093
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7147,
    stopColor: "#DDA83E",
    stopOpacity: 0.2853
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9552,
    stopColor: "#F8DE5F",
    stopOpacity: 0.0448036
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint280_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.8226 9.51028) rotate(180) scale(9.74016 9.73706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint281_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.7985 11.3664) rotate(180) scale(7.6636 7.66118)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint282_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.8138 8.14408) rotate(180) scale(8.12667 8.12409)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1221,
    stopColor: "#FFF8DC",
    stopOpacity: 0.8779
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FFF4CA",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FFECAB",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7297,
    stopColor: "#FFE280",
    stopOpacity: 0.2703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9753,
    stopColor: "#FFD44A",
    stopOpacity: 0.0247312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint283_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.2028 16.6544) rotate(180) scale(9.13896 9.13605)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint284_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.7258 10.3021) rotate(180) scale(4.17135 4.17003)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1196,
    stopColor: "#AD4C04",
    stopOpacity: 0.8804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#B75E10",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4907,
    stopColor: "#C77D23",
    stopOpacity: 0.5093
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7147,
    stopColor: "#DDA83E",
    stopOpacity: 0.2853
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9552,
    stopColor: "#F8DE5F",
    stopOpacity: 0.0448036
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint285_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.2808 15.0851) rotate(180) scale(15.2927 15.2878)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1196,
    stopColor: "#AD4C04",
    stopOpacity: 0.8804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#B75E10",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4907,
    stopColor: "#C77D23",
    stopOpacity: 0.5093
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7147,
    stopColor: "#DDA83E",
    stopOpacity: 0.2853
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9552,
    stopColor: "#F8DE5F",
    stopOpacity: 0.0448036
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint286_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.4281 14.0768) rotate(180) scale(5.13512 5.13346)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#596087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0665902,
    stopColor: "#545B81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4474,
    stopColor: "#3C4562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#2D3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283249"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint287_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.6282 15.1781) rotate(180) scale(9.26241 9.25939)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7781AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2052,
    stopColor: "#646E93",
    stopOpacity: 0.7948
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5293,
    stopColor: "#4C5674",
    stopOpacity: 0.4707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8058,
    stopColor: "#3C4662",
    stopOpacity: 0.1942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37415B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint288_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4049 14.9545) rotate(180) scale(4.73951 4.73805)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1496,
    stopColor: "#242B3C",
    stopOpacity: 0.8504
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3627,
    stopColor: "#323A4E",
    stopOpacity: 0.6373
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6138,
    stopColor: "#49526D",
    stopOpacity: 0.3862
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8917,
    stopColor: "#697397",
    stopOpacity: 0.1083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7781AA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint289_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.2524 15.188) rotate(180) scale(2.60105 2.60022)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98B0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2357,
    stopColor: "#94ABDE",
    stopOpacity: 0.7643
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5711,
    stopColor: "#8A9CCC",
    stopOpacity: 0.4289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9647,
    stopColor: "#7983AD",
    stopOpacity: 0.035313
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7781AA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint290_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.2834 12.2604) rotate(180) scale(1.98379 1.98316)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98B0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2357,
    stopColor: "#94ABDE",
    stopOpacity: 0.7643
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5711,
    stopColor: "#8A9CCC",
    stopOpacity: 0.4289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9647,
    stopColor: "#7983AD",
    stopOpacity: 0.035313
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7781AA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint291_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.7259 15.6912) rotate(180) scale(6.22487 6.22292)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98B0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2357,
    stopColor: "#94ABDE",
    stopOpacity: 0.7643
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5711,
    stopColor: "#8A9CCC",
    stopOpacity: 0.4289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9647,
    stopColor: "#7983AD",
    stopOpacity: 0.035313
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7781AA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint292_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.0666 15.667) rotate(180) scale(2.12488 2.12419)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000888724,
    stopColor: "#FFD4A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1657,
    stopColor: "#FFD4A2",
    stopOpacity: 0.835
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4004,
    stopColor: "#FFD490",
    stopOpacity: 0.6001
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6769,
    stopColor: "#FFD371",
    stopOpacity: 0.3234
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9831,
    stopColor: "#FFD347",
    stopOpacity: 0.0168727
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint293_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.1404 11.7232) rotate(180) scale(3.25488 3.25386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000888724,
    stopColor: "#FFEEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1255,
    stopColor: "#FFEDD7",
    stopOpacity: 0.8753
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFEAC5",
    stopOpacity: 0.6976
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5121,
    stopColor: "#FFE4A6",
    stopOpacity: 0.4883
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7455,
    stopColor: "#FFDD7B",
    stopOpacity: 0.2547
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    stopColor: "#FFD345",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint294_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.0527 6.21369) rotate(180) scale(8.22854 8.22602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint295_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.3308 9.77059) rotate(180) scale(15.7771 15.7721)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint296_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.072 6.01532) rotate(180) scale(9.73935 9.73626)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint297_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.6635 5.14173) rotate(180) scale(3.83336 3.83216)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint298_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.6967 6.24527) rotate(180) scale(4.70064 4.69916)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint299_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.687 5.99693) rotate(180) scale(4.60264 4.60112)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint300_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.6877 5.99721) rotate(180) scale(4.60262 4.60117)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint301_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.7821 8.87487) rotate(180) scale(8.01944 8.15596)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#FDF1AD",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#FDEC9B",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#FEE37C",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#FFD752",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint302_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.4012 6.70252) rotate(180) scale(2.09407 2.09341)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#FDF1AD",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#FDEC9B",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#FEE37C",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#FFD752",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint303_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.2705 7.29455) rotate(180) scale(1.92983 1.92922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#FDF1AD",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#FDEC9B",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#FEE37C",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#FFD752",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint304_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.2959 11.5442) rotate(180) scale(5.79219 5.7904)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint305_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.5399 9.63879) rotate(180) scale(4.16015 4.15883)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#FDF1AD",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#FDEC9B",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#FEE37C",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#FFD752",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint306_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.9115 8.54725) rotate(180) scale(1.72034 1.71983)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint307_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.9192 36.9529) rotate(180) scale(4.02069 4.01941)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E59310"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#D98C0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4883,
    stopColor: "#B7780D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7959,
    stopColor: "#A26B0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B670B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint308_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.6358 34.213) rotate(180) scale(3.58996 3.58879)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint309_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0281 32.662) rotate(180) scale(4.1224 4.12108)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint310_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.7727 32.7689) rotate(180) scale(3.53365 3.53252)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint311_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.0689 36.319) rotate(180) scale(2.91815 2.91725)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint312_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.2102 35.9543) rotate(180) scale(2.58691 2.58609)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint313_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.0756 37.1921) rotate(180) scale(2.85036 2.84945)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint314_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.0582 38.1064) rotate(180) scale(2.92713 2.92618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint315_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.0582 39.1081) rotate(180) scale(3.11878 3.11776)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint316_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.0135 34.9141) rotate(180) scale(6.40737 6.40536)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E59310"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#D98C0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4883,
    stopColor: "#B7780D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7959,
    stopColor: "#A26B0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B670B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint317_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.1738 36.6417) rotate(180) scale(5.71331 5.71149)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint318_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.8439 33.6344) rotate(180) scale(2.77355 2.77271)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint319_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.0151 31.0675) rotate(180) scale(1.14847 1.14807)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint320_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.1745 34.1649) rotate(180) scale(1.89918 1.89865)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint321_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.356 31.7643) rotate(180) scale(2.08335 2.08272)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint322_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.7958 31.5992) rotate(180) scale(6.46477 6.46276)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint323_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.0289 31.2137) rotate(180) scale(4.96622 4.96465)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint324_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.1417 33.0031) rotate(180) scale(2.20007 2.19939)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint325_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.7599 31.9811) rotate(180) scale(1.80765 1.80703)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint326_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.3223 33.1446) rotate(180) scale(1.38095 1.38052)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint327_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.7845 32.7742) rotate(180) scale(1.37264 1.37217)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint328_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.7172 31.0009) rotate(180) scale(2.1258 2.1258)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint329_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.8704 33.9187) rotate(180) scale(3.2699 3.26881)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3271,
    stopColor: "#9D5D0E",
    stopOpacity: 0.6729
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7917,
    stopColor: "#AF6F1B",
    stopOpacity: 0.2083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B97A22",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint330_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.1214 35.246) rotate(180) scale(2.79857 2.79768)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3271,
    stopColor: "#9D5D0E",
    stopOpacity: 0.6729
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7917,
    stopColor: "#AF6F1B",
    stopOpacity: 0.2083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B97A22",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint331_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.8273 36.1961) rotate(180) scale(3.85177 3.85053)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3271,
    stopColor: "#9D5D0E",
    stopOpacity: 0.6729
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7917,
    stopColor: "#AF6F1B",
    stopOpacity: 0.2083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B97A22",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint332_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3019 32.9825) rotate(180) scale(4.91145 4.90986)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#633604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1835,
    stopColor: "#6A3B06",
    stopOpacity: 0.8165
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    stopColor: "#7C4A0D",
    stopOpacity: 0.5552
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7511,
    stopColor: "#9B6217",
    stopOpacity: 0.2489
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B97A22",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint333_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.7171 27.9513) rotate(180) scale(9.29682 9.29392)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint334_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.2971 29.1462) rotate(180) scale(11.1414 11.1379)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint335_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.94 24.2191) rotate(180) scale(18.7844 18.7784)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint336_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.5387 24.5529) rotate(180) scale(12.951 12.9469)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint337_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.2197 34.0165) rotate(180) scale(2.65661 2.65578)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint338_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.024 29.0721) rotate(180) scale(4.88285 4.8813)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#FDF1AD",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#FDEC9B",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#FEE37C",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#FFD752",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint339_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.7234 34.9792) rotate(180) scale(0.816554 0.816308)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint340_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.1123 32.0641) rotate(180) scale(7.74625 7.74407)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint341_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.7907 32.3263) rotate(180) scale(5.98453 5.98264)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint342_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3443 29.7046) rotate(180) scale(2.79136 2.79049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint343_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.5401 25.8624) rotate(180) scale(2.73291 2.73203)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1258,
    stopColor: "#FFECD5",
    stopOpacity: 0.8742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#FFE9C3",
    stopOpacity: 0.695
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5161,
    stopColor: "#FFE3A4",
    stopOpacity: 0.4839
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7517,
    stopColor: "#FFDC79",
    stopOpacity: 0.2483
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint344_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.4665 31.0476) rotate(180) scale(3.53438 3.53328)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1258,
    stopColor: "#FFECD5",
    stopOpacity: 0.8742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#FFE9C3",
    stopOpacity: 0.695
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5161,
    stopColor: "#FFE3A4",
    stopOpacity: 0.4839
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7517,
    stopColor: "#FFDC79",
    stopOpacity: 0.2483
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint345_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.8089 33.0478) rotate(180) scale(2.44892 2.44814)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint346_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.094 33.925) rotate(180) scale(1.41146 1.41101)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint347_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.0913 33.607) rotate(180) scale(1.2708 1.27038)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint348_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.4515 33.3208) rotate(180) scale(3.28832 3.2874)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1196,
    stopColor: "#AD4C04",
    stopOpacity: 0.8804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#B75E10",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4907,
    stopColor: "#C77D23",
    stopOpacity: 0.5093
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7147,
    stopColor: "#DDA83E",
    stopOpacity: 0.2853
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9552,
    stopColor: "#F8DE5F",
    stopOpacity: 0.0448036
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint349_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.333 33.4729) rotate(180) scale(2.57789 2.57703)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3001,
    stopColor: "#DF6506",
    stopOpacity: 0.6999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7261,
    stopColor: "#EB7717",
    stopOpacity: 0.2739
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58726",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint350_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.4139 29.5524) rotate(180) scale(3.00036 2.99939)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#FFCC6F",
    stopOpacity: 0.7954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4959,
    stopColor: "#FFC65D",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8375,
    stopColor: "#FFBC3E",
    stopOpacity: 0.1625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint351_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.8143 9.13676) rotate(180) scale(3.07935 3.07841)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#FDF1AD",
    stopOpacity: 0.846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3734,
    stopColor: "#FDEC9B",
    stopOpacity: 0.6266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#FEE37C",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9179,
    stopColor: "#FFD752",
    stopOpacity: 0.0820628
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD344",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint352_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0908 20.5641) rotate(179.502) scale(23.1612 12.6561)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E59E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4068,
    stopColor: "#FFD878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5816,
    stopColor: "#FFCC53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7443,
    stopColor: "#FFC238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8887,
    stopColor: "#FFBD28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB22"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint353_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0408 20.3666) scale(21.4032 21.3964)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB03E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    stopColor: "#FFB140",
    stopOpacity: 0.4015
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2911,
    stopColor: "#FFB447",
    stopOpacity: 0.5461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#FFB952",
    stopOpacity: 0.6492
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3905,
    stopColor: "#FFC063",
    stopOpacity: 0.7325
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4285,
    stopColor: "#FFC979",
    stopOpacity: 0.8039
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4622,
    stopColor: "#FFD495",
    stopOpacity: 0.8672
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4927,
    stopColor: "#FFE2B5",
    stopOpacity: 0.9244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5198,
    stopColor: "#FFF1D9",
    stopOpacity: 0.9752
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#FFFAEE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint354_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.7594 32.6979) scale(16.9074 16.902)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF8E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    stopColor: "#F19407",
    stopOpacity: 0.7179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6827,
    stopColor: "#F8A519",
    stopOpacity: 0.3173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB62D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint355_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.9432 9.8906) scale(7.77005 7.76751)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1993,
    stopColor: "#FFF9E7",
    stopOpacity: 0.8007
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4829,
    stopColor: "#FFF1D5",
    stopOpacity: 0.5171
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8154,
    stopColor: "#FFE4B6",
    stopOpacity: 0.1846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDCA2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint356_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.0224 17.1334) scale(19.7652 19.759)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1993,
    stopColor: "#FFF9E7",
    stopOpacity: 0.8007
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4829,
    stopColor: "#FFF1D5",
    stopOpacity: 0.5171
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8154,
    stopColor: "#FFE4B6",
    stopOpacity: 0.1846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDCA2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint357_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.6805 15.9416) scale(26.0247 26.0164)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1993,
    stopColor: "#FFF9E7",
    stopOpacity: 0.8007
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4829,
    stopColor: "#FFF1D5",
    stopOpacity: 0.5171
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8154,
    stopColor: "#FFE4B6",
    stopOpacity: 0.1846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDCA2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint358_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9434 19.3867) scale(13.5793 13.575)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1993,
    stopColor: "#FFF9E7",
    stopOpacity: 0.8007
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4829,
    stopColor: "#FFF1D5",
    stopOpacity: 0.5171
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8154,
    stopColor: "#FFE4B6",
    stopOpacity: 0.1846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDCA2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint359_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.9003 15.6781) scale(14.275 14.2705)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1993,
    stopColor: "#FFF9E7",
    stopOpacity: 0.8007
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4829,
    stopColor: "#FFF1D5",
    stopOpacity: 0.5171
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8154,
    stopColor: "#FFE4B6",
    stopOpacity: 0.1846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDCA2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint360_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0557 32.0074) scale(18.6971 18.6912)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1993,
    stopColor: "#FFF9E7",
    stopOpacity: 0.8007
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4829,
    stopColor: "#FFF1D5",
    stopOpacity: 0.5171
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8154,
    stopColor: "#FFE4B6",
    stopOpacity: 0.1846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDCA2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint361_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.4809 20.2826) rotate(23.5615) scale(18.6183 18.6143)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDCA2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#FFCE85",
    stopOpacity: 0.243
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5517,
    stopColor: "#FFBF66",
    stopOpacity: 0.5517
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#FFB554",
    stopOpacity: 0.8151
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB24D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint362_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1739 20.3418) scale(10.4861 10.4828)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00222094,
    stopColor: "#0A4587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003666"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint363_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1739 20.3418) scale(10.4861 10.4828)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00222094,
    stopColor: "#0A4587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003666"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint364_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.9715 26.9156) scale(13.0212 13.0171)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1993,
    stopColor: "#FFF9E7",
    stopOpacity: 0.8007
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4829,
    stopColor: "#FFF1D5",
    stopOpacity: 0.5171
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8154,
    stopColor: "#FFE4B6",
    stopOpacity: 0.1846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDCA2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint365_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0829 10.9406) scale(8.94008 8.93727)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B4A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1163,
    stopColor: "#715007",
    stopOpacity: 0.8837
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    stopColor: "#816019",
    stopOpacity: 0.7179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4774,
    stopColor: "#9C7B38",
    stopOpacity: 0.5226
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6953,
    stopColor: "#C1A163",
    stopOpacity: 0.3047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9292,
    stopColor: "#F0D099",
    stopOpacity: 0.070795
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0AB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint366_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.7234 13.7563) scale(18.7616 18.7556)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint367_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3673 20.5879) scale(8.25074 8.24811)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF9FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint368_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.5122 12.0632) scale(12.1499 12.146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B8FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint369_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.1063 17.5909) scale(12.3703 12.3664)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B8FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint370_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.1158 12.8824) scale(11.9739 11.9701)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B8FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint371_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.6999 21.5328) scale(13.9165 13.9121)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint372_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.6619 14.0425) scale(10.3725 10.3692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint373_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.6956 20.2538) scale(12.366 12.3621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint374_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.1707 14.5197) scale(20.6383 20.6318)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint375_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.6015 31.0685) scale(21.7131 21.7063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCF8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint376_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.9321 9.21522) scale(10.6695 10.6661)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEF9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint377_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.7336 28.6624) scale(16.8782 16.8728)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint378_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1962 14.4404) scale(14.9916 14.9868)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint379_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1317 26.1994) rotate(180) scale(14.9916 14.9868)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint380_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.0458 20.3526) rotate(90) scale(14.9868 14.9916)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint381_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.2823 20.2881) rotate(-90) scale(14.9868 14.9916)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint382_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.3205 24.4882) rotate(135.009) scale(14.9885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint383_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.0277 16.1467) rotate(-44.9908) scale(14.9885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint384_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.3461 16.1723) rotate(44.9908) scale(14.9885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint385_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.0021 24.4627) rotate(-135.009) scale(14.9885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint386_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.4732 45.8842) rotate(19.0349) scale(9.49128 5.86898)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E59310"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#D98C0F",
    stopOpacity: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4883,
    stopColor: "#B7780D",
    stopOpacity: 0.5117
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7959,
    stopColor: "#A26B0C",
    stopOpacity: 0.2041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B670B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint387_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.7358 55.4128) scale(25.8015 25.7933)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E59310"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2975,
    stopColor: "#BA710A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5992,
    stopColor: "#965404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8442,
    stopColor: "#7F4201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773B00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint388_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5523 47.2518) scale(9.14034 9.13743)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#513200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    stopColor: "#583600",
    stopOpacity: 0.7743
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5659,
    stopColor: "#6D3F01",
    stopOpacity: 0.4341
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9765,
    stopColor: "#8F4F02",
    stopOpacity: 0.0234645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#915002",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint389_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0755 38.9714) scale(15.1579 15.1531)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA015"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2837,
    stopColor: "#D98A11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5847,
    stopColor: "#B7770E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8344,
    stopColor: "#A26B0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B670B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint390_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.3754 35.1603) scale(10.9088 10.9053)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD5B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2256,
    stopColor: "#FAD2AF",
    stopOpacity: 0.7744
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5468,
    stopColor: "#F3CB9D",
    stopOpacity: 0.4532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9236,
    stopColor: "#E8BF7E",
    stopOpacity: 0.0763797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint391_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.6268 33.2317) scale(6.34137 6.33934)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint392_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.4154 36.7889) scale(9.25291 9.24999)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD5B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2256,
    stopColor: "#FAD2AF",
    stopOpacity: 0.7744
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5468,
    stopColor: "#F3CB9D",
    stopOpacity: 0.4532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9236,
    stopColor: "#E8BF7E",
    stopOpacity: 0.0763797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint393_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.4502 35.0277) scale(3.68893 3.68776)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD5B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2256,
    stopColor: "#FAD2AF",
    stopOpacity: 0.7744
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5468,
    stopColor: "#F3CB9D",
    stopOpacity: 0.4532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9236,
    stopColor: "#E8BF7E",
    stopOpacity: 0.0763797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint394_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0128 38.735) scale(5.11632 5.1147)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD5B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2256,
    stopColor: "#FAD2AF",
    stopOpacity: 0.7744
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5468,
    stopColor: "#F3CB9D",
    stopOpacity: 0.4532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9236,
    stopColor: "#E8BF7E",
    stopOpacity: 0.0763797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint395_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.3609 41.537) scale(10.2006 10.1974)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD5B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2256,
    stopColor: "#FAD2AF",
    stopOpacity: 0.7744
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5468,
    stopColor: "#F3CB9D",
    stopOpacity: 0.4532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9236,
    stopColor: "#E8BF7E",
    stopOpacity: 0.0763797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint396_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.9491 35.1603) rotate(180) scale(10.9088 10.9053)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD5B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2256,
    stopColor: "#FAD2AF",
    stopOpacity: 0.7744
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5468,
    stopColor: "#F3CB9D",
    stopOpacity: 0.4532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9236,
    stopColor: "#E8BF7E",
    stopOpacity: 0.0763797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint397_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3859 36.8072) rotate(180) scale(9.13254 9.12965)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#683400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1472,
    stopColor: "#6F3902",
    stopOpacity: 0.8528
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    stopColor: "#814607",
    stopOpacity: 0.6433
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6036,
    stopColor: "#A05B0F",
    stopOpacity: 0.3964
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8769,
    stopColor: "#CA781B",
    stopOpacity: 0.1231
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08721",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint398_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.698 33.2317) rotate(180) scale(6.34137 6.33934)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1598,
    stopColor: "#60402A",
    stopOpacity: 0.8402
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3872,
    stopColor: "#724F30",
    stopOpacity: 0.6128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6552,
    stopColor: "#91673A",
    stopOpacity: 0.3448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#BB8848",
    stopOpacity: 0.0479711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C38E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint399_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.8742 35.0277) rotate(180) scale(3.68893 3.68776)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD5B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2256,
    stopColor: "#FAD2AF",
    stopOpacity: 0.7744
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5468,
    stopColor: "#F3CB9D",
    stopOpacity: 0.4532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9236,
    stopColor: "#E8BF7E",
    stopOpacity: 0.0763797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint400_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.5666 39.0109) scale(4.52938 4.52795)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD5B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2256,
    stopColor: "#FAD2AF",
    stopOpacity: 0.7744
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5468,
    stopColor: "#F3CB9D",
    stopOpacity: 0.4532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9236,
    stopColor: "#E8BF7E",
    stopOpacity: 0.0763797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint401_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.9469 41.537) rotate(180) scale(10.2006 10.1974)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD5B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2256,
    stopColor: "#FAD2AF",
    stopOpacity: 0.7744
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5468,
    stopColor: "#F3CB9D",
    stopOpacity: 0.4532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9236,
    stopColor: "#E8BF7E",
    stopOpacity: 0.0763797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint402_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.7688 35.7661) rotate(180) scale(4.78856 4.78089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#0FC5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABFBFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint403_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.9498 38.4464) rotate(180) scale(2.45419 2.45026)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint404_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.5585 35.929) rotate(180) scale(2.39428 2.39045)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint405_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.295 37.0096) rotate(180) scale(3.22885 3.22368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint406_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.2252 38.9319) rotate(180) scale(1.94516 1.94205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint407_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.3209 36.8099) rotate(180) scale(2.23169 2.22811)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AEBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint408_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.5304 36.9307) rotate(180) scale(3.337 3.33165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint409_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.4189 40.219) rotate(180) scale(3.41553 3.41005)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FF4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint410_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.0721 35.9062) rotate(180) scale(2.05425 2.05096)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint411_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.7377 37.0868) rotate(180) scale(4.64166 4.63423)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#A1F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561659,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint412_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.7465 35.926) rotate(180) scale(3.01921 3.01438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint413_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.7457 39.3139) rotate(180) scale(2.67598 2.67169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint414_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.7457 39.3139) rotate(180) scale(2.67598 2.67169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint415_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.0004 36.9786) rotate(180) scale(2.12505 2.12165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint416_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.8029 38.537) rotate(180) scale(1.84823 1.84527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint417_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.8948 37.7141) rotate(-90) scale(1.84527 1.84823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint418_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.6443 37.6305) rotate(90) scale(1.84527 1.84824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint419_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.7192 36.8069) scale(1.84823 1.84528)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint420_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.4416 38.16) rotate(180) scale(4.78856 4.78089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#0FC5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABFBFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint421_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.6227 40.8403) rotate(180) scale(2.45419 2.45026)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint422_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.2314 38.323) rotate(180) scale(2.39428 2.39045)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint423_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9679 39.4035) rotate(180) scale(3.22885 3.22368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint424_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.8981 41.3258) rotate(180) scale(1.94516 1.94205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint425_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.9938 39.2038) rotate(180) scale(2.23169 2.22811)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AEBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint426_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.2032 39.3246) rotate(180) scale(3.337 3.33165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint427_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0917 42.6129) rotate(180) scale(3.41553 3.41005)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FF4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint428_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.7449 38.3001) rotate(180) scale(2.05425 2.05096)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint429_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.4106 39.4807) rotate(180) scale(4.64166 4.63423)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#A1F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561659,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint430_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.4194 38.3199) rotate(180) scale(3.01921 3.01438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint431_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.4186 41.7078) rotate(180) scale(2.67598 2.67169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint432_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.4186 41.7078) rotate(180) scale(2.67598 2.67169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint433_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.6732 39.3725) rotate(180) scale(2.12505 2.12165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint434_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.4758 40.931) rotate(180) scale(1.84823 1.84527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint435_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.5676 40.108) rotate(-90) scale(1.84527 1.84823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint436_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.3172 40.0244) rotate(90) scale(1.84527 1.84824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint437_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.392 39.2009) scale(1.84823 1.84528)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint438_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1155 39.9645) rotate(180) scale(4.78856 4.78089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#0FC5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABFBFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint439_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.2965 42.6448) rotate(180) scale(2.45419 2.45026)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint440_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9052 40.1274) rotate(180) scale(2.39428 2.39045)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint441_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.6417 41.208) rotate(180) scale(3.22885 3.22368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint442_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.5719 43.1302) rotate(180) scale(1.94516 1.94205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint443_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.6676 41.0083) rotate(180) scale(2.23169 2.22811)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AEBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint444_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.877 41.129) rotate(180) scale(3.337 3.33165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint445_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.7655 44.4174) rotate(180) scale(3.41553 3.41005)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FF4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint446_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.4188 40.1046) rotate(180) scale(2.05425 2.05096)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint447_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0844 41.2852) rotate(180) scale(4.64166 4.63423)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#A1F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561659,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint448_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0932 40.1244) rotate(180) scale(3.01921 3.01438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint449_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0924 43.5123) rotate(180) scale(2.67598 2.67169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint450_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0924 43.5123) rotate(180) scale(2.67598 2.67169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint451_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.347 41.177) rotate(180) scale(2.12505 2.12165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint452_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1496 42.7354) rotate(180) scale(1.84823 1.84527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint453_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.2415 41.9125) rotate(-90) scale(1.84527 1.84823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint454_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.991 41.8288) rotate(90) scale(1.84527 1.84824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint455_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0658 41.0053) scale(1.84823 1.84528)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint456_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.7883 38.1921) rotate(180) scale(4.78856 4.78089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#0FC5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABFBFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint457_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.9694 40.8724) rotate(180) scale(2.45419 2.45026)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint458_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.5781 38.3551) rotate(180) scale(2.39428 2.39045)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint459_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.3145 39.4356) rotate(180) scale(3.22885 3.22368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint460_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.2447 41.3579) rotate(180) scale(1.94516 1.94205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint461_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.3405 39.2359) rotate(180) scale(2.23169 2.22811)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AEBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint462_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.5499 39.3567) rotate(180) scale(3.337 3.33165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint463_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.4384 42.645) rotate(180) scale(3.41553 3.41005)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FF4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint464_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.0916 38.3322) rotate(180) scale(2.05425 2.05096)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint465_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.7573 39.5129) rotate(180) scale(4.64166 4.63423)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#A1F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561659,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint466_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.7661 38.352) rotate(180) scale(3.01921 3.01438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint467_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.7653 41.7399) rotate(180) scale(2.67598 2.67169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint468_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.7653 41.7399) rotate(180) scale(2.67598 2.67169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint469_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.0199 39.4046) rotate(180) scale(2.12505 2.12165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint470_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.8225 40.9631) rotate(180) scale(1.84823 1.84527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint471_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.9143 40.1401) rotate(-90) scale(1.84527 1.84823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint472_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.6639 40.0565) rotate(90) scale(1.84527 1.84824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint473_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.7387 39.233) scale(1.84823 1.84528)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint474_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4231 35.7661) rotate(180) scale(4.78856 4.78089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#0FC5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABFBFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint475_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.6041 38.4464) rotate(180) scale(2.45419 2.45026)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint476_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.2128 35.929) rotate(180) scale(2.39428 2.39045)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint477_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.9493 37.0096) rotate(180) scale(3.22885 3.22368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint478_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.8795 38.9319) rotate(180) scale(1.94516 1.94205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint479_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.9752 36.8099) rotate(180) scale(2.23169 2.22811)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AEBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint480_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.1847 36.9307) rotate(180) scale(3.337 3.33165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint481_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.0732 40.219) rotate(180) scale(3.41553 3.41005)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FF4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint482_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.7264 35.9062) rotate(180) scale(2.05425 2.05096)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint483_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.392 37.0868) rotate(180) scale(4.64166 4.63423)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#A1F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561659,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint484_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4008 35.926) rotate(180) scale(3.01921 3.01438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint485_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4 39.3139) rotate(180) scale(2.67598 2.67169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint486_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4 39.3139) rotate(180) scale(2.67598 2.67169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint487_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6547 36.9786) rotate(180) scale(2.12505 2.12165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint488_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4572 38.537) rotate(180) scale(1.84823 1.84527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint489_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.5491 37.7141) rotate(-90) scale(1.84527 1.84823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint490_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.2986 37.6305) rotate(90) scale(1.84527 1.84824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint491_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3735 36.8069) scale(1.84823 1.84528)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78F9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint492_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1988 44.6524) scale(2.98358 2.98264)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD5B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2256,
    stopColor: "#FAD2AF",
    stopOpacity: 0.7744
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5468,
    stopColor: "#F3CB9D",
    stopOpacity: 0.4532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9236,
    stopColor: "#E8BF7E",
    stopOpacity: 0.0763797
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5BC77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint493_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.163 37.1096) scale(2.91556 2.91462)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1196,
    stopColor: "#AD4C04",
    stopOpacity: 0.8804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#B75E10",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4907,
    stopColor: "#C77D23",
    stopOpacity: 0.5093
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7147,
    stopColor: "#DDA83E",
    stopOpacity: 0.2853
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9552,
    stopColor: "#F8DE5F",
    stopOpacity: 0.0448036
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint494_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.5219 37.4104) scale(3.14231 3.14133)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint495_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1534 37.6126) scale(3.97746 3.97624)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint496_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.2208 37.9466) scale(1.60042 1.59993)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2409,
    stopColor: "#B14B03",
    stopOpacity: 0.7589
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5837,
    stopColor: "#C35D0B",
    stopOpacity: 0.4157
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9859,
    stopColor: "#E27B18",
    stopOpacity: 0.0129869
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#E37C18",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint497_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1763 37.7503) scale(0.552905 0.55273)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDCC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1153,
    stopColor: "#FED8BE",
    stopOpacity: 0.8846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    stopColor: "#FBCEAC",
    stopOpacity: 0.7201
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4732,
    stopColor: "#F6BD8D",
    stopOpacity: 0.5263
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6892,
    stopColor: "#EFA562",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    stopColor: "#E6872C",
    stopOpacity: 0.0778498
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#E37C18",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint498_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1415 33.6351) scale(3.1692 3.16821)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0920384,
    stopColor: "#FDD073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3847,
    stopColor: "#F6AD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6442,
    stopColor: "#F19322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    stopColor: "#EE840D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7E06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint499_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0921 35.1231) scale(2.88779 2.88681)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1335,
    stopColor: "#DD6505",
    stopOpacity: 0.8665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3236,
    stopColor: "#E17713",
    stopOpacity: 0.6764
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5476,
    stopColor: "#E99629",
    stopOpacity: 0.4524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#F4C048",
    stopOpacity: 0.2047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint500_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1455 35.4049) scale(2.33209 2.33135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1196,
    stopColor: "#AD4C04",
    stopOpacity: 0.8804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#B75E10",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4907,
    stopColor: "#C77D23",
    stopOpacity: 0.5093
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7147,
    stopColor: "#DDA83E",
    stopOpacity: 0.2853
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9552,
    stopColor: "#F8DE5F",
    stopOpacity: 0.0448036
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE966",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint501_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.8892 35.0606) scale(2.50412 2.50326)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2409,
    stopColor: "#B14B03",
    stopOpacity: 0.7589
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5837,
    stopColor: "#C35D0B",
    stopOpacity: 0.4157
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9859,
    stopColor: "#E27B18",
    stopOpacity: 0.0129869
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#E37C18",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint502_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1614 35.3869) scale(0.884184 0.883882)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDCC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1153,
    stopColor: "#FED8BE",
    stopOpacity: 0.8846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    stopColor: "#FBCEAC",
    stopOpacity: 0.7201
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4732,
    stopColor: "#F6BD8D",
    stopOpacity: 0.5263
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6892,
    stopColor: "#EFA562",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    stopColor: "#E6872C",
    stopOpacity: 0.0778498
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    stopColor: "#E37C18",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint503_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3006 6.3659) scale(3.42373 3.42263)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint504_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.7018 32.9115) scale(3.76772 3.76652)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint505_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.7356 32.9115) scale(3.76771 3.76652)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint506_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.564 18.486) scale(12.0856 12.0856)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint507_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.1317 21.0621) scale(14.2553 14.2553)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#E5F8FF",
    stopOpacity: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2324,
    stopColor: "#D6F6FF",
    stopOpacity: 0.7676
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3783,
    stopColor: "#BBF2FF",
    stopOpacity: 0.6217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5355,
    stopColor: "#97EDFF",
    stopOpacity: 0.4645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7018,
    stopColor: "#67E7FF",
    stopOpacity: 0.2982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#2FDFFF",
    stopOpacity: 0.127
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint508_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.5409 20.5201) scale(5.86404 5.86405)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5339,
    stopColor: "#0C478E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint509_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.4475 19.8975) scale(9.05909 9.05897)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1402,
    stopColor: "#003346",
    stopOpacity: 0.8598
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2859,
    stopColor: "#003E53",
    stopOpacity: 0.7141
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4341,
    stopColor: "#005067",
    stopOpacity: 0.5659
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5841,
    stopColor: "#006B85",
    stopOpacity: 0.4159
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7355,
    stopColor: "#008CAA",
    stopOpacity: 0.2645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8858,
    stopColor: "#00B5D7",
    stopOpacity: 0.1142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint510_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.9725 17.7411) scale(6.22189 6.22187)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint511_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.7818 17.5238) scale(13.2342 13.2345)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint512_radial_578_447528",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.3266 20.1941) scale(7.85411 7.85409)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpic);
export default __webpack_public_path__ + "static/media/epic.e250a0a97e58697cb7c36946e3a254b3.svg";
export { ForwardRef as ReactComponent };